export default {
  upgrade: {
    title: 'Nâng cấp',
    heroTitle: 'Trí Tuệ Mở Rộng – Học Tập Dễ Dàng – Kết Quả Vượt Trội',
    supportedLabel: 'Hỗ trợ',
    monthly: 'Tháng',
    yearly: 'Năm',
    perMonth: '/tháng',
    freeButton: 'miễn phí',
    upgradeButton: 'Nâng cấp',
    savingsBasic: 'Tiết kiệm 1.000.000 VNĐ với gói năm',
    savingsAdvanced: 'Tiết kiệm 15.000.000 VNĐ với gói năm',
    models: {
      gpt: 'GPT-5.2',
      deepseek: 'DeepSeek V3.2',
      grok: 'Grok 4.1',
      claude: 'Claude 3.7 Sonet',
      gemini: 'Gemini 3 Pro',
    },
    plans: {
      free: {
        name: 'miễn phí',
        basicCredits: '20 credit cơ bản/ngày',
        basicModels: ['GPT-5 mini', 'Grok 4.1', 'DeepSeek V3.2', 'Gemini 3 Flash'],
        highlightsTitle: 'Hỏi đáp cùng AI với các mô hình',
        highlights: [
          'Dùng thử giới hạn chức năng tạo hình ảnh bằng AI',
          'Tạo bài học cho học sinh bằng AI',
          'Tải lên tài liệu tối đa 100MB',
        ],
      },
      basic: {
        name: 'Cơ bản',
        basicCredits: '2000 credit cơ bản/tháng',
        advancedCredits: '500 credit nâng cao/tháng',
        basicModels: ['GPT-5 mini', 'Grok 4.1', 'DeepSeek V3.2', 'Gemini 3 Flash'],
        advancedModels: ['GPT-5.2', 'Grok 4.1', 'DeepSeek v3.2', 'Gemini 3 Pro', 'Claude 3.7 Sonet'],
        highlightsTitle: 'Mở khóa các tính năng:',
        highlights: [
          'Tạo ảnh nâng cao',
          'Tạo slide',
          'Sáng tạo nội dung',
          'Phân tích dữ liệu',
          'Tạo bài học không giới hạn',
          'Tải lên tài liệu tối đa 15GB',
        ],
      },
      advanced: {
        name: 'Nâng cao',
        basicCredits: '9000 credit cơ bản/tháng',
        advancedCredits: '2000 credit nâng cao/tháng',
        basicModels: ['GPT-5 mini', 'Grok 4.1', 'DeepSeek V3.2', 'Gemini 3 Flash'],
        advancedModels: ['GPT-5.2', 'Grok 4.1', 'DeepSeek v3.2', 'Gemini 3 Pro', 'Claude 3.7 Sonet'],
        highlightsTitle: 'Mở khóa các tính năng:',
        highlights: [
          'Tạo ảnh nâng cao',
          'Tạo slide',
          'Sáng tạo nội dung',
          'Phân tích dữ liệu',
          'Tạo bài học không giới hạn',
          'Tải lên tài liệu không giới hạn',
        ],
      },
    },
  },
  documentDetail: {
    pptx: {
      notSupportedTitle: 'PPTX chưa hỗ trợ xem trước trực tiếp trong trình duyệt.',
      notSupportedDescription: 'Vui lòng tải về hoặc mở bằng Microsoft PowerPoint.',
    },
    xmind: {
      notSupportedTitle: 'XMind chưa hỗ trợ xem trước trực tiếp trong trình duyệt.',
      notSupportedDescription: 'Vui lòng tải về hoặc mở bằng ứng dụng XMind.',
    },
    download: {
      notFound: 'Không tìm thấy file để tải về',
    },
    docx: {
      previewError: 'Lỗi khi xem trước file docx.',
    },
  },
  common: {
    upload: 'Tải lên',
    add: 'Thêm mới',
    addFile: 'Thêm file',
    addChild: 'Thêm con',
    addToFolder: 'Thêm vào thư mục',
    addSuccess: 'Thêm thành công',
    edit: 'Sửa',
    editSuccess: 'Sửa thành công',
    error: 'Lỗi',
    retry: 'Thử lại',
    delete: 'Xóa',
    remove: 'Gỡ bỏ',
    deleteSuccess: 'Xóa thành công',
    confirmDelete: 'Bạn có chắc chắn xóa bản ghi này không?',
    save: 'Lưu',
    saveSuccess: 'Lưu thành công',
    reset: 'Đặt lại',
    action: 'Hành động',
    export: 'Xuất',
    exportSuccess: 'Xuất thành công',
    import: 'Nhập',
    importSuccess: 'Nhập thành công',
    search: 'Tìm kiếm',
    searching: 'Đang tìm kiếm...',
    clear: 'Dọn dẹp',
    clearSuccess: 'Dọn dẹp thành công',
    yes: 'Có',
    no: 'Không',
    confirm: 'Xác nhận',
    download: 'Tải xuống',
    noData: 'Không có dữ liệu',
    wrong: 'Đã xảy ra lỗi, vui lòng thử lại sau.',
    success: 'Thành công',
    failed: 'Thất bại',
    verify: 'Xác minh',
    unauthorizedTips: 'Không được ủy quyền, vui lòng xác minh trước.',
    cancel: 'Hủy',
    rename: 'Đổi tên',
    pin: 'Ghim',
    unpin: 'Bỏ ghim',
    configuration: 'Thiết lập ',
    view: 'Xem',
    pull: 'Thêm agent',
    next: 'Tiếp',
    previous: 'Trước',
    viewAll: 'Xem thêm',
    publish: 'Đăng',
    unpublish: 'Hủy Đăng',
    move: 'Di chuyển',
    share: 'Chia sẻ',
    settings: 'Cài đặt',
    promoteAdmin: 'Bổ nhiệm Admin',
    logout: 'Đăng xuất',
    index: 'STT',
    dataChanged: 'Dữ liệu đã thay đổi',
    dataChangedDescription: 'Bạn có chắc chắn muốn rời trang này?',
    dataChangedButton: 'Rời',
    dataChangedCancel: 'Hủy',
    copy: 'Sao chép',
    shareQR: 'Chia sẻ bằng QR',
    scanQR: 'Quét và chia sẻ ứng dụng',
    createQR: 'Tạo mã QR',
    embedded: 'Nhúng',
    embeddedWeb: 'Nhúng vào Web',
    uploadSuccess: 'Tải lên thành công',
    uploadFailed: 'Tải lên thất bại',
    unsupported_format: 'Định dạng file này chưa hỗ trợ hoặc lỗi khi xem trước',
    information: 'Thông tin',
    back: 'Quay lại',
    close: 'Đóng',
    filter: 'Lọc',
    reload: 'Làm mới trang',
    returnToLogin: 'Quay lại trang đăng nhập',
    downloadSuccess: 'Tải file thành công',
    downloadFailed: 'Tải file thất bại',
    result: 'Kết quả',
    newest: 'Mới nhất',
    creationDate: 'Ngày tạo',
    alphabet: 'Alphabet',
    notifications: 'Thông báo',
    announcements: 'Thông báo',
    swapWorkspace: 'Đổi Workspace',
    showMore: 'Mở rộng',
    showLess: 'Thu gọn',
    loading: 'Đang tải',
    role: 'Vai trò',
    aiThinking: 'AI đang suy nghĩ',
    aiResponse: 'Câu trả lời của AI',
    approved: 'Chấp thuận',
    waiting: 'Chờ Duyệt',
    correct: 'Đúng',
    incorrect: 'Sai',
    correctAnswerIs: 'Đáp án đúng là',
    check: 'Kiểm tra',
    all: 'Tất cả',
    starOn: 'Star on',
    underDevelopment: 'Đang phát triển',
    page: 'Trang',
    of: 'trên',
    duplicate: 'Nhân bản',
    basicCredit: 'Cơ bản',
    advancedCredit: 'Nâng cao',
    actions: 'Hành động',
    enabled: 'Bật',
    disabled: 'Tắt',
    showing: 'Hiển thị',
    results: 'kết quả',
    accept: 'Đồng ý',
    recall: 'Thu hồi',
    assignNow: 'Giao bài ngay',
    assign: 'Giao bài',
    hide: 'Ẩn bớt',
    agree: 'Đồng ý',
    checkAll: 'Chọn tất cả',
    options: 'Tùy chọn',
    addAll: 'Thêm toàn bộ',
    approveAll: 'Thêm toàn bộ',
    reject: 'Từ chối',
    addNew: 'Thêm',
    light: 'Giao diện sáng',
    dark: 'Giao diện tối',
    sort: 'Bộ lọc',
    cancelSort: 'Hủy lọc',
    create: 'Tạo',
    exportExcel: 'Xuất excel',
    more: 'Thêm nữa',
    basic: 'Cơ bản',
    advanced: 'Nâng cao',
    updateSuccess: 'Cập nhật thành công',
    updateFailed: 'Cập nhật thất bại',
    deleteFailed: 'Xóa thất bại',
    createSuccess: 'Tạo thành công',
    createFailed: 'Tạo thất bại',
    saveFailed: 'Lưu thất bại',
    loadSuccess: 'Tải thành công',
    loadFailed: 'Tải thất bại',
    admin: 'Quản trị viên',
    headmaster: 'Hiệu trưởng',
    viceHeadmaster: 'Hiệu phó',
    teacher: 'Giáo viên',
    student: 'Học sinh / Phụ huynh',
    syncData: 'Đồng bộ dữ liệu',
    syncDataSuccess: 'Đồng bộ dữ liệu thành công',
    unknown: 'Không xác định',
    true: 'Đúng',
    false: 'Sai',
    errorOccurred: 'Đã có lỗi xảy ra',
    justNow: 'Vừa xong',
    minutes: 'phút',
    hours: 'giờ',
    days: 'ngày',
    ago: 'trước',
    done: 'Quay lại',
  },
  aiModel: {
    title: 'Model AI',
    editTitle: 'Sửa model',
    addTitle: 'Thêm model',
    logoCode: 'Mã logo',
    modelCode: 'Mã model',
    modelName: 'Tên model',
    description: 'Mô tả',
    provider: 'Nhà cung cấp',
    type: 'Loại',
    creditCost: 'Credit tiêu thụ',
    status: 'Trạng thái',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    typeBasic: 'Cơ bản',
    typeAdvanced: 'Nâng cao',
    providerAll: 'Tất cả',
    isPinned: 'Ưu tiên',
    viewMore: 'Các Mô hình Khác',
  },
  maintenance: {
    updateSystem: 'Nâng cấp hệ thống',
    updatingSystem: 'Đang nâng cấp hệ thống',
    systemStatus: 'Trạng thái hệ thống',
    maintenanceSystem: 'Bảo trì hệ thống',
    maintenanceTitle: 'Bảo trì',
    maintenanceDescription: 'Chúng tôi đang thực hiện bảo trì trên hệ thống. Vui lòng thử lại sau.',
    maintenanceExtraDescription: 'Hệ thống sẽ sớm hoạt động trở lại. Cảm ơn sự kiên nhẫn của bạn!',
    backToHome: 'Quay lại trang chủ',
    contactSupport: 'Để được hỗ trợ, vui lòng liên hệ',
    status: 'Trạng thái hệ thống',
    expectedTime: 'Thời gian dự kiến',
  },
  billing: {
    title: 'Cấu hình Hệ thống Tính phí/Điểm Tín dụng',
    serviceName: 'Tên Dịch vụ',
    serviceId: 'ID Dịch vụ (Tùy chọn)',
    method: 'Phương thức',
    path: 'Đường dẫn API',
    billingEnabled: 'Bật tính phí',
    requiredCreditType: 'Loại điểm tín dụng chính',
    fallbackCreditType: 'Loại điểm tín dụng dự phòng',
    billingUnit: 'Đơn vị tính phí',
    baseCreditCost: 'Chi phí điểm cơ bản',
    advanceCreditCost: 'Chi phí điểm nâng cao',
    creditPerToken: 'Điểm cho mỗi token',
    creditPerMb: 'Điểm cho mỗi MB',
    minimumCreditCost: 'Chi phí điểm tối thiểu',
    rateLimit: 'Giới hạn tốc độ',
    burstLimit: 'Giới hạn đột biến',
    targetType: 'Đối tượng áp dụng',
    targetKey: 'Khóa định danh',
    description: 'Mô tả',
    tags: 'Nhãn',
    tierConfig: 'Cấu hình gói dịch vụ',
    codeConfig: 'Cấu hình mã nguồn',
    enterServiceName: 'Nhập tên dịch vụ',
    enterServiceIdOptional: 'Nhập ID dịch vụ (tùy chọn khi tạo mới)',
    selectMethod: 'Chọn phương thức HTTP',
    enterPath: 'Nhập đường dẫn API',
    selectCreditType: 'Chọn loại điểm tín dụng',
    selectFallbackCreditType: 'Chọn loại điểm dự phòng',
    selectBillingUnit: 'Chọn đơn vị tính phí',
    enterBaseCreditCost: 'Nhập chi phí điểm cơ bản',
    enterAdvanceCreditCost: 'Nhập chi phí điểm nâng cao',
    enterCreditPerToken: 'Nhập điểm cho mỗi token',
    enterCreditPerMb: 'Nhập điểm cho mỗi MB',
    enterMinimumCreditCost: 'Nhập chi phí điểm tối thiểu',
    enterRateLimit: 'Nhập giới hạn tốc độ',
    enterBurstLimit: 'Nhập giới hạn đột biến',
    selectTargetType: 'Chọn đối tượng áp dụng',
    enterTargetKey: 'Nhập khóa định danh',
    enterDescription: 'Nhập mô tả',
    enterTierConfig: 'Nhập cấu hình gói dịch vụ (JSON)',
    enterCodeConfig: 'Nhập cấu hình mã nguồn (JSON)',
    saveConfiguration: 'Lưu cấu hình',
    loadMockData: 'Tải dữ liệu mẫu',
    configurationSaved: 'Đã lưu cấu hình thành công!',
    mockDataLoaded: 'Đã tải dữ liệu mẫu thành công!',
    formReset: 'Đã đặt lại form về giá trị mặc định',
    checkFormErrors: 'Vui lòng kiểm tra lỗi trong form',
    baseCredit: 'Điểm cơ bản',
    advanceCredit: 'Điểm nâng cao',
    premiumCredit: 'Điểm cao cấp',
    perRequest: 'Theo yêu cầu',
    perToken: 'Theo token',
    perMb: 'Theo MB',
    perHour: 'Theo giờ',
    user: 'Học sinh/Sinh viên',
    organization: 'Trường học',
    project: 'Lớp học',
    apiKey: 'Khóa API',
    // Danh sách cấu hình billing
    configList: {
      title: 'Danh sách cấu hình tính phí',
      description: 'Quản lý các cấu hình tính phí cho các dịch vụ API',
      addNew: 'Thêm mới',
      searchServiceName: 'Tìm kiếm theo tên dịch vụ',
      filterByBillingUnit: 'Lọc theo đơn vị tính phí',
      filterByTargetType: 'Lọc theo đối tượng áp dụng',
      noData: {
        title: 'Chưa có cấu hình nào',
        description: 'Bắt đầu bằng cách tạo cấu hình tính phí đầu tiên',
      },
      deleteConfirm: 'Bạn có chắc chắn muốn xóa cấu hình này không?',
      deleteSuccess: 'Xóa cấu hình thành công',
      deleteError: 'Lỗi khi xóa cấu hình',
      fetchError: 'Lỗi khi tải danh sách cấu hình',
    },
    // Bảng dữ liệu
    table: {
      serviceName: 'Tên dịch vụ',
      apiPath: 'Đường dẫn API',
      billingUnit: 'Đơn vị tính phí',
      creditCost: 'Chi phí điểm',
      targetType: 'Đối tượng áp dụng',
      targetKey: 'Khóa định danh',
      status: 'Trạng thái',
    },
    // Đơn vị tính phí
    units: {
      perRequest: 'Theo yêu cầu',
      perToken: 'Theo token',
      perMb: 'Theo MB',
      perHour: 'Theo giờ',
    },
    // Đối tượng áp dụng
    targetTypes: {
      user: 'Học sinh/Sinh viên',
      organization: 'Trường học',
      project: 'Lớp học',
      apiKey: 'Khóa API',
    },
    validation: {
      serviceName: 'Vui lòng nhập tên dịch vụ',
      method: 'Vui lòng chọn phương thức HTTP',
      path: 'Vui lòng nhập đường dẫn API',
      requiredCreditType: 'Vui lòng chọn loại điểm tín dụng chính',
      billingUnit: 'Vui lòng chọn đơn vị tính phí',
      baseCreditCost: 'Chi phí điểm cơ bản phải lớn hơn hoặc bằng 0',
      advanceCreditCost: 'Chi phí điểm nâng cao phải lớn hơn hoặc bằng 0',
      creditPerToken: 'Điểm cho mỗi token phải lớn hơn hoặc bằng 0',
      creditPerMb: 'Điểm cho mỗi MB phải lớn hơn hoặc bằng 0',
      minimumCreditCost: 'Chi phí điểm tối thiểu phải lớn hơn hoặc bằng 0',
    },
  },
  mindmap: {
    // Default text
    defaultText: 'Sơ đồ tư duy',
    newMindMap: 'Sơ đồ tư duy mới',

    // Menu actions
    openMenu: 'Mở menu',
    hideMenu: 'Ẩn menu',
    showMenu: 'Hiển thị menu',

    // Theme section
    theme: 'Chủ đề',
    default: 'Mặc định',
    classic: 'Cổ điển',
    minions: 'Minions',
    pinkGrape: 'Pink Grape',
    mint: 'Mint',
    gold: 'Gold',
    vitalityOrange: 'Vitality Orange',
    greenLeaf: 'Green Leaf',
    dark2: 'Dark 2',
    skyGreen: 'Sky Green',
    classic2: 'Classic 2',
    classic3: 'Classic 3',
    classic4: 'Classic 4',
    classicGreen: 'Classic Green',
    classicBlue: 'Classic Blue',
    blueSky: 'Blue Sky',
    brainImpairedPink: 'Brain Impaired Pink',
    dark: 'Dark',
    earthYellow: 'Earth Yellow',
    freshGreen: 'Fresh Green',
    freshRed: 'Fresh Red',
    romanticPurple: 'Romantic Purple',
    simpleBlack: 'Simple Black',
    courseGreen: 'Course Green',
    coffee: 'Coffee',
    redSpirit: 'Red Spirit',
    blackHumour: 'Black Humour',
    lateNightOffice: 'Late Night Office',
    blackGold: 'Black Gold',
    avocado: 'Avocado',
    autumn: 'Autumn',
    orangeJuice: 'Orange Juice',

    // Layout section
    layout: 'Bố cục',
    logicalStructure: 'Cấu trúc logic',
    logicalStructureLeft: 'Cấu trúc logic trái',
    mindMap: 'Sơ đồ tư duy',
    catalogOrganization: 'Tổ chức danh mục',
    organizationStructure: 'Cơ cấu tổ chức',
    timeline: 'Dòng thời gian',
    timeline2: 'Dòng thời gian 2',
    fishbone: 'Xương cá',
    fishbone2: 'Xương cá 2',
    rightFishbone: 'Xương cá phải',
    rightFishbone2: 'Xương cá phải 2',
    verticalTimeline: 'Dòng thời gian dọc',
    verticalTimeline2: 'Dòng thời gian dọc 2',
    verticalTimeline3: 'Dòng thời gian dọc 3',

    // View options
    viewOptions: 'Tùy chọn hiển thị',
    showConnections: 'Hiển thị đường nối',
    showIcons: 'Hiển thị biểu tượng',
    fullscreenMode: 'Chế độ toàn màn hình',
    showGrid: 'Hiển thị lưới',

    // Export section
    exportFile: 'Xuất file',
    exportPNG: 'Xuất PNG',
    exportSVG: 'Xuất SVG',
    exportJSON: 'Xuất JSON',
    toggleMiniMap: 'Bật/Tắt bản đồ thu nhỏ',
    exportModal: {
      title: 'Xuất file',
      exportType: 'Loại xuất',
      fileName: 'Tên tệp',
      formatOptions: 'Tùy chọn định dạng',
      paddingX: 'Đệm x',
      paddingY: 'Đệm y',
      transparent: 'Nền là trong suốt',
      fitBg: 'Hiển thị đầy đủ hình nền (có hiệu lực khi dùng hình nền)',
      configOptions: 'Tùy chọn cấu hình',
      includeConfig: 'Bao gồm cấu hình (layout, theme, v.v.)',
      footerText: 'Thêm văn bản ở chân trang',
      footerTextPlaceholder: 'Ví dụ: Từ simple-mind-map',
      cancel: 'Hủy',
      export: 'Xuất',
      exportTypes: {
        smm: {
          name: 'Tài liệu',
          description: 'Định dạng tài liệu gốc của Simple Mind Map',
        },
        png: {
          name: 'Hình ảnh',
          description: 'Định dạng ảnh phổ biến, phù hợp để xem chia sẻ',
        },
        svg: {
          name: 'SVG',
          description: 'Định dạng vector, có thể chỉnh sửa và mở rộng',
        },
        pdf: {
          name: 'PDF',
          description: 'Định dạng tài liệu phổ biến, dễ in và chia sẻ',
        },
        md: {
          name: 'Markdown',
          description: 'Định dạng văn bản có cấu trúc, dễ đọc và chỉnh sửa',
        },
        xmind: {
          name: 'XMind',
          description: 'Định dạng tương thích với XMind',
        },
        txt: {
          name: 'Txt',
          description: 'Định dạng văn bản đơn giản',
        },
        json: {
          name: 'JSON',
          description: 'Định dạng dữ liệu có cấu trúc',
        },
      },
    },

    // Toolbar buttons
    undo: 'Hoàn tác (Ctrl+Z)',
    redo: 'Làm lại (Ctrl+Y)',
    drawMode: 'Bút vẽ',
    insertSibling: 'Nút cùng cấp (Enter)',
    insertChild: 'Nút con (Tab)',
    deleteNode: 'Xóa nút (Delete)',
    insertImage: 'Hình ảnh',
    insertIcon: 'Biểu tượng',
    insertLink: 'Liên kết',
    insertNote: 'Ghi chú',
    insertTag: 'Thẻ',
    insertSummary: 'Tóm tắt (Ctrl+G)',
    insertConnection: 'Đường liên kết',
    insertFormula: 'Công thức',
    insertOutline: 'Khung ngoài',
    demonstrate: 'Trình chiếu',
    aiContinue: 'AI',
    openFolder: 'Thư mục',
    newFile: 'Tệp mới',

    // Main page content
    title: 'Trình tạo sơ đồ tư duy AI',
    description: 'Chỉ trong vài giây, những ý tưởng rời rạc sẽ được chuyển hoá thành sơ đồ tư duy mạch lạc, dễ hiểu và trực quan, giúp bạn nắm bắt và triển khai mọi kế hoạch một cách hiệu quả.',
    placeholder: 'Mô tả những gì bạn muốn tạo...',
    startGenerating: 'Bắt đầu tạo',
    languageOptions: {
      vietnamese: 'Tiếng Việt',
      english: 'English',
    },
    suggestedPrompts: 'Ví dụ gợi ý',
    suggestedPromptsList: {
      option1: 'Chiến lược thăm nhập thị trường phần mềm xa hội',
      option2: 'Mẹo giáo tiếp hiệu quả',
      option3: 'Cách đọc một cuốn sách',
      option4: 'Lịch trình du lịch Thái Lan 5 ngày',
    },
    createdMindmaps: 'Sơ đồ tư duy đã tạo',
    noMindmaps: 'Chưa có sơ đồ tư duy nào',
    noMindmapsDescription: 'Tạo sơ đồ tư duy đầu tiên của bạn bằng cách nhập yêu cầu ở trên',
    viewDetails: 'Xem chi tiết',
    completed: 'Đã hoàn thành',
    tokens: 'tokens',
    deleteMindmap: 'Xóa sơ đồ tư duy',
    deleteMindmapConfirm: 'Bạn có chắc chắn muốn xóa sơ đồ tư duy này không?',
    deleteMindmapSuccess: 'Xóa sơ đồ tư duy thành công!',
    deleteMindmapError: 'Có lỗi xảy ra khi xóa sơ đồ tư duy',
    pleaseEnterRequest: 'Vui lòng nhập yêu cầu để tạo sơ đồ tư duy',
    workspaceNotFound: 'Không tìm thấy workspace ID',
    defaultDescription: 'Sơ đồ tư duy được tạo tự động từ yêu cầu của bạn.',

    // Additional toolbar buttons
    openFile: 'Mở tệp',
    saveAs: 'Lưu thành',
    importFile: 'Nhập',
    exportFileToolbar: 'Xuất',

    // Popover form labels
    insertImageTitle: 'Chèn hình ảnh',
    imageUrl: 'URL hình ảnh:',
    imageTitle: 'Tiêu đề:',
    imageWidth: 'Chiều rộng:',
    imageHeight: 'Chiều cao:',
    insertIconsTitle: 'Chèn biểu tượng',
    icons: 'Biểu tượng:',
    addIcon: 'Thêm biểu tượng',
    insertLinkTitle: 'Chèn liên kết',
    url: 'URL:',
    text: 'Văn bản:',
    insertNoteTitle: 'Chèn ghi chú',
    noteContent: 'Nội dung ghi chú:',
    insertTagsTitle: 'Chèn thẻ',
    tags: 'Thẻ:',
    addTag: 'Thêm thẻ',
    insertSummaryTitle: 'Chèn tóm tắt',
    summaryText: 'Văn bản tóm tắt:',
    insertFormulaTitle: 'Công thức',
    formulaPlaceholder: 'Vui lòng nhập cú pháp LaTeX',
    confirm: 'Xác nhận',
    commonFormulas: 'Công thức phổ biến',
    formula: 'Công thức',
    latex: 'LaTeX',
    cancel: 'Hủy',
    insert: 'Chèn',
    enterTagName: 'Nhập tên thẻ',

    // Bottom bar
    zoomOut: 'Thu nhỏ',
    zoomIn: 'Phóng to',
    scale: 'Tỷ lệ',
    language: 'Ngôn ngữ',
    vietnamese: 'Tiếng Việt',
    english: 'English',

    // Node context menu
    insertSiblingNode: 'Chèn nút cùng cấp',
    insertChildNode: 'Chèn nút con',
    insertParentNode: 'Chèn nút cha',
    insertSummaryNode: 'Chèn tóm tắt',
    moveNodeUp: 'Di chuyển nút lên',
    moveNodeDown: 'Di chuyển nút xuống',
    collapseAllChildren: 'Thu gọn tất cả nút con',
    expandAllChildren: 'Mở rộng tất cả nút con',
    deleteCurrentNode: 'Xóa nút',
    deleteCurrentNodeOnly: 'Chỉ xóa nút hiện tại',
    copyNode: 'Sao chép nút',
    cutNode: 'Cắt nút',
    pasteNode: 'Dán nút',
    clearCustomStyle: 'Xóa kiểu tùy chỉnh',
    exportNodeAsPng: 'Xuất nút thành png',
    aiContinueNode: 'AI Tiếp tục',
    removeNote: 'Xóa ghi chú',
    removeLink: 'Xóa liên kết',
    removeTag: 'Xóa thẻ',
    // Canvas context menu
    expandAll: 'Mở rộng tất cả',
    collapseAll: 'Thu gọn tất cả',
    reformat: 'Định dạng lại',
    returnToMainNode: 'Quay về nút gốc',
    fitToScreen: 'Vừa màn hình',
    addRootNode: 'Thêm nút gốc',

    // Right side menu
    openMenuTooltip: 'Mở menu',
    hideMenuTooltip: 'Ẩn menu',
    showMenuTooltip: 'Hiển thị menu',
    themeTooltip: 'Chủ đề',
    layoutTooltip: 'Bố cục',
    viewOptionsTooltip: 'Tùy chọn hiển thị',
    exportFileTooltip: 'Xuất file',

    // Detail page
    loadingMindmap: 'Đang tải sơ đồ tư duy...',
    noMindmapData: 'Không có dữ liệu sơ đồ tư duy',
    backToMainPage: 'Quay lại trang chính',
    cannotLoadMindmap: 'Không thể tải sơ đồ tư duy',
    errorLoadingMindmap: 'Có lỗi xảy ra khi tải sơ đồ tư duy',
    errorGeneratingMindmap: 'Có lỗi xảy ra khi tạo sơ đồ tư duy',
    noDataToGenerate: 'Không có dữ liệu để tạo sơ đồ tư duy',
    newAssociativeLine: 'Kết nối mới',
    newAssociativeLineText: 'Kết nối mới',

    // components
    newNode: 'Nút mới',
    newChildNode: 'Nút con mới',
    newParentNode: 'Nút cha mới',
    newSummaryNode: 'Nội dung tóm tắt mới',
    newConnectionNode: 'Kết nối mới',
    newFormulaNode: 'Công thức mới',
    newOutlineNode: 'Khung ngoài mới',
    from: 'Từ',
    nodes: 'Nút',

    // placeholder
    noteContentPlaceholder: 'Nhập nội dung ghi chú...',
    summaryContentPlaceholder: 'Nhập nội dung tóm tắt...',

    // line style options
    lineStyleOptions: {
      curve: 'Đường cong',
      straight: 'Đường thẳng',
      direct: 'Đường trực tiếp',
    },
    nodeShapeOptions: {
      rectangle: 'Hình chữ nhật',
      circle: 'Hình tròn',
      diamond: 'Hình thoi',
    },

    // font weight options
    fontWeightOptions: {
      normal: 'Bình thường',
      bold: 'Đậm',
      bolder: 'Rất đậm',
      lighter: 'Mỏng',
    },

    // text decoration options
    textDecorationOptions: {
      none: 'Không có',
      underline: 'Gạch chân',
      lineThrough: 'Gạch ngang',
      overline: 'Gạch trên',
    },

    // theme options
    themeOptions: {
      default: 'Mặc định',
      classic: 'Cổ điển',
      minions: 'Minions',
      pinkGrape: 'Nho hồng',
      mint: 'Bạc hà',
      gold: 'Vàng',
      vitalityOrange: 'Cam sức sống',
      greenLeaf: 'Lá xanh',
      dark2: 'Tối 2',
      redSpirit: 'Tinh thần đỏ',
      coffee: 'Cà phê',
      orangeJuice: 'Nước cam',
      avocado: 'Bơ',
      autumn: 'Mùa thu',
      classicGreen: 'Xanh cổ điển',
      classicBlue: 'Xanh dương cổ điển',
      dark: 'Tối',
      earthYellow: 'Vàng đất',
      freshGreen: 'Xanh tươi',
      freshRed: 'Đỏ tươi',
      romanticPurple: 'Tím lãng mạn',
      simpleBlack: 'Đen đơn giản',
      courseGreen: 'Xanh khóa học',
      blackHumour: 'Hài đen',
      lateNightOffice: 'Văn phòng đêm khuya',
      blackGold: 'Đen vàng',
      brainImpairedPink: 'Hồng não tàn',
      blueSky: 'Trời xanh',
      classic2: 'Cổ điển 2',
      classic3: 'Cổ điển 3',
      classic4: 'Cổ điển 4',
      skyGreen: 'Xanh trời',
    },
  },
  rightSideMenu: {
    openMenu: 'Mở menu',
    hideMenu: 'Ẩn menu',
    showMenu: 'Hiển thị menu',
    theme: 'Chủ đề',
    layout: 'Bố cục',
    viewOptions: 'Tùy chọn hiển thị',
    showConnections: 'Hiển thị đường nối',
    showIcons: 'Hiển thị biểu tượng',
    fullscreenMode: 'Chế độ toàn màn hình',
    showGrid: 'Hiển thị lưới',
    export: 'Xuất file',
    lineStyle: 'Kiểu đường',
    lineColor: 'Màu đường',
    lineWidth: 'Độ dày đường',
    lineDasharray: 'Kiểu đường đứt',
    generalizationLineColor: 'Màu đường tóm tắt',
    generalizationLineWidth: 'Độ dày đường tóm tắt',
    associativeLineColor: 'Màu đường kết nối',
    associativeLineWidth: 'Độ dày đường kết nối',
    associativeLineActiveColor: 'Màu đường kết nối khi chọn',
    associativeLineActiveWidth: 'Độ dày đường kết nối khi chọn',
    moreDetailOptions: 'Tùy chọn chi tiết',
    customizeStyle: 'Tùy chỉnh kiểu dáng',
    connectionLine: 'Đường kết nối',
    lineThickness: 'Độ dày đường',
    color: 'Màu sắc',
    customOption: 'Tùy chọn',
    node: 'Nút',
    shape: 'Hình dạng',
    font: 'Phông chữ',
    fontSize: 'Kích thước',
    fontWeight: 'Độ đậm',
    textDecoration: 'Trang trí',
    textColor: 'Màu chữ',
    backgroundColor: 'Màu nền',
    borderColor: 'Màu viền',
    border: 'Viền',
    borderWidth: 'Độ dày viền',
    borderRadius: 'Bo góc',
    spacing: 'Khoảng cách',
    horizontalSpacing: 'Khoảng cách ngang',
    verticalSpacing: 'Khoảng cách dọc',
  },
  table: {
    quickSearchPlaceholder: 'Tìm kiếm nhanh',
  },
  chat: {
    newChatButton: 'Tạo hội thoại',
    newChat: 'Đoạn trò chuyện mới',
    newFolder: 'Tạo hội thoại',
    placeholder: 'Hỏi tôi bất cứ điều gì',
    placeholderMobile: 'Hỏi tôi bất cứ điều gì',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    copyFailed: 'Sao chép thất bại',
    downloaded: 'Đã tải xuống',
    urlCopied: 'Đã sao chép liên kết',
    copyCode: 'Sao chép Code',
    clearChat: 'Clear Chat',
    clearChatConfirm: 'Bạn có chắc chắn xóa cuộc trò chuyện này?',
    exportImage: 'Xuất hình ảnh',
    exportImageConfirm: 'Bạn có chắc chắn xuất cuộc trò chuyện này sang png không?',
    exportSuccess: 'Xuất thành công',
    exportFailed: 'Xuất thất bại',
    usingContext: 'Context Mode',
    turnOnContext: 'Ở chế độ hiện tại, việc gửi tin nhắn sẽ mang theo các bản ghi trò chuyện trước đó.',
    turnOffContext: 'Ở chế độ hiện tại, việc gửi tin nhắn sẽ không mang theo các bản ghi trò chuyện trước đó.',
    deleteMessage: 'Xóa tin nhắn',
    deleteMessageConfirm: 'Bạn có chắc chắn xóa tin nhắn này?',
    deleteHistoryConfirm: 'Bạn có chắc chắn để xóa lịch sử này?',
    clearHistoryConfirm: 'Bạn có chắc chắn để xóa lịch sử trò chuyện?',
    preview: 'Xem trước',
    showRawText: 'Hiển thị dưới dạng văn bản thô',
    thinking: 'Đang suy nghĩ...',
    chatHistory: 'Lịch sử trò chuyện',
    version: 'Phiên bản',
    searchChat: 'Tìm kiếm',
    pleaseUploadImage: 'Chỉ được phép upload file ảnh (JPG, PNG, GIF, etc.)',
    fileSizeTooLarge: 'Kích thước file không được vượt quá 10MB',
    loading: 'AI đang suy nghĩ...',
    table: {
      title: 'Lịch sử trò chuyện',
      name: 'Tên',
      description: 'Miêu tả',
      action: 'Hành động',
      createdAt: 'Ngày tạo',
      updatedAt: 'Ngày cập nhật',
      status: 'Trạng thái',
      agent: 'Agent',
      chatHistory: 'Lịch sử trò chuyện',
      chatHistoryDescription: 'Lịch sử trò chuyện sẽ được hiển thị ở đây',
      chatHistoryAction: 'Xem lịch sử trò chuyện',
      titleDeleteHistory: 'Xóa đoạn trò chuyện này',
      contentDeleteHistory: 'Hành động này sẽ xóa toàn bộ lịch sử chat với trợ lý học tập. Bạn sẽ không thể khôi phục lại các tin nhắn sau khi xóa.',
      deleteHistorySuccess: 'Xóa lịch sử trò chuyện thành công',
      deleteHistoryFailed: 'Xóa lịch sử trò chuyện thất bại',
    },
    shareChat: {
      shareChatDescription: 'Xin chào! Tôi có thể giúp gì cho bạn?',
      suggestedQuestions: 'Câu hỏi gợi ý',
      suggestedQuestionsDescription: 'Câu hỏi gợi ý sẽ được hiển thị ở đây',
      suggestedQuestionsAction: 'Xem câu hỏi gợi ý',
      pickAQuestion: 'Chọn câu hỏi',
      orTypeAQuestion: 'Hoặc nhập câu hỏi vào ô bên dưới',
      typeAQuestion: 'Nhập câu hỏi vào ô bên dưới',
      youCanAskMeQuestion: 'Bạn có thể thử hỏi tôi những câu hỏi như',
    },
    statisticalAnalysis: 'Phân tích thống kê',
    fileAttached: 'file đính kèm',
    filesAttached: 'files đính kèm',
    filePasted: 'Đã paste file',
    fileDropped: 'Đã thả file',
    dropFilesHere: 'Thả file vào đây',
    supportedFormats: 'Hỗ trợ hình ảnh, PDF, Word, Excel, PowerPoint và nhiều định dạng khác',
    defaultWelcomeMessage: 'Xin chào! Tôi có thể giúp gì cho bạn?',
    suggestionsTitle: '💡 Bạn có thể hỏi tôi:',
    orEnterQuestion: 'Hoặc nhập câu hỏi của bạn bên dưới',
    enterQuestion: 'Nhập câu hỏi của bạn bên dưới',
    tableAnalysisPrompt: 'Hãy trình bày đầy đủ các bảng trong kết quả mô tả theo format dưới đây, đảm bảo:\n- Có tiêu đề\n- Có dòng phân cách bằng dấu gạch ngang ở trên và dưới bảng\n- Mỗi biến được tách riêng, các giá trị con thụt vào 1 tab\n- Các số liệu căn lề phải, tên biến căn lề trái\n- Cuối bảng có chú thích (ví dụ: ¹ n (%))\n- Giữ đúng số lượng dòng gạch và định dạng như mẫu\n- Các chữ số hiển thị chung 1 cỡ chữ\n- Chỉ xuất bảng, không có phần giới thiệu.',
    onlyImagesAllowed: 'Chỉ được phép tải lên file hình ảnh',
    documentsNotAllowed: 'Agent này không cho phép tải lên tài liệu',
    uploadsNotAllowed: 'Agent này không cho phép tải lên file',
    fileNotAllowed: 'Loại file không được phép',
    submitError: 'Gửi tin nhắn thất bại. Vui lòng thử lại.',
    titleUpdateNameChat: 'Đổi tên đoạn trò chuyện',
    nameHistoryChat: 'Tên cuộc trò chuyện',
    nameHistoryChatPlaceholder: 'Nhập tên cuộc trò chuyện',
  },
  workspace: {
    letStart: 'Hãy bắt đầu',
    createWorkspace: 'Tạo Workspace',
    chooseWorkspace: 'Chọn Workspace',
    createNewWorkspace: 'Tạo Workspace mới',
    updateWorkspace: 'Cập nhật Workspace',
    workspaceName: 'Tên Workspace',
    sector: 'Lĩnh vực',
    description: 'Mô tả',
    guest: 'Khách',
    createSuccess: 'Tạo Workspace thành công',
    createError: 'Tạo Workspace thất bại',
    updateSuccess: 'Cập nhật Workspace thành công',
    updateError: 'Cập nhật Workspace thất bại',
    deleteSuccess: 'Xóa Workspace thành công',
    deleteError: 'Xóa Workspace thất bại',
    deleteWorkspace: 'Xóa Workspace',
    deleteWorkspaceDescription: 'Bạn có chắc chắn muốn xóa Workspace này?',
    workspace: 'Workspace',
    workspaceList: 'Danh sách Workspace',
    workspaceListEmpty: 'Không có Workspace',
    workspaceListEmptyDescription: 'Tạo Workspace để bắt đầu cộng tác với nhóm',
    workspaceListEmptyButton: 'Tạo Workspace',
    createdBy: 'Tạo bởi',
    ownerBy: 'Quản trị bởi',
    workspaceManagement: 'Quản lý Workspace',
    workspaceManagementDescription: 'Tạo và quản lý các Workspace để làm việc hiệu quả hơn với team của bạn',
    welcomeBonus: 'Thưởng chào mừng! 🎉',
    welcomeBonusDescription: 'Chúc mừng! Bạn đã nhận được credit chào mừng cho tài khoản mới.',
    welcomeBonusSubDescription: 'Bây giờ bạn có thể bắt đầu sử dụng các dịch vụ AI với credit miễn phí.',
    welcomeBonusAmount: 'Bạn nhận được:',
    welcomeBonusBasic: '1,000 Credit Cơ bản',
    welcomeBonusAdvanced: '500 Credit Nâng cao',
    welcomeBonusUpgrade: 'Để sử dụng nhiều credit hơn, vui lòng nâng cấp lên Pro.',
    modal: {
      validate: {
        workspace_name: 'Tên Workspace không được phép để trống.',
        industry: 'Lĩnh vực không được phép để trống.',
      },
    },
  },
  setting: {
    setting: 'Cài đặt',
    general: 'Chung',
    advanced: 'Nâng cao',
    config: 'Cấu hình',
    avatarLink: 'Avatar Link',
    name: 'Tên',
    description: 'Miêu tả',
    role: 'Vai trò',
    temperature: 'Nhiệt độ',
    top_p: 'Top_p',
    resetUserInfo: 'Đặt lại thông tin người dùng',
    chatHistory: 'Lịch sử trò chuyện',
    theme: 'Giao diện',
    language: 'Ngôn ngữ',
    api: 'API',
    reverseProxy: 'Reverse Proxy',
    timeout: 'Timeout',
    socks: 'Socks',
    httpsProxy: 'HTTPS Proxy',
    balance: 'API Balance',
    monthlyUsage: 'Sử dụng hàng tháng',
    openSource: 'Dự án này được mở nguồn tại',
    freeMIT: 'miễn phí và dựa trên giấy phép MIT, không có bất kỳ hình thức hành vi trả phí nào!',
    stars: 'Nếu bạn thấy dự án này hữu ích, vui lòng cho tôi một Star trên GitHub hoặc tài trợ một chút, cảm ơn bạn!',
    colorTheme: 'Màu chung',
  },

  store: {
    siderButton: 'Prompt Store',
    local: 'Local',
    online: 'Online',
    title: 'Tiêu đề',
    description: 'Miêu tả',
    clearStoreConfirm: 'Cho dù để xóa dữ liệu?',
    importPlaceholder: 'Vui lòng dán dữ liệu JSON vào đây',
    addRepeatTitleTips: 'Tiêu đề trùng lặp, vui lòng nhập lại',
    addRepeatContentTips: 'Nội dung trùng lặp: {msg}, vui lòng nhập lại',
    editRepeatTitleTips: 'Xung đột tiêu đề, vui lòng sửa lại',
    editRepeatContentTips: 'Xung đột nội dung {msg} , vui lòng sửa đổi lại',
    importError: 'Key value mismatch',
    importRepeatTitle: 'Tiêu đề liên tục bị bỏ qua: {msg}',
    importRepeatContent: 'Nội dung liên tục bị bỏ qua: {msg}',
    onlineImportWarning: 'Lưu ý: Vui lòng kiểm tra nguồn tệp JSON!',
    downloadError: 'Vui lòng kiểm tra trạng thái mạng và tính hợp lệ của tệp JSON',
  },
  knowledge: {
    title: 'Bộ kiến thức',
    create: 'Tạo bộ kiến thức',
    extraction: 'Trích văn bản',
    search: 'Tìm kiếm kiến thức',
    import: ' Import Knowledge',
    edit: 'Sửa bộ kiến thức',
    createEmptyKnowledge: 'Tạo Kiến thức trống',
    emptyKnowledge: 'Tôi muốn tạo bộ kiến thức trống',
    name: 'Tên bộ kiến thức',
    description: 'Mô tả kiến thức',
    titleDelete: 'Xóa bộ kiến thức này?',
    contentDeleteAgent: 'Bộ kiến thức đã được sử dụng bởi {agent} agent. Nếu tiếp tục, bộ kiến thức sẽ bị xóa và tự động gỡ bỏ khỏi toàn bộ các agent đó.\nBạn có muốn tiếp tục',
    contentDelete: 'Bộ kiến thức sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
    titleErrorDelete: 'Xóa không thành công',
    contentErrorDelete: 'Trợ lý đang sử dụng bộ kiến thức này đã được đăng tải lên cửa hàng. Vui lòng hủy đăng tải trợ lý trước khi thực hiện xóa bộ kiến thức.',
    document: {
      title: 'Tài liệu',
      description: 'Tất cả các tệp của bộ kiến thức {name} được hiển thị ở đây',
      create: 'Thêm tệp',
      search: 'Tìm kiếm tệp',
      name: 'Tên',
      docs: 'Tài liệu',
      words: 'Từ',
      linkedApps: 'Trợ lý liên kết',
      titleDelete: 'Bạn có chắc chắn muốn xóa?',
      contentDelete: 'Kiến thức này đã được gắn với trợ lý giáo dục. Khi xóa, các trợ lý đang sử dụng kiến thức này có thể hoạt động kém chính xác hơn. Bạn có chắc chắn muốn xóa không?',
      documentInfo: 'Thông tin tài liệu',
    },
    steps: {
      dataSource: 'Chọn nguồn dữ liệu',
      documentProcessing: 'Xử lý văn bản',
      executeFinish: 'Thực hiện và hoàn thành',
      next: 'Tiếp theo',
      saveProcess: 'Lưu & Xử lý',
      previous: 'Quay lại',
      goToDocument: 'Đi đến tài liệu',
      uploadFile: 'Tải lên tệp',
      uploadImage: 'Trích văn bản từ hình ảnh',
      importFromUrl: 'Nhập từ URL',
      inputText: 'Nhập văn bản',
      knowledgeCreated: 'Kiến thức đã được tạo',
      knowledgeCreatedDes: 'Chúng tôi đã tự động đặt tên cho Kiến thức, bạn có thể sửa đổi nó bất kỳ lúc nào',
      embeddingCompleted: 'Hoàn tất nhúng',
      embeddingError: 'Lỗi nhúng',
      guide: 'Tiếp theo là gì',
      guideDes: 'Sau khi tài liệu hoàn thành chỉ mục, Kiến thức có thể được tích hợp vào ứng dụng như một ngữ cảnh, bạn có thể tìm cài đặt ngữ cảnh trong trang điều chỉnh prompt. Bạn cũng có thể tạo nó như một plugin chỉ mục ChatGPT độc lập để phát hành.',
    },
    importFromUrl: {
      placeholder: 'https://www.example.com',
      supportedUrls: 'URL được hỗ trợ:',
      webPage: 'Trang web: nội dung sẽ được tải xuống dưới dạng tệp .html',
      fileFormats: 'Tệp với định dạng:',
      googleDocs: 'Google Docs, Slides công khai',
      maxSize: 'Kích thước tệp tối đa:',
      importing: 'Đang nhập từ URL:',
    },
    inputText: {
      title: 'Nhập nội dung của bạn',
      contentLabel: 'Nội dung',
      contentPlaceholder: 'Dán hoặc nhập nội dung của bạn tại đây. Tối đa 10.000 từ.',
      words: 'từ',
      fileNameLabel: 'Tên tệp mới',
      fileNamePlaceholder: 'Tài liệu ví dụ',
      importing: 'Đang nhập nội dung',
    },
    chunk: {
      chunkSetting: 'Cài đặt phân đoạn',
      chunkingSetting: 'Quy tắc phân đoạn',
      general: 'Tổng quát',
      generalDescription: 'Văn bản sẽ được chia nhỏ thành nhiều đoạn giống nhau về cách xử lý. Phù hợp với văn bản tương đối đồng nhất: nội dung liền mạch, không có cấu trúc rõ ràng dạng mục, tiểu mục,... (ví dụ: bài báo, sách, báo cáo)',
      hierarchical: 'Cha-con',
      hierarchicalDescription: 'Văn bản sẽ được chia thành “đoạn cha” và trong mỗi đoạn cha lại có “đoạn con” để tìm kiếm hoặc truy xuất. Giữ “đoạn cha” làm ngữ cảnh rộng, và lấy “đoạn con” để trả lời chính xác. Phù hợp với văn bản có cấu trúc mục lớn và chứa nhiều mục nhỏ (ví dụ: giáo trình, hợp đồng, ...)',
      removeExtraSpaces: 'Thay thế các khoảng trắng, dòng mới và tab liên tiếp',
      removeUrlsEmails: 'Xóa tất cả URL và địa chỉ email',
      chunkQAFormat: 'Tách từng bộ câu hỏi Q&A thành các đoạn riêng biệt',
      chunkQAFormatDescription: 'Bật tùy chọn này sẽ tiêu tốn nhiều token hơn',
      detectLanguage: 'Ngôn ngữ nhận diện',
      delimiter: 'Ký tự phân tách',
      maximumChunkLength: 'Độ dài đoạn tối đa',
      maximumChunkLengthSuffix: 'ký tự',
      chunkOverlap: 'Chồng lặp giữa các đoạn',
      chunkOverlapSuffix: 'ký tự',
      previewChunk: 'Xem trước đoạn văn bản',
      textPreprocessingRules: 'Quy tắc tiền xử lý văn bản',
      parentChunkForContext: 'Đoạn cha cho ngữ cảnh',
      childChunkForRetrieval: 'Đoạn con làm câu trả lời',
      paragraph: 'Chia văn bản theo từng đoạn',
      paragraphDescription: 'Chế độ này chia văn bản thành các đoạn dựa trên ký tự phân tách và độ dài đoạn tối đa, sử dụng đoạn văn đã chia làm đoạn cha để truy xuất.',
      custom: 'Tùy chỉnh',
      fullDoc: 'Tài liệu đầy đủ',
      fullDocDescription: 'Toàn bộ tài liệu được sử dụng làm đoạn cha và được truy xuất trực tiếp. Lưu ý: vì lý do hiệu suất, văn bản vượt quá 10.000 token sẽ tự động bị cắt bớt.',
      indexMethod: 'Chế độ tìm kiếm',
      highQuality: 'Chất lượng cao',
      highQualityDescription: 'Tìm kiếm thông minh, chính xác hơn',
      highQualitySubDescription: 'Trợ lý giáo dục được gắn kiến thức có thể tìm kiếm thông minh hơn, hiểu được ý nghĩa câu hỏi. Kết quả trả lời chính xác hơn, đặc biệt với câu hỏi dài và phức tạp',
      highQualityNote: 'Sau khi hoàn tất việc nhúng ở chế độ Chất lượng cao, không thể hoàn nguyên về chế độ Tiết kiệm.',
      embeddingModel: 'Mô hình nhúng',
      economy: 'Tiết kiệm',
      economyDescription: 'Tìm kiếm nhanh, phù hợp tra cứu đơn giản',
      economySubDescription: 'Trợ lý giáo dục được gắn kiến thức có thể tìm kiếm nhanh hơn, phù hợp cho những trường hợp cần tra cứu đơn giản',
      retrievalSetting: 'Cài đặt truy xuất',
      retrievalSettingNote: 'Tìm hiểu thêm về phương pháp truy xuất. Bạn có thể thay đổi điều này bất kỳ lúc nào trong cài đặt Kiến thức.',
      semanticSearch: 'Tìm kiếm theo ý nghĩa',
      semanticSearchDes: 'Tạo các nhúng truy vấn và tìm kiếm đoạn văn bản tương tự nhất với biểu diễn vector của nó.',
      fullTextSearch: 'Tìm kiếm văn bản',
      fullTextSearchDes: 'Lập chỉ mục cho tất cả các thuật ngữ trong tài liệu, cho phép người dùng tìm kiếm bất kỳ thuật ngữ nào và truy xuất đoạn văn bản liên quan chứa các thuật ngữ đó.',
      hybridSearch: 'Tìm kiếm kết hợp',
      hybridSearchDes: 'Thực hiện tìm kiếm toàn văn bản và tìm kiếm vector đồng thời, sắp xếp lại để chọn kết quả phù hợp nhất với truy vấn của người dùng. Yêu cầu cấu hình API mô hình Rerank.',
      rerankModel: 'Mô hình sắp xếp lại',
      scoreThreshold: 'Ngưỡng điểm',
      topK: 'Top K',
      recommend: 'Đề xuất',
      weightedScore: 'Điểm số có trọng số',
      weightedScoreDes: 'Bằng cách điều chỉnh trọng số được gán, chiến lược xếp hạng lại này xác định liệu ưu tiên khớp ngữ nghĩa hay từ khóa.',
      rerankModelDes: 'Mô hình sắp xếp lại sẽ sắp xếp lại danh sách tài liệu ứng cử viên dựa trên sự phù hợp ngữ nghĩa với truy vấn của người dùng, cải thiện kết quả của việc xếp hạng ngữ nghĩa',
      semantic: 'Ngữ nghĩa',
      keyword: 'Từ khoá',
      invertedIndex: 'Chỉ mục ngược',
      invertedIndexDes: 'Chỉ mục Ngược là một cấu trúc được sử dụng cho việc truy xuất hiệu quả. Nó được tổ chức theo thuật ngữ, mỗi thuật ngữ trỏ đến tài liệu hoặc trang web chứa nó.',
      preview: 'Xem trước',
      estimatedChunks: 'Đoạn ước tính',
      clickPreviewChunk: 'Nhấp vào nút "Xem trước đoạn" ở bên trái để tải bản xem trước',
      chunks: 'Đoạn',
      sections: 'Đoạn',
      parentChunks: 'Đoạn cha mẹ',
      childChunks: 'Đoạn con',
      result: 'Kết quả',
      chunk: 'Đoạn',
      character: 'Ký tự',
      inputText: 'Nhập văn bản',
      keywords: 'Từ khoá',
      addKeyword: 'Thêm từ khoá',
      addAnotherOne: 'Thêm một cái khác',
      addParameter: 'Thêm Đoạn',
      all: 'Tất cả',
      search: 'Tìm kiếm',
      edit: 'Đã sửa',
      query: 'truy vấn',
      active: 'Đã kích hoạt',
      inactive: 'Không kích hoạt',
      enabled: 'Sử dụng',
      disabled: 'Ngừng sử dụng',
      addChunk: 'Thêm Đoạn',
      addChildChunk: 'Thêm Đoạn Con',
      newChunk: 'Đoạn mới',
      newChildChunk: 'Đoạn con mới',
      editChunk: 'Sửa đoạn',
      originalFileName: 'Tên tệp gốc:',
      originalFileSize: 'Kích thước tệp:',
      uploadDay: 'Ngày tải lên:',
      lastUpdateDay: 'Ngày cập nhật cuối:',
      source: 'Nguồn',
      technicalParameters: 'Thông số kỹ thuật',
      paraSpec: 'Chế độ phân đoạn:',
      paraLength: 'Độ dài đoạn tối đa:',
      avarageLength: 'Độ dài trung bình đoạn:',
      paraNumber: 'Số đoạn văn:',
      paragraphs: 'đoạn',
      retrievalCount: 'Số lần truy vấn',
      timesUsed: 'Số lần sử dụng tài liệu:',
      immersionTime: 'Thời gian nhúng',
      embededCost: 'Chi phí nhúng',
      name: 'Tên tệp',
      chunkMode: 'Chế độ chunking',
      words: 'Số từ',
      uploadTime: 'Thời gian tải lên',
      status: 'Trạng thái',
      action: 'Thao tác',
      available: 'Sử dụng',
      titleDelete: 'Xóa đoạn này?',
      times: 'lần',
      lineBreak: '{n} lần xuống dòng.',
      identifyParentParagraph: 'Cách xác định đoạn cha',
      searchMethod: 'Cách thức tìm kiếm',
      arrangementResults: 'Hệ thống tự chọn và sắp xếp kết quả phù hợp',
      numberSegmentsAnalysis: 'Số đoạn văn bản được lấy ra để phân tích',
      displayResultsRelatedQuestion: 'Chỉ hiển thị kết quả nếu liên quan tới câu hỏi',
      uploadedBy: 'Người tải lên:',
      numberOfCharacters: 'Số từ:',
      collapse: 'Thu gọn',
    },
    metadata: {
      name: 'Tên',
      metadata: 'Metadata',
      addMetadata: 'Thêm Metadata',
      description: 'Bạn có thể quản lý tất cả siêu dữ liệu trong phần Kiến thức này tại đây. Mọi chỉnh sửa sẽ được đồng bộ đến tất cả tài liệu.',
      note: 'Siêu dữ liệu đóng vai trò như một bộ lọc quan trọng, giúp nâng cao độ chính xác và mức độ phù hợp khi truy xuất thông tin. Bạn có thể chỉnh sửa và thêm siêu dữ liệu cho tài liệu này tại đây.',
      startLabel: 'Bắt đầu thêm nhãn',
      newMetadata: 'Thêm mới Metadata',
      manage: 'Quản lý',
      titleDelete: 'Xác nhận xóa',
      contentDelete: 'Bạn có chắc chắn muốn xóa metadata "{name}" không?',
    },
    extract: {
      title: 'Trích văn bản từ hình ảnh',
      extraction: 'Trích xuất',
      download: 'Tải xuống',
      createNew: 'Tạo bộ kiến thức mới',
      addToKnowledge: 'Thêm vào bộ kiến thức đã có',
    },
    languageOptions: {
      vietnamese: 'Tiếng Việt',
      english: 'English',
    },
  },
  upload: {
    steps: {
      chooseDataFile: 'Chọn tệp dữ liệu',
      checkAndFinish: 'Kiểm tra và hoàn thành',
    },
    drag_instruction: 'Nhấp để tải lên, hoặc kéo và thả tệp vào đây',
    supported_format: 'Định dạng được hỗ trợ',
    support_format: 'Định dạng hỗ trợ',
    max_size: 'Kích thước tệp tối đa: {size}',
    chooseFile: 'Chọn tệp',
    uploadYourFile: 'Tải lên tệp của bạn',
    uploadYourImages: 'Tải lên hình ảnh',
    uploadYourPDFFiles: 'Tải lên tệp PDF',
    uploadFileForAssistant: 'Tải lên kiến thức cho trợ lý',
    error: {
      invalid_type: 'Loại tệp không hợp lệ',
      too_large: 'Tệp quá lớn. Tối đa: {size} MB',
      too_many: 'Quá nhiều tệp. Số lượng tối đa cho phép: {max}',
    },
    previewDocument: 'Xem trước tài liệu',
  },
  menu: {
    home: 'Trang chủ',
    dashboard: 'Tổng quan',
    folder: 'Thư mục',
    monitor: 'Giám sát',
    chat: 'Trò chuyện',
    agent: 'Agent',
    knowledges: 'Kiến thức',
    knowledge: 'Kiến thức',
    document: 'Tài liệu',
    tasks: 'Tác vụ',
    settings: 'Cài đặt',
    agentStore: 'Cửa hàng NextSchool',
    userProfile: 'Thông tin cá nhân',
    transaction: 'Quản lý giao dịch',
    helpCommunity: 'Hỗ trợ và cộng đồng',
    tool: 'Công cụ',
    userGuide: 'Hướng dẫn sử dụng',
    forum: 'Diễn đàn',
    contactSupport: 'Liên hệ hỗ trợ',
    elearning: 'Elearning',
    aiElearning: 'AI ELearning',
    slide: 'Slide',
    addAgent: 'Thêm trợ lý',
    updateAgent: 'Cập nhật trợ lý',
    uploadAgent: 'Đăng tải trợ lý',
    viewAgent: 'Xem trợ lý',
    configureAgent: 'Cấu hình trợ lý',
    assignAgent: 'Gán trợ lý',
    imageGeneration: 'Trình tạo hình ảnh AI',
    createKnowledge: 'Tạo Kiến thức',
    knowledgeDetail: 'Chi tiết Kiến thức',
    createDocument: 'Tạo Tài liệu',
    documentDetail: 'Chi tiết Tài liệu',
    documentSettings: 'Cài đặt Tài liệu',
    textExtraction: 'Trích xuất Văn bản',
    brandVoices: 'Giọng Thương hiệu',
    parameterConfiguration: 'Cấu hình Tham số',
    apiServiceConfiguration: 'Cấu hình hệ thống thanh toán/tín dụng',
    writer: 'Viết',
    writerUpdate: 'Bài viết',
    writerTemplates: 'Thư viện template',
    whiteboard: 'Bảng vẽ',
    classroom: 'Lớp học',
    classroomDetail: 'Chi tiết tớp học',
    classroomDetailSubject: 'Không gian học tập',
    classroomUploadDocument: 'Tài liệu',
    classroomCreatePractice: 'Bài luyên tập',
    classroomCreateFlashcard: 'Thẻ ôn tập',
    classroomCreateExercise: 'Bài tập',
    classroomPracticeExercise: 'Bài luyện tập',
    classroomExerciseDetail: 'Chi tiết bài tập',
    classroomFlashcardPractice: 'Thẻ ôn tập',
    classroomExamPaper: 'Kho đề',
    classroomQuestionBank: 'Danh sách câu hỏi',
    classroomCreateExamPaper: 'Tạo đề kiểm tra',
    classroomConfigureScore: 'Thiết lập điểm',
    classroomList: 'Danh sách lớp học',
    classroomQuestionLibrary: 'Ngân hàng câu hỏi',
    classroomLearningResources: 'Kho học liệu',
    classroomStartLesson: 'Bắt đầu bài học',
    classroomTeachBoard: 'Khởi đầu tiết học',

    classroomLearningHub: 'Khởi động bài học',
    startLesson: 'Khởi đầu tiết học',
    classAI: 'Lớp học AI',
    classroomSpace: 'Không gian học tập',
    learningAssistant: 'Trợ lý học tập',
    classMembers: 'Thành viên lớp học',
    teaching: 'Dạy học',
    moreTools: 'Thêm công cụ',
    backgroundRemoval: 'Xóa nền',
    removeText: 'Xóa văn bản',
    inpaint: 'Inpaint',
    upscaleImage: 'Nâng cao hình ảnh',
    removeObject: 'Xóa ảnh',
    changeBackground: 'Thay đổi nền',
    aiTranslator: 'Trình dịch AI',
    imageTranslator: 'Trình dịch hình ảnh',
    videoSummarizer: 'Rút ngắn video',
    chatPdf: 'Trò chuyện PDF',
    mindmap: 'Sơ đồ tư duy',
    detailMindmap: 'Chi tiết sơ đồ tư duy',
    deepResearch: 'Nghiên cứu sâu',
    agentPdf: 'Trò chuyện PDF',
    agentPdfDetail: 'Trò chuyện PDF chi tiết',
    imageToWord: 'Hình ảnh sang văn bản',
    pdfToWord: 'PDF sang văn bản',
    transactionUpload: 'Tải lên tệp',
    group: {
      agent: 'Trợ lý giáo dục',
      community: 'Cộng đồng',
      image: 'Hình ảnh',
      video: 'Video',
      document: 'Tài liệu',
      text: 'Văn bản',
      audio: 'Âm thanh',
      other: 'KHÁC',
      tool: 'Công cụ',
      school: 'Trường học',
      ocr: 'OCR',
      store: 'Cửa hàng',
      systemSettings: 'CÀI ĐẶT HỆ THỐNG',
      agentStore: 'AGENT & CỬA HÀNG',
    },
    creditAndUsers: 'Credit & người dùng',
    approval: 'Phê duyệt',
    workspace: 'Workspace',
    image: 'Hình ảnh',
    notifications: 'Thông báo',
    paymentSystem: {
      title: 'Hệ thống thanh toán',
      tabs: {
        packages: 'Quản lý gói cước',
        modelPricing: 'Quản lý giá model',
        transactions: 'Quản lý giao dịch',
      },
      packages: {
        title: 'Danh sách gói cước',
        packageName: 'Tên gói',
        price: 'Giá',
        status: 'Trạng thái',
        createdAt: 'Ngày tạo',
        actions: 'Hành động',
        active: 'Hoạt động',
        inactive: 'Ngừng hoạt động',
        activate: 'Kích hoạt',
        deactivate: 'Ngừng hoạt động',
        edit: 'Chỉnh sửa',
        delete: 'Xóa',
        searchPlaceholder: 'Tìm kiếm tên gói',
        statusPlaceholder: 'Trạng thái',
        all: 'Tất cả',
        free: 'miễn phí',
        perMonth: '/tháng',
        features: {
          '10 câu hỏi/ngày': '10 câu hỏi/ngày',
          'Hỗ trợ chatbot cơ bản': 'Hỗ trợ chatbot cơ bản',
          'Không giới hạn câu hỏi': 'Không giới hạn câu hỏi',
          'Hỗ trợ chatbot nâng cao': 'Hỗ trợ chatbot nâng cao',
          'Báo cáo chi tiết': 'Báo cáo chi tiết',
          'API truy cập': 'API truy cập',
          'Quản lý người dùng': 'Quản lý người dùng',
          'Hỗ trợ ưu tiên': 'Hỗ trợ ưu tiên',
          'Tùy chỉnh riêng': 'Tùy chỉnh riêng',
        },
      },
      modelPricing: {
        title: 'Danh sách giá model',
        search: 'Tìm kiếm',
        provider: 'Nhà cung cấp',
        type: 'Loại',
        changeParams: 'Đổi tỉ lệ quy đổi',
        exportToExcel: 'Export to Excel',
        exportToPDF: 'Export to PDF',
        print: 'Print',
        serialNumber: 'STT',
        modelName: 'Tên model',
        inputPrice: 'Giá input ($)',
        outputPrice: 'Giá output ($)',
        lastUpdated: 'Cập nhật gần nhất',
        edit: 'Sửa',
        delete: 'Xóa',
        addNew: 'Thêm mới',
        editTitle: 'Sửa model',
        modelCode: 'Mã model',
        creditType: 'Loại',
        changeReason: 'Lý do thay đổi',
        changeReasonPlaceholder: 'Nhập lý do thay đổi thanh toán',
        cancel: 'Hủy',
        save: 'Lưu',
        rateTitle: 'Quy đổi $ sang Credit (Rate)',
        markupTitle: 'Hệ số biên lợi nhuận M (yêu cầu >1)',
        markupFactor: 'Hệ số M',
        minimumTitle: 'Phí tối thiểu (credit)',
        validation: {
          modelNameRequired: 'Vui lòng nhập tên model',
          providerRequired: 'Vui lòng chọn nhà cung cấp',
          typeRequired: 'Vui lòng chọn loại',
          inputPriceRequired: 'Giá input phải >= 0',
          outputPriceRequired: 'Giá output phải >= 0',
          changeReasonRequired: 'Vui lòng nhập lý do thay đổi',
          rateBasicRequired: 'Credit cơ bản phải > 0',
          rateAdvanceRequired: 'Credit nâng cao phải > 0',
          markupRequired: 'Hệ số M phải lớn hơn 1',
          minimumRequired: 'Credit tối thiểu phải > 0',
        },
        rateModal: {

          title: 'Đổi tỉ lệ quy đổi USD sang credit',
          description: 'Tỉ lệ quy đổi $1 sang credit cơ bản và nâng cao của hệ thống',
          basicCredit: 'Credit cơ bản',
          advancedCredit: 'Credit nâng cao',
        },
        markupModal: {
          title: 'Đổi hệ số biên lợi nhuận',
          description: 'Hệ số nhân thêm để tính toán vào chi phí vận hành',
          markupFactor: 'Hệ số biên lợi nhuận M (yêu cầu >1)',
          increasePercent: '=> Tăng thêm {percent}% so với chi phí gốc',
        },
        minimumModal: {
          title: 'Đổi chi phí tối thiểu',
          description: 'Phí credit tối thiểu khi người dùng thực hiện một hành động bất kỳ',
          minimumCredit: 'Phí tối thiểu (credit)',
        },
        providers: {
          openai: 'OpenAI',
          anthropic: 'Anthropic',
          google: 'Google',
          azure: 'Azure',
        },
        creditTypes: {
          token: 'Token',
          request: 'Request',
          time: 'Time',
        },
      },
      transactions: {
        title: 'Lịch sử giao dịch',
        user: 'Người dùng',
        plan: 'Gói',
        amount: 'Số tiền',
        method: 'Phương thức',
        status: 'Trạng thái',
        time: 'Thời gian',
        actions: 'Actions',
        viewDetails: 'Xem chi tiết',
        exportInvoice: 'Xuất hóa đơn',
        searchPlaceholder: 'Người dùng',
        planPlaceholder: 'Gói',
        statusPlaceholder: 'Trạng thái',
        dateRange: 'Chọn khoảng thời gian',
        success: 'Thành công',
        failed: 'Thất bại',
        processing: 'Đang xử lý',
        creditCard: 'Thẻ tín dụng',
        bankTransfer: 'Chuyển khoản',
        ewallet: 'Ví điện tử',
        free: 'Miễn phí',
        exportExcel: 'Xuất Excel',
      },
    },
    bookSetup: 'Thiết lập sách',
    uploadManagement: 'Quản lý đăng tải',
    writerUploadTemplate: 'Tải lên template',
    writerBlankTemplate: 'Tạo template trống',
    writerEditTemplate: 'Chỉnh sửa template',
    writerLibrary: 'Thư viện nội dung',
    writerTemplateSelector: 'Chọn Template',
    writerContentLibrary: 'Thư viện nội dung',
    writerBlankContent: 'Tạo nội dung trống',
    writerEditContent: 'Chỉnh sửa nội dung',
    school: 'Quản lý trường học',
    classroomResult: 'Kết quả học tập',
    classroomStudentDetail: 'Chi tiết học sinh',
    viewEducationalResource: 'Xem tài nguyên giáo dục',
    classroomExerciseProgressDetail: 'Chi tiết tiến trình bài tập',
    classroomUploadLessonPlanTool: 'Tải lên kế hoạch bài học',
    classroomUploadTeachingPlanTool: 'Tải lên kế hoạch bài giảng',
    classroomUploadLessonPlan: 'Tải lên kế hoạch bài học',
    classroomUploadTeachingPlan: 'Tải lên kế hoạch bài giảng',
    classroomStudentExerciseResult: 'Kết quả bài tập',
    classroomExamProgressDetail: 'Tiến độ kiểm tra',
    classroomStudentExamResult: 'Kết quả kiểm tra',
    classroomExamManage: 'Kiểm tra',
    classroomExam: 'Lịch kiểm tra',
    classroomExamStudents: 'Danh sách học sinh',
    classroomExamGrade: 'Chấm bài kiểm tra',
    classroomExamDetail: 'Chi tiết bài kiểm tra',
    classroomDocument: 'Tài liệu học tập',
    classroomFlashcard: 'Thẻ ôn tập',
    // classroomPractice: 'Bài luyện tập',
    classroomExercise: 'Bài luyện tập',
    classroomAssignments: 'Bài tập',
    subjectMore: 'Xem thêm',
    classroomNoSubject: 'Không có không gian học tập',
    classroomNoSubjectDescription: 'Hiện tại chưa có không gian học tập nào trong lớp học này. Vui lòng liên hệ giáo viên để được hỗ trợ.',
    classroomAssessments: 'Kiểm tra',
    classroomLearningOutcomes: 'Kết quả học tập',
  },

  learningResources: {
    title: 'Kho học liệu',
    searchPlaceholder: 'Tìm kiếm học liệu',
    tabs: {
      teachingDocuments: 'Tài liệu giảng dạy',
      worksheets: 'Phiếu bài tập',
      slides: 'Slide',
    },
    teachingDocuments: {
      featured: 'Tài liệu giảng dạy nổi bật',
      all: 'Tất cả tài liệu giảng dạy',
      noData: 'Không có tài liệu giảng dạy',
    },
    worksheets: {
      featured: 'Phiếu bài tập nổi bật',
      all: 'Tất cả phiếu bài tập',
      noData: 'Không có phiếu bài tập',
    },
    slides: {
      featured: 'Slide nổi bật',
      all: 'Tất cả slide',
      noData: 'Không có slide',
    },
    loading: 'Đang tải...',
    hot: 'Hot',
  },

  agent: {
    search: 'Tìm trợ lý',
    create: 'Tạo trợ lý',
    monitor: 'Giám sát',
    historyChat: 'Lịch sử chat',
    searchChat: 'Tìm chat',
    edit: 'Sửa trợ lý',
    view: 'Xem trợ lý',
    delete: 'Xóa trợ lý',
    deleteMessage: 'Bạn có chắc chắn muốn xóa trợ lý này?',
    deleteSuccess: 'Xóa trợ lý thành công',
    deleteError: 'Xóa trợ lý thất bại',
    urlShare: 'Địa chỉ công khai',
    publish: 'Đăng tải',
    publishMessage: 'Bạn có chắc chắn muốn đăng tải trợ lý này?',
    publishSuccess: 'Đăng tải trợ lý thành công',
    publishError: 'Đăng tải trợ lý thất bại',
    unpublish: 'Hủy đăng tải',
    unpublishMessage: 'Bạn có chắc chắn muốn hủy đăng tải trợ lý này?',
    unpublishSuccess: 'Hủy đăng tải trợ lý thành công',
    unpublishError: 'Hủy đăng tải trợ lý thất bại',
    addAgent: {
      title: 'Tạo trợ lý',
      quickAddAgent: 'Thêm nhanh trợ lý',
      name: 'Tên trợ lý',
      welcomeMessage: 'Tin nhắn chào mừng',
      descriptionMessage: 'Cấu hình tin nhắn chào mừng và tin nhắn gợi ý cho trợ lý của bạn',
      suggestedMessages: 'Tin nhắn gợi ý',
      messagePlaceholder: 'Placeholder tin nhắn',
      save: 'Lưu',
      addFolder: 'Thêm thư mục',
      folder: 'Thư mục',
      position: 'Vai trò',
      language: 'Ngôn ngữ',
      description: 'Mô tả',
      instruction: 'Hướng dẫn',
      instructionDescription: 'Hướng dẫn trợ lý',
      avatar: 'Ảnh đại diện',
      generalInformation: 'Thông tin cá nhân',
      agentModel: 'Mô hình trợ lý',
      message: 'Tin nhắn',
      addMessage: 'Thêm tin nhắn',
      askAgent: 'Hỏi trợ lý',
      addSuccess: 'Thêm mới trợ lý thành công',
      modelParam: 'Cách trả lời',
      selectModel: 'Chọn model',
      modelDescription: 'Mô tả',
      modelPrice: 'Giá',
      addError: 'Thêm trợ lý thất bại',
      addRequired: 'Vui lòng nhập các trường bắt buộc!',
      tab: {
        instruction: 'Thông tin chung',
        interface: 'Giao diện',
        tasks: 'Công việc',
        publish: 'Đăng tải',
        message: 'Tin nhắn',
      },
      validation: {
        nameRequired: 'Vui lòng nhập tên trợ lý!',
        folderRequired: 'Vui lòng chọn thư mục trợ lý!',
        positionRequired: 'Vui lòng nhập vai trò trợ lý!',
        languageRequired: 'Vui lòng chọn ngôn ngữ trợ lý!',
        descriptionRequired: 'Vui lòng nhập mô tả trợ lý!',
        instructionRequired: 'Vui lòng nhập hướng dẫn trợ lý!',
        modelParamRequired: 'Vui lòng chọn cách trả lời trợ lý!',
        modelRequired: 'Vui lòng chọn mô hình trợ lý!',
      },
      modal: {
        pickAvatar: 'Chọn avatar',
        uploadAvatar: 'Tải lên avatar',
        changeAvatar: 'Thay đổi avatar',
        categories: {
          animal: 'Động vật',
          human: 'Con người',
          robot: 'Robot',
          sticker: 'Nhãn dán',
        },
      },
      modelParamOptions: {
        exactly: 'Chính xác',
        balanced: 'Cân bằng',
        creative: 'Sáng tạo',
        myPreset: 'Tùy chỉnh',
        temperature: 'Độ sáng tạo',
        topP: 'Top P (lọc xác suất)',
        presencePenalty: 'Phạt lặp ý mới',
        frequencyPenalty: 'Phạt lặp từ',
        maxTokens: 'Số lượng token',
        tooltip: {
          temperature: 'Điều khiển mức độ ngẫu nhiên khi sinh câu trả lời. Độ sáng tạo thấp thì câu trả lời ít biến hóa, cao thì đa dạng hơn.',
          top_p: 'Điều chỉnh độ đa dạng dựa trên kỹ thuật lấy mẫu nucleus (lọc theo xác suất). Ví dụ 0.5 là chọn từ nửa trên các từ có xác suất cao nhất.',
          presence_penalty: 'Áp dụng hình phạt lên xác suất những từ đã xuất hiện trong đoạn văn, khuyến khích dùng từ mới tránh lặp ý.',
          frequency_penalty: 'Áp dụng hình phạt lên xác suất những từ lặp lại nhiều lần trong đoạn văn, giảm việc lặp từ.',
          max_tokens: 'Giới hạn số từ tối đa mà mô hình được phép sinh ra. Tăng lên để có câu trả lời dài hơn nếu cần.',
        },
      },
    },
    update: {
      features: 'Chức năng',
      featuresDescription: 'Cải thiện trải nghiệm người dùng',
      vision: 'Kích hoạt nhận diện',
      tool: 'Tool',
      memory: 'Memory',
      visionDescription: 'Khả năng đọc và xử lý hình ảnh',
      toolDescription: 'Cho phép sử dụng công cụ mở rộng.',
      memoryDescription: 'Lưu lại lịch sử hội thoại.',
      document: 'Tài liệu',
      documentDescription: 'Khả năng tải lên và xử lý tài liệu',
      chat: 'Tin nhắn',
      welcomeMessage: 'Tin nhắn chào mừng',
      descriptionMessage: 'Cấu hình tin nhắn chào mừng và tin nhắn gợi ý cho trợ lý của bạn',
      suggestedMessages: 'Tin nhắn gợi ý',
      messagePlaceholder: 'Nhập tin nhắn',
      save: 'Lưu',
      addMessage: 'Thêm tin nhắn',
      add: 'Thêm',
      message: 'Tin nhắn',
      interface: 'Giao diện',
      tasks: 'Công việc',
      publish: 'Xuất bản',
      agentInformation: 'Thông tin chung',
      agentInformationSubtitle: 'Cấu hình thông tin cơ bản và vai trò cho trợ lý của bạn',
      agentModel: 'Mô hình trợ lý',
      assistantModel: 'Mô hình trợ lý',
      persona: 'Nhân vật',
      position: 'Vai trò',
      positionPlaceholder: 'Nhập vai trò hoặc chức vụ của trợ lý (ví dụ: Chuyên viên Marketing, Phân tích dữ liệu)',
      language: 'Ngôn ngữ',
      description: 'Mô tả',
      descriptionPlaceholder: 'Mô tả về chức năng và mục đích chính của trợ lý',
      instruction: 'Hướng dẫn',
      instructionDescription: 'Hướng dẫn & Hành vi Trợ lý',
      instructionSubtitle: 'Định nghĩa tính cách, ngữ điệu và cách thức phản hồi của trợ lý',
      instructionPlaceholder: 'Ví dụ:\n\nBạn là một chuyên gia marketing chuyên nghiệp với hơn 10 năm kinh nghiệm.\n\nVai trò của bạn:\n- Tư vấn chiến lược marketing\n- Phân tích thị trường và đối thủ\n- Đề xuất giải pháp sáng tạo\n\nPhong cách giao tiếp:\n- Thân thiện nhưng chuyên nghiệp\n- Đưa ra lời khuyên cụ thể, có thể áp dụng\n- Sử dụng ví dụ thực tế để minh họa\n\nLuôn hỏi thêm thông tin nếu câu hỏi chưa rõ ràng.',
      avatar: 'Ảnh đại diện',
      generalInformation: 'Thông tin cá nhân',
      agentName: 'Tên trợ lý',
      agentNamePlaceholder: 'Nhập tên dễ nhớ cho trợ lý của bạn',
      folder: 'Thư mục',
      selectFolder: 'Chọn thư mục',
      file: 'Đính kèm',
      addFile: 'Thêm đính kèm',
      knowledge: 'Kiến thức',
      payment: 'Thanh toán',
      addKnowledge: 'Thêm kiến thức',
      descriptionAddKnowledge: 'Thêm cơ sở tri thức để nâng cao năng lực',
      searchKnowledge: 'Tìm kiến thức',
      noKnowledgeAvailable: 'Không có kiến thức nào',
      noTaskAvailable: 'Không có nhiệm vụ nào',
      itemSelected: 'Đã chọn',
      total: 'Tổng',
      paymentMethod: 'Phương thức thanh toán',
      paymentValue: 'Số tiền thanh toán',
      paymentCurrency: 'Loại tiền',
      addPaymentMethod: 'Thêm phương thức thanh toán',
      paymentMethodDescription: 'Hiển thị khi người dùng chọn các giá trị sau: Giờ, Tháng, Bán trợ lý',
      paymentValueDescription: 'Cho phép nhập số tại trường nhập',
      paymentCurrencyDescription: 'Cho phép chọn giá trị: VND, USD',
      updateSuccess: 'Cập nhật trợ lý thành công',
      modelConfiguration: 'Cấu hình mô hình',
      modelConfigurationSubtitle: 'Cấu hình mô hình trợ lý của bạn',
      settings: 'Cài đặt hiện tại',
      expiredDate: 'Hạn sử dụng liên kết',
      colorTheme: 'Màu Theme',
      sharedLink: 'Liên kết chia sẻ',
      sharedLinkSubtitle: 'Tạo liên kết chia sẻ để người dùng có thể truy cập vào trợ lý của bạn',
      openLink: 'Mở liên kết',
      selectType: 'Chọn kiểu nhúng',
      avatarApp: 'Ảnh đại diện ứng dụng',
      avatarUploaded: 'Ảnh đại diện đã tải lên',
      uploadAvatar: 'Tải lên ảnh đại diện',
      configShareLink: 'Cấu hình chia sẻ',
      configShareLinkSubtitle: 'Cấu hình chia sẻ link của bạn',
      nameApp: 'Tên ứng dụng',
      descriptionApp: 'Mô tả ứng dụng web',
      copyright: 'Tên bản quyền',
      type: 'Loại Link Share',
      copyrightBy: 'Được cung cấp bởi',
      modelParam: 'Cách trả lời',
      selectModel: 'Chọn model',
      modelDescription: 'Mô tả',
      modelPrice: 'Giá',
      skill: 'Kỹ năng',
      descriptionSkill: 'Cấu hình các kỹ năng và khả năng chuyên biệt',
      addSkill: 'Thêm kỹ năng',
      descriptionAddSkill: 'Chọn kỹ năng để nâng cao năng lực của tác nhân của bạn',
      searchSkill: 'Tìm kỹ năng',
      descriptionKnowledge: 'Quản lý cơ sở tri thức để nâng cao năng lực cho trợ lý',
      emptyKnowledge: 'Thêm mới kiến thức đầu tiên cho trợ lý',
      task: 'Nhiệm vụ',
      descriptionTask: 'Thiết lập các nhiệm vụ để trợ lý thực hiện nhanh chóng hơn',
      addTask: 'Thêm nhiệm vụ',
      addTaskDescription: 'Thêm nhiệm vụ để trợ lý thực hiện nhanh',
      editTask: 'Sửa nhiệm vụ',
      emptyTask: 'Thêm mới nhiệm vụ đầu tiên cho trợ lý',
      chatAppearance: {
        tab: {
          chatAppearance: 'Giao diện chat',
          theme: 'Giao diện',
          custom: 'Tùy chỉnh',
        },
        saveChanges: 'Lưu thay đổi',
        saveChangesSuccess: 'Lưu thay đổi thành công',
        title: 'Cài đặt giao diện chat',
        description: 'Tùy chỉnh giao diện chat của bạn',
        chooseTheme: 'Chọn giao diện',
        cool: 'Cool',
        background: 'Nền',
        customColors: 'Màu tùy chỉnh',
        color: 'Màu',
        image: 'Ảnh',
        uploadBackgroundImage: 'Tải lên ảnh nền',
        textColor: 'Màu văn bản',
        chatBubbleColors: 'Màu bong bóng chat',
        gradientColor1: 'Màu đầu tiên',
        gradientColor2: 'Màu thứ hai',
        userMessage: 'Tin nhắn người dùng',
        aiMessage: 'Tin nhắn AI',
        livePreview: 'Xem trước',
        preview: 'Bản xem trước',
        seeHowYourChatWillLook: 'Xem trước giao diện chat của bạn',
        desktop: 'Máy tính',
        mobile: 'Điện thoại',
        aiAssistant: 'AI Assistant',
        onlineNow: 'Đang hoạt động',
        heyThere: 'Xin chào!',
        coolDesign: 'Thiết kế cool!',
        youCanSeeAllTheDesignChangesHereInRealTime: 'Bạn có thể xem tất cả các thay đổi trong giao diện chat ở đây!',
        typeYourMessageHere: 'Nhập tin nhắn ở đây...',
        aiAssistantMobile: 'AI Assistant',
        onlineNowMobile: 'Đang hoạt động',
        unsavedChangesWarning: 'Bạn có thay đổi chưa được lưu trong Giao diện Chat. Vui lòng lưu thay đổi trước.',
        unsavedChangesTitle: 'Thay đổi chưa lưu',
        unsavedChangesContent: 'Bạn có thay đổi chưa được lưu trong cài đặt Giao diện Chat. Bạn muốn làm gì?',
        saveBeforeMainSave: 'Bạn có thay đổi chưa được lưu trong Giao diện Chat. Bạn có muốn lưu trước khi tiếp tục?',
        saveAndContinue: 'Lưu và tiếp tục',
        discardChanges: 'Bỏ thay đổi',
        discardAndContinue: 'Bỏ và tiếp tục',
      },
      tab: {
        instruction: 'Thông tin chung',
        interface: 'Giao diện',
        tasks: 'Công việc',
        publish: 'Xuất bản',
        message: 'Tin nhắn',
        file: 'Đính kèm',
        author: 'Đồng tác giả',
        knowledge: 'Kiến thức',
        payment: 'Thanh toán',
        shareLink: 'Chia sẻ link',
        chatAppearance: 'Giao diện chat',
        knowledgeSkill: 'Kiến thức & Kỹ năng',
        task: 'Nhiệm vụ',
      },
      validation: {
        nameRequired: 'Vui lòng nhập tên trợ lý!',
        folderRequired: 'Vui lòng chọn thư mục trợ lý!',
        positionRequired: 'Vui lòng nhập vai trò trợ lý!',
        languageRequired: 'Vui lòng chọn ngôn ngữ trợ lý!',
        descriptionRequired: 'Vui lòng nhập mô tả trợ lý!',
        instructionRequired: 'Vui lòng nhập hướng dẫn trợ lý!',
        modelParamRequired: 'Vui lòng chọn cách trả lời trợ lý!',
        modelRequired: 'Vui lòng chọn mô hình trợ lý!',
        expiration_dateRequired: 'Hạn sử dụng link không được để trống.',
      },
      modal: {
        pickAvatar: 'Chọn avatar',
        uploadAvatar: 'Tải lên avatar',
        changeAvatar: 'Thay đổi avatar',
      },
      modelParamOptions: {
        exactly: 'Chính xác',
        balanced: 'Cân bằng',
        creative: 'Sáng tạo',
        myPreset: 'Tùy chỉnh',
        temperature: 'Độ sáng tạo',
        topP: 'Đa dạng ý tưởng',
        presencePenalty: 'Tránh lặp lại',
        frequencyPenalty: 'Khuyến khích ý mới',
        maxTokens: 'Giới hạn độ dài',
        tooltip: {
          temperature: 'Tăng để trợ lý diễn đạt phong phú, giảm để trợ lý bám sát hướng dẫn',
          top_p: 'Tăng để câu trả lời đa dạng hơn',
          presence_penalty: 'Tăng để hạn chế lặp từ/câu',
          frequency_penalty: 'Tăng để câu trả lời dễ xuất hiện những nội dung mới',
          max_tokens: 'Tăng để câu trả lời dài và chi tiết hơn',
        },
      },
      coAuthor: {
        title: 'Đồng tác giả',
        descriptionAuthor: 'Cấu hình đồng tác giả cho trợ lý của bạn',
        name: 'Tên',
        position: 'Chức vụ',
        description: 'Mô tả',
        avatar: 'Ảnh đại diện',
        addCoAuthor: 'Thêm đồng tác giả',
        namePlaceholder: 'Nhập tên đồng tác giả',
        positionPlaceholder: 'Nhập chức vụ đồng tác giả',
        descriptionPlaceholder: 'Nhập mô tả đồng tác giả',
        coAuthorInfo: 'Thông tin đồng tác giả',
        removeCoAuthor: 'Xóa đồng tác giả',
        removeCoAuthorContent: 'Bạn có chắc chắn muốn xóa đồng tác giả này?',
        removeCoAuthorSuccess: 'Xóa đồng tác giả thành công',
        removeCoAuthorError: 'Xóa đồng tác giả thất bại',
        validation: {
          name: 'Vui lòng nhập tên đồng tác giả!',
          position: 'Vui lòng nhập chức vụ đồng tác giả!',
          description: 'Vui lòng nhập mô tả đồng tác giả!',
          avatar: 'Vui lòng nhập avatar đồng tác giả!',
        },
      },
    },
    configuration: {
      enterChat: 'Nhập chat',
      tab: {
        instruction: 'Hướng dẫn',
        interface: 'Giao diện',
        tasks: 'Công việc',
        publish: 'Xuất bản',
      },
      interface: {
        title: 'Giao diện chat',
        welcomeMessage: {
          title: 'Tin nhắn chào mừng',
          preview: 'Xem trước',
          edit: 'Chỉnh sửa',
          placeholder: 'Nhập tin nhắn chào mừng',
          description: 'Tin nhắn chào mừng sẽ được hiển thị khi người dùng bắt đầu cuộc trò chuyện mới',
        },
        suggestedMessages: {
          title: 'Tin nhắn gợi ý',
          add: 'Thêm tin nhắn',
          placeholder: 'Nhập tin nhắn gợi ý',
          description: 'Các tin nhắn gợi ý sẽ được hiển thị cho người dùng để họ có thể bắt đầu cuộc trò chuyện dễ dàng hơn',
        },
        messagePlaceholder: {
          title: 'Placeholder tin nhắn',
          placeholder: 'Nhập placeholder',
          description: 'Placeholder sẽ được hiển thị trong ô nhập tin nhắn',
          characterCount: '{count}/50',
        },
        save: 'Lưu',
      },
      instruction: {
        // Section Headers
        agentInformation: 'Thông tin trợ lý',
        brandInformation: 'Thông tin thương hiệu',
        avatar: 'Ảnh đại diện',
        persona: 'Nhân vật',
        instruction: 'Hướng dẫn',

        // Form Labels
        position: 'Vai trò',
        jobBrief: 'Mô tả công việc',
        language: 'Ngôn ngữ',
        brand: 'Thương hiệu',
        businessType: 'Loại hình kinh doanh',
        location: 'Địa điểm',
        description: 'Mô tả',
        name: 'Tên',
        gender: 'Giới tính',
        department: 'Phòng ban',
        agentModel: 'Mô hình trợ lý',

        // Buttons & UI Text
        regenerate: 'Tái tạo',
        preview: 'Xem trước',
        edit: 'Chỉnh sửa',
        save: 'Lưu',

        // Instruction Section
        systemPrompt: 'Lời nhắc hệ thống',
        instructionDescription: 'Hướng dẫn của đại lý được tạo ra dựa trên thông tin của đại lý và thương hiệu. Mẹo: gõ @agent_name để nhắc tên đại lý một cách động.',

        // Fixed content
        itManagerTitle: 'Quản lý CNTT',
        itManagerDescription: 'Giám sát việc phát triển, triển khai và duy trì các hệ thống và cơ sở hạ tầng CNTT.',

        // Select Options
        male: 'Nam',
        female: 'Nữ',
        informationTechnology: 'Công nghệ thông tin',
        marketing: 'Marketing',
        sales: 'Bán hàng',
        english: 'Tiếng Anh',
        vietnam: 'Việt Nam',
      },
    },
    rateAgent: {
      title: 'Đánh giá',
      description: 'Vui lòng chia sẻ suy nghĩ của bạn về trợ lý này...',
      ratingLabel: 'Đánh giá trợ lý',
      commentLabel: 'Viết đánh giá',
      commentPlaceholder: 'Hãy chia sẻ suy nghĩ của bạn về trợ lý này! Có đáp ứng kỳ vọng của bạn không?',
      cancel: 'Hủy',
      submit: 'Đồng ý',
      validation: {
        ratingRequired: 'Vui lòng đánh giá trợ lý',
        commentRequired: 'Vui lòng viết đánh giá',
      },
      reviewSuccess: 'Đánh giá trợ lý thành công',
      daysAgo: 'ngày trước',
      hoursAgo: 'giờ trước',
      minutesAgo: 'phút trước',
      filterByRating: 'Lọc theo đánh giá',
    },
    marketPlace: {
      backToMarket: 'Cửa hàng NextSchool',
      publishAgent: 'Đăng tải trợ lý',
      featuredAgents: 'Trợ lý nổi bật',
      allAgents: 'Tất cả trợ lý',
      searchPlaceholder: 'Tìm kiếm',
      uploadButton: 'Đăng tải',
      areaFilter: 'Lĩnh vực',
      ratingFilter: 'Đánh giá',
      paymentFilter: 'Thanh toán',
      noAgent: 'Không có trợ lý nào',
      noExperience: 'Không có kinh nghiệm',
      priceFilter: 'Giá',
      users: 'Người dùng',
      rating: 'Đánh giá',
      description: 'Mô tả',
      position: 'Vị trí',
      name: 'Tên',
      workplace: 'Nơi làm việc',
      uploadToMarket: 'Đăng tải lên Cửa hàng',
      uploadSuccess: 'Đăng tải thành công',
      uploadFailed: 'Đăng tải thất bại',
      confirmUpload: 'Bạn có chắc chắn muốn đăng tải trợ lý này?',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      addToFolder: 'Thêm vào thư mục',
      free: 'Miễn phí',
      paid: 'Trả phí',
      author: 'Tác giả',
      totalReviews: 'Tổng số đánh giá',
      writeReview: 'Viết đánh giá',
      yourAgent: 'Trợ lý của bạn',
      totalUsage: 'lượt sử dụng',
      pushBackSuccess: 'Xóa trợ lý khỏi thư mục thành công',
      pushBackError: 'Xóa trợ lý khỏi thư mục thất bại',
      sector: 'Lĩnh vực',
      tabDetail: {
        overview: 'Tổng quan',
        experience: 'Kinh nghiệm',
        attachments: 'Tệp đính kèm',
        reviews: 'Đánh giá',
        author: 'Tác giả',
      },
      // Tab
      tab: {
        discoverByCategory: 'Khám phá theo danh mục',
        educationalAssistant: 'Trợ lý giáo dục',
        lessonPlan: 'Kế hoạch giảng dạy',
        eLessonPlan: 'Kế hoạch bài dạy',
        worksheet: 'Phiếu bài tập',
        video: 'Video',
        slide: 'Slide',
        image: 'Ảnh',
      },
      educationalAssistant: {
        featured: 'Trợ lý nổi bật',
        all: 'Tất cả trợ lý',
        noData: 'Không tìm thấy trợ lý nào',
        paid: 'Trả phí',
        free: 'Miễn phí',
      },
      lessonPlan: {
        featured: 'Kế hoạch nổi bật',
        all: 'Tất cả kế hoạch giảng dạy',
        noData: 'Không tìm thấy kế hoạch giảng dạy nào',
        paid: 'Trả phí',
        free: 'Miễn phí',
      },
      eLessonPlan: {
        featured: 'Kế hoạch nổi bật',
        all: 'Tất cả kế hoạch bài dạy',
        noData: 'Không tìm thấy kế hoạch bài dạy nào',
        paid: 'Trả phí',
        free: 'Miễn phí',
      },
      worksheet: {
        featured: 'Phiếu bài tập nổi bật',
        all: 'Tất cả phiếu bài tập',
        noData: 'Không tìm thấy phiếu bài tập nào',
        paid: 'Trả phí',
        free: 'Miễn phí',
        weeks: 'TUẦN HỌC',
      },
      video: {
        featured: 'Video nổi bật',
        all: 'Tất cả video',
        noData: 'Không tìm thấy video nào',
        paid: 'Trả phí',
        free: 'Miễn phí',
        // Modal content
        videoInfo: 'Thông tin video',
        subject: 'Môn học',
        status: 'Trạng thái',
        views: 'Lượt xem',
        rating: 'Đánh giá',
        description: 'Mô tả',
        author: 'Tác giả',
        teacher: 'Giáo viên',
        addToClassroom: 'Thêm vào lớp học',
        download: 'Tải xuống',
        videoNotAvailable: 'Video không khả dụng',
        yourBrowserNotSupport: 'Trình duyệt của bạn không hỗ trợ thẻ video.',
        // Modal actions
        close: 'Đóng',
        play: 'Phát',
        pause: 'Tạm dừng',
        downloadSuccess: 'Tải xuống thành công!',
        downloadError: 'Lỗi khi tải xuống video',
        addToClassroomSuccess: 'Tính năng thêm vào lớp học đang được phát triển',
      },
      slide: {
        featured: 'Bài thuyết trình nổi bật',
        all: 'Tất cả bài thuyết trình',
        noData: 'Không tìm thấy bài thuyết trình nào',
        paid: 'Trả phí',
        free: 'Miễn phí',
      },
      image: {
        featured: 'Hình ảnh nổi bật',
        all: 'Tất cả hình ảnh',
        noData: 'Không tìm thấy hình ảnh nào',
        paid: 'Trả phí',
        free: 'Miễn phí',
        // Modal content
        imageInfo: 'Thông tin hình ảnh',
        status: 'Trạng thái',
        views: 'Lượt xem',
        description: 'Mô tả',
        info: 'Thông tin hình ảnh',
        resolution: 'Độ phân giải',
        aspectRatio: 'Tỷ lệ khung hình',
        model: 'Mô hình',
        createdAt: 'Thời gian tạo',
        defaultDescription: 'Một cô gái phong cách anime đang ngồi trên tàu nghe nhạc, và máy quay chuyển sang góc bên',
        author: 'Tác giả',
        teacher: 'Giáo viên',
        addToClassroom: 'Thêm vào lớp học',
        download: 'Tải xuống',
        // Modal actions
        close: 'Đóng',
        downloadSuccess: 'Tải xuống thành công!',
        downloadError: 'Lỗi khi tải xuống hình ảnh',
        addToClassroomSuccess: 'Tính năng thêm vào lớp học đang được phát triển',
      },
    },
    detail: {
      title: 'Thông tin chi tiết tác giả',
      overview: 'Tổng quan',
      experience: 'Kinh nghiệm',
      attachments: 'Tệp đính kèm',
      reviews: 'Đánh giá',
      mainFunctions: 'Chức năng chính',
      language: 'Ngôn ngữ',
      model: 'Mô hình',
      chatAgent: 'Bắt đầu trò chuyện',
      contactInfo: {
        title: 'Thông tin liên hệ',
        email: 'Email',
        phone: 'Điện thoại',
        workplace: 'Nơi làm việc',
      },
      workExperience: {
        title: 'Kinh nghiệm làm việc',
        company: 'Công ty',
        position: 'Vị trí',
        period: 'Thời gian',
        description: 'Mô tả',
      },
      certificates: {
        title: 'Chứng chỉ và bằng cấp',
        name: 'Tên chứng chỉ',
        issuer: 'Cấp bởi',
        year: 'Năm cấp',
        viewDocument: 'Xem tài liệu',
      },
      reviewSection: {
        title: 'Đánh giá và nhận xét',
        totalReviews: 'Tổng số đánh giá',
        averageRating: 'Đánh giá trung bình',
        writeReview: 'Viết đánh giá',
        rating: 'Đánh giá',
        time: 'Thời gian',
        comment: 'Nhận xét',
      },
      attachmentSection: {
        title: 'Tệp đính kèm',
        name: 'Tên tệp',
        type: 'Loại tệp',
      },
      coAuthorSection: {
        title: 'Đồng tác giả',
        name: 'Tên',
        position: 'Chức vụ',
        description: 'Mô tả',
      },
      awards: {
        title: 'Giải thưởng',
        name: 'Tên giải thưởng',
        issuer: 'Cấp bởi',
        year: 'Năm cấp',
        viewDocument: 'Xem tài liệu',
      },
    },
    uploadAgent: {
      title: 'Đăng tải trợ lý',
      tabTitle: 'Quản lý trợ lý',
      uploadAgentWarning: 'Bạn có chắc chắn muốn đăng tải trợ lý này?',
      noAgent: 'Không có trợ lý nào',
      addToFolder: 'Thêm vào thư mục',
      addToFolderSuccess: 'Thêm vào thư mục thành công',
      addToFolderError: 'Thêm vào thư mục thất bại',
      buttonAddPlaceHolder: 'Chọn thư mục',
      tabs: {
        uploadAgent: 'Đăng tải trợ lý',
        uploadedAgent: 'Đã đăng tải trợ lý',
        uploadAgentDescription: 'Đăng tải trợ lý để chia sẻ với cộng đồng',
        uploadedAgentDescription: 'Trợ lý đã được đăng tải và có thể chia sẻ với cộng đồng',
        uploadAgentButton: 'Đăng tải',
        uploadedAgentButton: 'Xem',
      },
      uploadAgentButton: 'Đăng tải',
      uploadedAgentButton: 'Xem',
      editAgentButton: 'Sửa',
      uploadDrawer: {
        overview: 'Tổng quan',
        title: 'Đăng tải trợ lý',
        description: 'Mô tả trợ lý',
        descriptionPlaceholder: 'Nhập mô tả trợ lý',
        language: 'Ngôn ngữ',
        model: 'Mô hình',
        modelPlaceholder: 'Chọn mô hình',
        experience: 'Kinh nghiệm',
        experiencePlaceholder: 'Nhập kinh nghiệm làm việc',
        validation: {
          description: 'Mô tả không được để trống',
          language: 'Ngôn ngữ không được để trống',
          model: 'Mô hình không được để trống',
          experience: 'Kinh nghiệm không được để trống',
        },
      },
      modal: {
        validation: {
          folderId: 'Thư mục không được để trống',
        },
      },
    },
    languageOptions: {
      vietnamese: 'Tiếng Việt',
      english: 'English',
    },
  },
  chatAgent: {
    greetingTitle: 'Xin chào!',
    greetingIntroPrefix: 'Mình là',
    defaultWelcomeMessage: 'Mình có thể giúp gì cho bạn?',
    suggestionsTitle: 'Tin nhắn gợi ý',
    orEnterQuestion: 'Hoặc nhập câu hỏi của bạn bên dưới.',
    enterQuestion: 'Nhập câu hỏi hoặc yêu cầu của bạn bên dưới.',
  },
  slideGeneration: {
    title: 'Tạo slide',
    description: 'Tạo bài thuyết trình chuyên nghiệp với AI — chỉ cần mô tả chủ đề và để AI tạo ra những slide đẹp mắt và có cấu trúc!',
    quickSlideGeneration: {
      title: 'Tạo slide AI',
      promptPlaceholder: 'Mô tả chủ đề bài thuyết trình của bạn...',
      promptRequired: 'Vui lòng nhập mô tả cho slide',
      generateSlide: 'Tạo slide',
      dictate: 'Nhập bằng giọng nói',
      generationStarted: 'Đã bắt đầu tạo slide!',
      slideCount: {
        title: 'Số lượng slide',
      },
      language: {
        title: 'Ngôn ngữ',
      },
    },
  },
  imageGeneration: {
    title: 'Tạo ảnh',
    dropFilesHere: 'Thả file vào đây',
    description: 'Biểu diễn suy nghĩ của bạn thông qua tác phẩm nghệ thuật — chỉ cần chia sẻ những gì trong đầu bạn, và xem suy nghĩ của bạn biến thành những bức tranh tuyệt đẹp! Ví dụ, một hoàng hôn đẹp trên một hồ trong làn sóng.',
    exampleImages: 'Ảnh mẫu',
    examplePrompts: 'Prompt mẫu',
    exploreIdeas: 'Khám phá các ý tưởng để bắt đầu:',
    generate: 'Tạo',
    generateImage: 'Tạo ảnh',
    generateImageDescription: 'Tạo ảnh dựa trên prompt của bạn',
    generateImageButton: 'Tạo',
    generateImagePlaceholder: 'Nhập prompt của bạn',
    generateImageError: 'Vui lòng nhập prompt!',
    generateImageSuccess: 'Tạo ảnh thành công',
    generatedImages: 'Ảnh đã tạo',
    generating: 'Đang tạo...',
    history: 'Lịch sử',
    generateSettings: 'Cài đặt tạo ảnh',
    regenerate: 'Tái tạo',
    copyPrompt: 'Sao chép prompt',
    usePrompt: 'Sử dụng prompt',
    downloadImage: 'Tải ảnh',
    deleteImage: 'Xóa ảnh',
    deleteImageConfirm: 'Bạn có chắc chắn muốn xóa ảnh này không?',
    deleteImageSuccess: 'Xóa ảnh thành công',
    shareImage: 'Chia sẻ ảnh',
    generateNewImage: 'Tạo ảnh mới',
    pleaseWait: 'Vui lòng chờ',
    generatingImage: 'Đang tạo ảnh...',
    imageDetails: 'Chi tiết ảnh',
    deleteMessage: 'Xóa tin nhắn',
    requiresFileUpload: 'Model chỉnh sửa ảnh yêu cầu bạn tải lên ít nhất một ảnh.',
    // Quick Image Generation Component
    quickImageGeneration: {
      title: 'Tạo ảnh AI',
      promptPlaceholder: 'Mô tả hình ảnh bạn muốn tạo...',
      promptRequired: 'Vui lòng nhập mô tả cho ảnh',
      generateImage: 'Tạo ảnh',
      artStyle: {
        title: 'Chọn phong cách nghệ thuật',
        cinematic: 'Điện ảnh',
        natural: 'Tự nhiên',
        cinematicTooltip: 'Phong cách điện ảnh tạo ra những hình ảnh kịch tính và siêu thực',
        naturalTooltip: 'Phong cách tự nhiên tạo ra những hình ảnh tự nhiên và ít siêu thực hơn',
      },
      background: {
        title: 'Hình nền',
        auto: 'Tự động',
        opaque: 'Mờ đục',
        transparent: 'Trong suốt',
        autoTooltip: 'Hình nền tự động',
        opaqueTooltip: 'Hình nền mờ đục',
        transparentTooltip: 'Hình nền trong suốt',
      },
      aspectRatio: {
        title: 'Tỷ lệ khung hình',
      },
      negativePrompt: {
        title: 'Những yếu tố cần loại bỏ',
        placeholder: 'Nhập những yếu tố cần loại bỏ khỏi hình ảnh',
      },
      numberOfImages: 'Số lượng ảnh:',
      tools: {
        removeBackground: 'Tách nền',
        deleteObject: 'Xóa vật thể',
        changeObject: 'Đổi vật thể',
        sharpen: 'Làm nét ảnh',
        scale: 'Mở rộng ảnh',
      },
    },
    // Quick MindMap Component
    quickMindMap: {
      title: 'Tạo Mindmap',
      promptPlaceholder: 'Mô tả chủ đề để tạo sơ đồ tư duy...',
      promptRequired: 'Vui lòng nhập mô tả cho mindmap',
      generateMindMap: 'Tạo Mindmap',
    },
    // AI Image Tool
    aiImageTool: 'Công cụ tạo ảnh AI',
    aiImageToolTitle: 'Tạo ảnh AI (UNI_IMAGE)',
    prompt: 'Mô tả',
    promptPlaceholder: 'Mô tả hình ảnh bạn muốn tạo...',
    negativePrompt: 'Mô tả loại trừ',
    negativePromptPlaceholder: 'Những gì bạn không muốn...',
    style: 'Phong cách',
    aspectRatio: 'Tỷ lệ khung hình',
    portrait: 'Dọc',
    square: 'Vuông',
    landscape: 'Ngang',
    deleteMessageConfirm: 'Bạn có chắc chắn muốn xóa tin nhắn này không?',
    deleteMessageSuccess: 'Xóa tin nhắn thành công',
    deleteMessageError: 'Xóa tin nhắn thất bại',
    poweredBy: 'Cung cấp bởi',
    uploadImagesForEdit: 'Tải lên ảnh để chỉnh sửa',
    uploadImages: 'Tải lên ảnh',
    clickOrDragToUpload: 'Click hoặc kéo và thả file để tải lên',
    supportedFormats: 'PNG, JPG, WEBP lên đến 10MB',
    uploading: 'Đang tải lên...',
    images: 'ảnh',
    maximumImagesAllowed: 'Chỉ được tải lên tối đa 3 ảnh.',
    selectFilesToReplace: 'Chọn file để thay thế file đã tải lên',
    clearAll: 'Xóa tất cả',
    addMoreImages: 'Thêm ảnh',
    replaceImages: 'Thay thế ảnh',
    uploadedImages: 'Ảnh đã tải lên',
    removeImage: 'Xóa ảnh',
    replaceImage: 'Thay thế ảnh',
    imageToImage: 'Ảnh sang ảnh',
    switchToImageEdit: 'Chuyển sang chỉnh sửa ảnh',
    popover: {
      title: 'Tạo ảnh',
      description: 'Tạo ảnh dựa trên prompt của bạn',
      generate: 'Tạo',
      cancel: 'Hủy',
      chooseArtStyle: 'Chọn kiểu tác phẩm',
      vivid: 'Sắc màu',
      vividDescription: 'Tạo ra những hình ảnh siêu thực và ấn tượng với màu sắc rực rỡ và độ tương phản mạnh mẽ',
      natural: 'Tự nhiên',
      naturalDescription: 'Tạo ra những hình ảnh trông tự nhiên hơn, ít siêu thực với tông màu mềm mại',
      aspectRatio: 'Tỷ lệ khung hình',
      numberOfImages: 'Số lượng ảnh',
      showExamplePrompts: 'Hiển thị prompt mẫu',
      keepPrompt: 'Giữ prompt',
      optimizePrompt: 'Tối ưu hóa prompt',
      optimizePromptDescription: 'Tối ưu hóa prompt để tạo ra kết quả tốt hơn',
      optimizePromptButton: 'Tối ưu hóa',
      optimizePromptSuccess: 'Tối ưu hóa prompt thành công',
      optimizePromptError: 'Tối ưu hóa prompt thất bại',
      optimizePromptLoading: 'Đang tối ưu hóa prompt...',
      optimizePromptRegenerate: 'Tái tạo',
      optimizePromptCopy: 'Sao chép',
      optimizePromptCopySuccess: 'Sao chép prompt thành công',
      optimizePromptCopyError: 'Sao chép prompt thất bại',
      optimizePromptCopyConfirm: 'Bạn có chắc chắn muốn sao chép prompt này không?',
      optimizePromptCopyConfirmSuccess: 'Sao chép prompt thành công',
      optimizePromptCopyConfirmError: 'Sao chép prompt thất bại',
      outputLanguage: 'Ngôn ngữ đầu ra',
      yourPrompt: 'Prompt của bạn',
      enterPromptToOptimize: 'Nhập prompt của bạn để tối ưu...',
      optimizePromptUse: 'Sử dụng',
      optimizedPrompt: 'Prompt đã tối ưu',
      clear: 'Xóa',
      optimizePromptWarning: 'Dall-E 2 có thể không hỗ trợ tốt tiếng Việt, dẫn đến việc đôi khi kết quả không chính xác với nội dung yêu cầu. Để có trải nghiệm tốt hơn với tiếng Việt, bạn nên sử dụng Dall-E 3.',
      // bg
      backgroundImage: 'Hình nền',
      auto: 'Tự động',
      autoDescription: 'Tự động chọn hình nền tốt nhất',
      opaque: 'Đậm',
      opaqueDescription: 'Hình nền đậm, không trong suốt',
      transparent: 'Trong suốt',
      transparentDescription: 'Hình nền trong suốt',
      imageResolution: 'Độ phân giải ảnh',
      imageResolutionPlaceholder: 'Chọn độ phân giải ảnh',
      // NS 1.1
      pages: 'Số lượng ảnh',
      pagesDescription: 'Số lượng ảnh được tạo ra',
      pagesPlaceholder: 'Chọn số lượng ảnh',
      negativePrompt: 'Chi tiết cần tránh',
      negativePromptPlaceholder: 'Nhập chi tiết cần tránh, ví dụ: màu đỏ, màu xanh lá, ...',
      pagesOptions: [
        {
          label: '1 ảnh',
          value: 1,
        },
        {
          label: '2 ảnh',
          value: 2,
        },
      ],
    },
    drawer: {
      title: 'Lịch sử',
      prompt: 'Prompt',
      image: 'Ảnh',
      artStyle: 'Kiểu tác phẩm',
      aspectRatio: 'Tỷ lệ khung hình',
      numberOfImages: 'Số lượng ảnh',
      showExamplePrompts: 'Hiển thị prompt mẫu',
      createdAt: 'Ngày tạo',
      noHistory: 'Không có lịch sử',
      generationTime: 'Thời gian tạo',
      delete: 'Xóa',
      deleteSuccess: 'Xóa ảnh thành công',
      deleteError: 'Xóa ảnh thất bại',
      usePrompt: 'Sử dụng prompt',
      usePromptSuccess: 'Sử dụng prompt thành công',
      usePromptError: 'Sử dụng prompt thất bại',
      usePromptConfirm: 'Bạn có chắc chắn muốn sử dụng prompt này không?',
      conversationName: 'Tên cuộc trò chuyện',
      deleteConversation: 'Xóa cuộc trò chuyện',
      deleteConversationConfirm: 'Bạn có chắc chắn muốn xóa cuộc trò chuyện này không?',
      deleteConversationSuccess: 'Xóa cuộc trò chuyện thành công',
      deleteConversationError: 'Xóa cuộc trò chuyện thất bại',
    },
    modal: {
      title: 'Chi tiết ảnh',
      prompt: 'Prompt',
      model: 'Mô hình',
      size: 'Kích thước',
      style: 'Kiểu tác phẩm',
      generationTime: 'Thời gian tạo',
      createdAt: 'Ngày tạo',
      imageInfo: 'Thông tin ảnh',
      download: 'Tải ảnh',
      variations: 'Biến thể',
      negativePrompt: 'Prompt âm',
      createdTime: 'Thời gian tạo',
      aspectRatio: 'Tỷ lệ khung hình',
      share: 'Chia sẻ',
      findSimilarImage: 'Tìm ảnh tương tự prompt',
      findSimilarImageDescription: 'Tìm ảnh tương tự dựa trên mô tả',
      describeYourImage: 'Mô tả ảnh của bạn',
      describeYourImagePlaceholder: 'Nhập mô tả ảnh của bạn. Ví dụ: Một hoàng hôn đẹp trên một hồ trong làn sóng.',
      searchingYourImage: 'Đang tìm kiếm ảnh của bạn...',
      pleaseWait: 'Vui lòng chờ',
      startSearching: 'Bắt đầu tìm kiếm',
      startSearchingDescription: 'Nhập mô tả ảnh của bạn và nhấn nút "Tìm kiếm"',
      noResults: 'Không tìm thấy kết quả',
      noResultsDescription: 'Không tìm thấy kết quả',
      noResultsButton: 'Thử lại',
      noResultsButtonDescription: 'Thay đổi từ khóa tìm kiếm hoặc mô tả ảnh của bạn',
      result: 'Kết quả',
      resultDescription: 'Kết quả của ảnh của bạn',
      resultButton: 'Xem',
      resultButtonDescription: 'Xem kết quả của ảnh của bạn',
      similarityScore: 'Độ tương đồng',
      detail: 'Chi tiết',
      clickImageToSeeDetail: 'Click ảnh để xem chi tiết',
      totalFound: 'Tổng cộng',
      image: 'ảnh',
      usePrompt: 'Sử dụng prompt',
    },
  },
  folder: {
    create: 'Tạo thư mục',
    folderName: 'Tên thư mục',
    empty: 'Thư mục trống',
    titleDelete: 'Xóa thư mục',
    contentDeleteTopLeft: 'Xóa thư mục này bạn sẽ xóa ',
    contentDeleteTopRight: '.',
    contentDeleteBottom: 'Bạn có chắc chắn muốn xóa thư mục này không?',
  },
  settings: {
    title: 'Thiết lập workspace',
    orgUnit: 'Thông tin tổ chức',
    workspaceInfo: 'Thông tin workspace',
    workspaceInfoTab: {
      title: 'Thông tin đơn vị',
      subTitle: 'Thông tin chung đơn vị',
      workspaceName: 'Tên đơn vị',
      workspaceNamePlaceholder: 'Nhập tên đơn vị',
      sector: 'Lĩnh vực',
      description: 'Mô tả',
      location: 'Địa điểm',
      url: 'Website, fanpage, ...',
      language: 'Ngôn ngữ',
      updateSuccess: 'Cập nhật thông tin workspace thành công',
      updateError: 'Cập nhật thông tin workspace thất bại',
      address: 'Địa chỉ',
      addressPlaceholder: 'Nhập địa chỉ đơn vị',
      educationalLevel: 'Cấp học',
      educationalLevelPlaceholder: 'Chọn cấp học',
      website: 'Website (nếu có)',
      websitePlaceholder: 'Nhập website (nếu có)',
      gradingScale: 'Thang điểm sử dụng',
      gradingScalePlaceholder: 'Chọn thang điểm sử dụng',
      userRole: 'Vai trò trong đơn vị',
      userRolePlaceholder: 'Nhập vai trò trong đơn vị',
      urlDescription: 'Ảnh logo đơn vị',
      submitEdit: 'Sửa thông tin',
      submitSave: 'Lưu thay đổi',
      adminInfoTitle: 'Thông tin người quản trị đơn vị',
      changeAdmin: 'Thay đổi người quản trị',
      changeAdminDescription: 'Chọn người quản trị mới cho đơn vị. <br/><strong>Lưu ý</strong>: Sau khi chuyển giao, người mới sẽ nắm toàn quyền quản lý thông tin của đơn vị',
    },
    operationHistory: 'Lịch sử hoạt động',
    operationHistoryTab: {
      title: 'Lịch sử hoạt động',
      fromDate: 'Từ ngày',
      toDate: 'Đến ngày',
      refresh: 'Nạp lại',
      table: {
        name: 'Tên',
        email: 'Email',
        role: 'Vai trò',
        detail: 'Chi tiết',
        time: 'Thời gian',
      },
    },
    orgUnitEdit: 'Sửa thông tin tổ chức',
    userManagement: 'Quản lý người dùng',
    userManagementTab: {
      member: 'Thành viên',
      roleSetting: 'Cài đặt vai trò',
      title: 'Quản lý người dùng',
      addUser: 'Thêm người dùng',
      editUser: 'Sửa người dùng',
      deleteUser: 'Xóa người dùng',
      userName: 'Tên người dùng',
      email: 'Email',
      role: 'Vai trò',
      status: 'Trạng thái',
      action: 'Hành động',
      phone: 'Số điện thoại',
      selectUsers: 'Chọn người dùng',
      emailInstructions: 'Nhập nhiều email',
      addEmail: 'Thêm email',
      howTypeEmailDescription: 'Nhập nhiều email cách nhau bởi dấu phẩy, dấu chấm phẩy hoặc xuống dòng và nhấn Enter',
      invalidEmail: 'Địa chỉ email không hợp lệ',
      invalidEmailDescription: 'Bạn có thể chỉnh sửa các địa chỉ email này sau khi đóng thông báo này.',
      invalidEmailModal: 'Địa chỉ email không hợp lệ',
      duplicateEmails: 'Email trùng lặp',
      duplicateEmailsDescription: 'Các email này đã tồn tại trong danh sách',
      closeToFix: 'Đóng để sửa',
      emailValidationIssues: 'Những email không hợp lệ',
      userList: 'Danh sách người dùng',
      note: 'Ghi chú',
      selectRole: 'Chọn vai trò',
      createdBy: 'Người tạo',
      updateRole: 'Cập nhật vai trò người dùng',
      currentRole: 'Vai trò hiện tại',
      newRole: 'Vai trò mới',
      noRole: 'Chưa có vai trò',
      userGroup: 'Nhóm người dùng',
      addUserGroup: 'Thêm nhóm người dùng',
      editUserGroup: 'Sửa nhóm người dùng',
      setupUserGroup: 'Thiết lập nhóm người dùng',
      chooseSetupGroup: 'Chọn nhóm người dùng',
      groupList: 'Danh sách nhóm',
      addUserGroupButton: 'Thêm nhóm người dùng',
      nameGroup: 'Tên nhóm người dùng',
      nameGroupPlaceholder: 'Nhập tên nhóm người dùng',
      titleDeleteGroup: 'Xác nhận xóa nhóm người dùng',
      contentDeleteGroup: 'Hệ thống sẽ xóa nhóm người dùng này khỏi danh sách cấu hình. Tất cả người dùng đang thuộc nhóm sẽ được gỡ khỏi nhóm này, nhưng tài khoản của họ vẫn được giữ nguyên và có thể gán vào các nhóm khác.',
      contentDeleteGroupConfirm: 'Thao tác này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục?',
      requestJoin: 'Yêu cầu tham gia',
      requestTitle: 'Yêu cầu tham gia đơn vị',
      requestDescription: 'Yêu cầu tham gia đơn vị của giáo viên đang chờ thầy/cô phê duyệt.<br/>Thầy/cô có thể thay đổi danh sách sau này trong mục Quản lý người dùng.',
      approve: 'Phê duyệt',
      fullName: 'Họ và tên',
      titleApprove: 'Phê duyệt yêu cầu tham gia đơn vị',
      contentApprove: 'Đơn vị sẽ được yêu cầu tham gia đơn vị và hiển thị khi người dùng sử dụng phần mềm. Bạn có muốn phê duyệt không?',
      titleReject: 'Từ chối yêu cầu tham gia đơn vị',
      contentReject: 'Yêu cầu tham gia đơn vị sẽ bị từ chối. Bạn có muốn hủy yêu cầu này không?',
      emailUser: 'Email người dùng',
    },
    userManagementDropdown: {
      userInfo: 'Thông tin người dùng',
      roleSetting: 'Cài đặt vai trò',
      securitySettings: 'Thiết lập bảo mật',
      logout: 'Đăng xuất',
      classInfo: 'Thông tin lớp học',
      workspaceInfo: 'Thông tin đơn vị',
      systemSettings: 'Cài đặt hệ thống',
      textbook: 'Sách giáo khoa',
      teacherBook: 'Sách giáo viên',
      toolManagement: 'Cấu hình công cụ',
      decreeCircular: 'Nghị định thông tư',
    },
    textbookDetail: {
      backToList: 'Quay lại danh sách',
      grade: 'Cấp',
      publishBook: 'Xuất bản bộ sách',
      addBook: 'Thêm bộ sách',
      editBook: 'Sửa bộ sách',
      addLesson: 'Thêm bài học',
      editLesson: 'Sửa bài học',
      addChildLesson: 'Thêm bài học con',
      editChildLesson: 'Sửa bài học con',
      deleteBook: 'Xóa bộ sách',
      deleteLesson: 'Xóa bài học',
      deleteChildLesson: 'Xóa bài học con',
      deleteBookContent: 'Khi xóa bộ sách, toàn bộ các file đã tải lên gồm sách giáo khoa và sách giáo viên tương ứng của bộ sách sẽ bị xóa.',
      deleteLessonContent: 'Khi xóa bài học, toàn bộ các file đã tải lên gồm sách giáo khoa và sách giáo viên tương ứng của bài học sẽ bị xóa.',
      deleteChildLessonContent: 'Khi xóa bài học con, toàn bộ các file đã tải lên gồm sách giáo khoa và sách giáo viên tương ứng của bài học con sẽ bị xóa.',
      deleteBookConfirm: 'Bạn có chắc chắn muốn xóa bộ sách không?',
      deleteLessonConfirm: 'Bạn có chắc chắn muốn xóa bài học không?',
      deleteChildLessonConfirm: 'Bạn có chắc chắn muốn xóa bài học con không?',
      searchPlaceholder: 'Tìm kiếm bộ sách, bài học...',
      unit: 'Unit',
      lesson: 'Bài học',
      chapter: 'Chapter',
      statusPublished: 'Sách giáo viên',
      statusProgress: 'Đang cập nhật',
      addUnit: 'Thêm unit',
      viewPdf: 'Xem PDF',
      preview: 'Xem trước',
      edit: 'Chỉnh sửa',
      more: 'Thêm',
      // Textbook List Table
      order: 'Thứ tự',
      name: 'Tên',
      subject: 'Môn học',
      textbookSet: 'Số bộ sách',
      listGrades: 'Danh sách lớp học',
      lastSystemPublish: 'Publish hệ thống lần cuối',
      lastUpdate: 'Cập nhật lần cuối',
      loading: 'Đang tải...',
      loadTextbookStructureError: 'Không thể tải cấu trúc sách giáo khoa',
      note: 'Lưu ý',
      lessonName: 'Tên bài học',
      lessonNamePlaceholder: 'Nhập tên bài học',
      bookInfoMessage: 'Bộ sách sau khi thêm sẽ hiển thị đồng thời tại sách giáo khoa và sách giáo viên.',
      lessonInfoMessage: 'Bài học sau khi thêm sẽ hiển thị đồng thời tại sách giáo khoa và sách giáo viên.',
      childLessonInfoMessage: 'Bài học con sau khi thêm sẽ hiển thị đồng thời tại sách giáo khoa và sách giáo viên.',
      lessonNameRequired: 'Vui lòng nhập tên bài học',
      addAgentDocument: 'Thêm tài liệu trợ lý',
      addPdfDocument: 'Thêm tài liệu PDF',
      pdfOnly: 'Chỉ hỗ trợ file PDF',
      missingGradeSubject: 'Thiếu thông tin cấp học hoặc môn học',
      missingTextbookStructureId: 'Thiếu thông tin cấu trúc sách giáo khoa',
      creatingAgentDocument: 'Đang tạo tài liệu trợ lý',
      pleaseWait: 'Vui lòng đợi trong giây lát',
      addAgentDocumentSuccess: 'Thêm tài liệu trợ lý thành công',
      closingAutomatically: 'Đóng tự động sau 2 giây',
      unpublishBook: 'Hủy xuất bản bộ sách',
      published: 'Đã xuất bản',
      notPublished: 'Chưa xuất bản',
      publishSuccess: 'Xuất bản bộ sách thành công',
      unpublishSuccess: 'Hủy xuất bản bộ sách thành công',
      noStructuresToPublish: 'Không có cấu trúc nào để xuất bản',
      publishConfirmMessage: 'Thực hiện áp dụng các bộ sách của môn {subject} {grade} lên toàn bộ hệ thống. Việc áp dụng có thể ảnh hưởng tới tham số về sách giáo khoa của các công cụ.',
      publishConfirmQuestion: 'Bạn có chắc chắn muốn publish bộ sách không?',
      // Decree Circular
      missingGradeSubjectId: 'Thiếu thông tin grade_subject_id',
      pleaseUploadFile: 'Vui lòng tải lên file',
      fileNotUploadedSuccessfully: 'File chưa được tải lên thành công',
      uploadDecreeCircularSuccess: 'Tải lên nghị định thông tư thành công',
      uploadingDecreeCircular: 'Đang tải lên nghị định thông tư...',
      closingAutomaticallyDecreeCircular: 'Đang đóng tự động...',
      viewDecreeCircularTooltip: 'Xem thông tư {name}',
      addDecreeCircularTooltip: 'Thêm thông tư',
      addFileViewPdf: 'Thêm file view (PDF)',
    },
    roleManagementTab: {
      title: 'Cài đặt vai trò',
      addRole: 'Thêm vai trò',
      editRole: 'Sửa vai trò',
      deleteRole: 'Xóa vai trò',
      roleName: 'Tên vai trò',
      description: 'Mô tả',
      permissions: 'Quyền',
      functionName: 'Tên chức năng',
      functionCode: 'Mã chức năng',
      status: 'Trạng thái',
      action: 'Hành động',
      active: 'Hoạt động',
      inactive: 'Không hoạt động',
      createSuccess: 'Tạo vai trò thành công',
      updateSuccess: 'Cập nhật vai trò thành công',
      deleteSuccess: 'Xóa vai trò thành công',
      createError: 'Tạo vai trò thất bại',
      updateError: 'Cập nhật vai trò thất bại',
      deleteError: 'Xóa vai trò thất bại',
      confirmDelete: 'Bạn có chắc chắn muốn xóa vai trò này?',
      selectFunctions: 'Chọn chức năng',
      noFunctionsSelected: 'Chưa có chức năng nào được chọn',
      validation: {
        roleName: 'Vui lòng nhập tên vai trò',
        roleCode: 'Vui lòng chọn mã vai trò',
        description: 'Vui lòng nhập mô tả',
        functions: 'Vui lòng chọn ít nhất một chức năng',
      },
      searchPlaceholder: 'Tìm kiếm vai trò',
      roleCode: 'Mã vai trò',
    },
    workspaceSettings: {
      title: 'Thiết lập workspace',
      workspaceInfo: 'Thông tin workspace',
      workspaceApprove: 'Phê duyệt workspace',
      activity: 'Nhật ký hoạt động',
      userManagement: 'Quản lý người dùng',
      roleManagement: 'Cài đặt vai trò',
      notification: 'Thông báo',
      parameterConfiguration: 'Cấu hình tham số',
      apiServiceConfiguration: 'Cấu hình hệ thống thanh toán/tín dụng',
      interface: 'Giao diện',
      pendingApproval: 'Chờ xét duyệt',
      approved: 'Đã xét duyệt',
      rejected: 'Đã từ chối',
      revocationRequest: 'Yêu cầu thu hồi',
      email: 'Email',
      phone: 'Số điện thoại',
      organizationName: 'Tên đơn vị đăng ký',
      requestDate: 'Ngày yêu cầu',
      approvalDate: 'Ngày phê duyệt',
      requestRevocationDate: 'Ngày thu hồi yêu cầu',

      approve: 'Phê duyệt',
      titleApprove: 'Phê duyệt thêm mới đơn vị',
      contentApprove: 'Đơn vị sẽ được thêm mới và hiển thị khi người dùng sử dụng phần mềm. Bạn có muốn phê duyệt không?',
      titleReject: 'Từ chối thêm mới đơn vị',
      contentReject: 'Yêu cầu đăng ký đơn vị sẽ bị từ chối. Bạn có muốn hủy yêu cầu này không?',
      imageApprove: 'Phê duyệt ảnh',
      aiModel: 'Model AI',
      systemSettings: 'Thiết lập hệ thống',
      notificationConfig: {
        columns: {
          id: 'ID',
          featureCluster: 'Cụm tính năng',
          displayType: 'Loại hiển thị',
          channel: 'Kênh',
          notificationName: 'Tên thông báo',
          eventType: 'Loại sự kiện',
          eventKey: 'Mã sự kiện',
          target: 'Đối tượng',
          effectiveTime: 'Thời gian hiệu lực',
          status: 'Trạng thái',
          lastUpdated: 'Cập nhật gần nhất',
          actions: 'Thao tác',
        },
        filters: {
          featureCluster: 'Cụm tính năng',
          displayType: 'Loại hiển thị',
          eventType: 'Loại sự kiện',
          status: 'Trạng thái',
          filter: 'Bộ lọc',
          apply: 'Áp dụng',
          clear: 'Xóa bộ lọc',
        },
        featureClusters: {
          system: 'Hệ thống',
          credit: 'Credit',
          lesson: 'Bài học',
          test: 'Bài kiểm tra',
          member: 'Thành viên',
        },
        displayTypes: {
          banner: 'Banner',
          notiBell: 'Noti-bell',
        },
        eventTypes: {
          autoScheduleBased: 'Tự động - Dựa trên lịch',
          manualOnLogin: 'Tự động - Đăng nhập',
          autoEventBased: 'Tự động - Dựa trên sự kiện',
        },
        statuses: {
          active: 'Đang hoạt động',
          waiting: 'Chờ đến ngày',
          expired: 'Đã hết hạn',
          paused: 'Đang tạm dừng',
        },
        actions: {
          edit: 'Chỉnh sửa',
          delete: 'Xóa',
          addBanner: 'Thêm banner',
          addNotiBell: 'Thêm thông báo',
          addNew: 'Thêm mới',
          deleteSuccess: 'Xóa thông báo banner thành công',
          deleteError: 'Có lỗi xảy ra khi xóa thông báo banner',
          deleteConfirm: 'Bạn có chắc chắn muốn xóa thông báo banner này không?',
        },
        messages: {
          errorLoading: 'Có lỗi xảy ra khi tải dữ liệu',
          realtime: 'Thời gian thực',
        },
        bannerForm: {
          title: {
            create: 'Thông báo banner',
            edit: 'Sửa thông báo banner',
          },
          fields: {
            id: 'ID',
            featureCluster: 'Cụm tính năng',
            channel: 'Channel',
            notificationType: 'Loại thông báo',
            notificationName: 'Tên thông báo',
            eventType: 'Event type',
            reDisplayAfter: 'Tái hiển thị banner sau',
            targetUsers: 'Đối tượng hướng tới',
            workspaces: 'Danh sách các workspace đã được xét duyệt',
            startDate: 'Ngày bắt đầu',
            endDate: 'Ngày kết thúc',
            redirectUrl: 'Redirect',
            image: 'Đính kèm',
            attach: 'Đính kèm',
            status: 'Trạng thái',
          },
          placeholders: {
            featureCluster: 'Chọn cụm tính năng',
            channel: 'Chọn channel',
            notificationType: 'Chọn loại thông báo',
            notificationName: 'Nhập tên thông báo',
            reDisplayAfter: 'Chọn thời gian tái hiển thị',
            targetUsers: 'Chọn đối tượng',
            workspaces: 'Chọn workspace',
            startDate: 'Chọn ngày bắt đầu',
            endDate: 'Chọn ngày kết thúc',
            redirectUrl: 'Nhập URL điều hướng',
            status: 'Chọn trạng thái',
          },
          reDisplayAfter: {
            'nextLogin': 'Lần đăng nhập tiếp theo',
            '1day': '1 ngày',
            '3days': '3 ngày',
            '7days': '7 ngày',
            'noRedisplay': 'Không hiển thị lại trong thời gian campaign',
          },
          targetUsers: {
            all: 'Tất cả',
            admin: 'Admin',
            teacher: 'Giáo viên',
            student: 'Học sinh',
          },
          validation: {
            featureCluster: 'Vui lòng chọn cụm tính năng',
            channel: 'Vui lòng chọn channel',
            notificationType: 'Vui lòng chọn loại thông báo',
            notificationName: 'Vui lòng nhập tên thông báo',
            targetUsers: 'Vui lòng chọn ít nhất một đối tượng',
            startDate: 'Vui lòng chọn ngày bắt đầu',
            endDate: 'Vui lòng chọn ngày kết thúc',
            dateRange: 'Vui lòng chọn khoảng thời gian',
            endDateAfterStartDate: 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
            endDateAfterNow: 'Ngày kết thúc phải lớn hơn thời gian hiện tại',
            image: 'Vui lòng đính kèm hình ảnh banner',
          },
          actions: {
            create: 'Thêm mới',
            uploadImage: 'Tải lên hình ảnh',
          },
          messages: {
            createSuccess: 'Tạo banner thành công',
            createError: 'Tạo banner thất bại',
            updateSuccess: 'Cập nhật banner thành công',
            updateError: 'Cập nhật banner thất bại',
            submitError: 'Có lỗi xảy ra khi gửi form',
            loadError: 'Có lỗi xảy ra khi tải thông tin banner',
            imageUploadSuccess: 'Tải lên hình ảnh thành công',
            imageUploadError: 'Tải lên hình ảnh thất bại',
            invalidImageType: 'Chỉ chấp nhận file ảnh (JPEG, PNG, GIF, WebP)',
            imageTooLarge: 'Kích thước file không được vượt quá 10MB',
          },
        },
        bellForm: {
          title: {
            create: 'Thông báo notification bell',
            edit: 'Sửa thông báo notification bell',
          },
          fields: {
            id: 'ID',
            featureCluster: 'Cụm tính năng',
            channel: 'Channel',
            notificationType: 'Loại thông báo',
            notificationName: 'Tên thông báo',
            eventType: 'Event type',
            eventKey: 'Event key',
            sendTiming: 'Thời điểm gửi',
            groupWindow: 'Tổng hợp thông báo trong',
            scheduleType: 'Loại Schedule',
            bannerId: 'ID banner',
            deadline: 'Thời hạn',
            messageVi: 'Message tiếng Việt',
            messageEn: 'Message tiếng Anh',
            redirect: 'Redirect',
            targetUsers: 'Đối tượng hướng tới',
            workspaces: 'Danh sách các workspace đã được xét duyệt',
            status: 'Trạng thái',
            startDate: 'Ngày bắt đầu',
            endDate: 'Ngày kết thúc',
          },
          placeholders: {
            featureCluster: 'Chọn cụm tính năng',
            channel: 'Chọn channel',
            notificationType: 'Chọn loại thông báo',
            notificationName: 'Nhập tên thông báo',
            eventKey: 'Nhập event key để xác định khi nào sự kiện xảy ra',
            sendTiming: 'Chọn thời điểm gửi',
            groupWindow: 'Chọn cửa sổ tổng hợp',
            scheduleType: 'Chọn loại schedule',
            bannerId: 'Chọn ID banner',
            deadline: 'Chọn thời hạn',
            messageVi: 'Nhập message tiếng Việt',
            messageEn: 'Nhập message tiếng Anh',
            redirect: 'Nhập URL điều hướng',
            targetUsers: 'Chọn đối tượng',
            workspaces: 'Chọn workspace',
            status: 'Chọn trạng thái',
            startDate: 'Chọn ngày bắt đầu',
            endDate: 'Chọn ngày kết thúc',
          },
          validation: {
            featureCluster: 'Vui lòng chọn cụm tính năng',
            channel: 'Vui lòng chọn channel',
            notificationType: 'Vui lòng chọn loại thông báo',
            notificationName: 'Vui lòng nhập tên thông báo',
            eventType: 'Vui lòng chọn event type',
            eventKey: 'Vui lòng nhập event key',
            sendTiming: 'Vui lòng chọn thời điểm gửi',
            groupWindow: 'Vui lòng chọn cửa sổ tổng hợp',
            scheduleType: 'Vui lòng chọn loại schedule',
            bannerId: 'Vui lòng chọn ID banner',
            deadline: 'Vui lòng chọn thời hạn',
            messageVi: 'Vui lòng nhập message tiếng Việt',
            messageEn: 'Vui lòng nhập message tiếng Anh',
            targetUsers: 'Vui lòng chọn ít nhất một đối tượng',
          },
          actions: {
            create: 'Thêm mới',
          },
          messages: {
            createSuccess: 'Tạo notification bell thành công',
            createError: 'Tạo notification bell thất bại',
            updateSuccess: 'Cập nhật notification bell thành công',
            updateError: 'Cập nhật notification bell thất bại',
            loadError: 'Có lỗi xảy ra khi tải thông tin notification bell',
          },
        },
      },
    },
    aiModel: {
      title: 'Model AI',
      editTitle: 'Sửa model',
      addTitle: 'Thêm model',
      logoCode: 'Mã logo',
      modelCode: 'Mã model',
      modelName: 'Tên model',
      description: 'Mô tả',
      provider: 'Nhà cung cấp',
      type: 'Loại',
      creditCost: 'Credit tiêu thụ',
      status: 'Trạng thái',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      typeBasic: 'Cơ bản',
      typeAdvanced: 'Nâng cao',
      providerAll: 'Tất cả',
    },
    systemSettings: {
      creditBonus: 'Credit Bonus',
      systemUsers: 'Người dùng hệ thống',
      baseCredit: 'Credit cơ bản',
      baseCreditPlaceholder: 'Nhập credit cơ bản',
      advanceCredit: 'Credit nâng cao',
      advanceCreditPlaceholder: 'Nhập credit nâng cao',
      addUser: 'Thêm người dùng',
      bulkEditCredit: 'Sửa credit hàng loạt',
      editCreditMultipleUsers: 'Nhiều người dùng',
      editCreditMultipleUsersTitle: 'Sửa credit hàng loạt nhiều người dùng',
      editCreditByWorkspace: 'Theo workspace',
      editCreditByWorkspaceTitle: 'Sửa credit hàng loạt theo workspace',
      editCredit: 'Sửa Credit',
      addUserSuccess: 'Thêm mới người dùng thành công',
      addUserFail: 'Thêm mới người dùng thất bại',
      titleDelete: 'Xóa người dùng',
      contentDelete: 'Người dùng sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      deleteUserSuccess: 'Xóa người dùng thành công',
      deleteUserFail: 'Xóa người dùng thất bại',
      updateUserSuccess: 'Cập nhật người dùng thành công',
      updateUserFail: 'Cập nhật người dùng thất bại',
      emailUser: 'Email người dùng',
      emailUserPlaceholder: 'Chọn email người dùng',
    },
  },
  auth: {
    title: 'Tập hợp đội AI của bạn',
    signup_google: 'Đăng ký bằng Google',
    login_google: 'Đăng nhập bằng Google',
    continue_google: 'Tiếp tục với Google',
    or: 'hoặc',
    name: 'Tên',
    account: 'Tài khoản',
    email: 'Email',
    emailPlaceholder: 'Nhập email',
    password: 'Mật khẩu',
    new_password: 'Mật khẩu mới',
    confirm_password: 'Nhập lại mật khẩu',
    confirm_new_password: 'Nhập lại mật khẩu',
    agree_terms: 'Bằng việc đăng ký, bạn đồng ý với điều khoản',
    signup: 'Đăng ký',
    have_account: 'Bạn đã có tài khoản?',
    no_account: 'Bạn không có tài khoản?',
    login: 'Đăng nhập',
    forgot_password: 'Quên mật khẩu',
    reset_password: 'Quên mật khẩu',
    recover_password: 'Khôi phục mật khẩu',
    submit: 'Gửi',
    registerAccount: 'Đăng ký tài khoản',
    firstName: 'Tên',
    lastName: 'Họ',
    firstNamePlaceholder: 'Nhập tên và tên đệm',
    lastNamePlaceholder: 'Nhập họ',
    verifyEmailDescription: 'Hệ thống đã gửi mã xác nhận đến email của thầy/cô.<br/>Vui lòng kiểm tra <strong>hộp thư đến</strong> hoặc  <strong>thư rác (spam)</strong> để nhận mã và nhập vào bên dưới để bắt đầu sử dụng hệ thống.',
    verifyEmailDescriptionStudent: 'Hệ thống đã gửi mã xác nhận đến email của bạn.<br/>Vui lòng kiểm tra <strong>hộp thư đến</strong> hoặc  <strong>thư rác (spam)</strong> để nhận mã và nhập vào bên dưới để bắt đầu sử dụng hệ thống.',
    verifyCodePlaceholder: 'Nhập mã xác nhận',
    getStarted: 'Bắt đầu sử dụng',
    next: 'Tiếp tục',
    continue: 'Tiếp tục',
    useNextSchoolTitle: 'Chọn cách thầy/cô muốn sử dụng NextSchool',
    useNextSchoolDescription: 'NextSchool có thể được dùng trong không gian của trường hoặc độc lập cho riêng thầy/cô.',
    individual: 'Cá nhân',
    individualDescription: 'Tạo lớp học và bài giảng riêng. Sử dụng NextSchool theo cách linh hoạt và độc lập.',
    organization: 'Trường',
    organizationDescription: 'Thầy/cô sẽ được Hiệu trưởng/Phó Hiệu trưởng phân công vào lớp.',
    chooseOrganization: 'Chọn đơn vị trường',
    chooseOrganizationJoin: 'Chọn đơn vị trường để tham gia',
    addOrganization: 'Thêm mới đơn vị sử dụng',
    startClass: 'Bắt đầu với lớp học đầu tiên',
    start: 'Bắt đầu',
    organizationNewTitle: 'Nhập tên đơn vị đăng ký',
    organizationNewDescription: 'Sau khi thầy/cô gửi yêu cầu, hệ thống sẽ chuyển thông tin đến NextSchool để phê duyệt. Khi đơn vị được xác nhận, thầy/cô sẽ nhận thông báo qua email để hoàn tất đăng ký và bắt đầu sử dụng hệ thống.',
    organizationName: 'Tên đơn vị đăng ký',
    organizationNamePlaceholder: 'Nhập tên đơn vị đăng ký',
    organizationPhone: 'Số điện thoại liên hệ',
    organizationPhonePlaceholder: 'Nhập số điện thoại liên hệ',
    submitRegistrationRequest: 'Gửi yêu cầu đăng ký',
    submitRegistrationRequestSuccess: 'Gửi yêu cầu đăng ký đơn vị thành công',
    registrationRequestTitle: 'Hệ thống NextSchool đã tiếp nhận yêu cầu đăng ký đơn vị của thầy cô.',
    registrationRequestDescription: 'Khi đơn vị được xác nhận, thầy/cô sẽ nhận thông báo qua email để hoàn tất đăng ký và bắt đầu sử dụng hệ thống.',
    startTrial: 'Bắt đầu dùng thử',
    cancelBack: 'Hủy yêu cầu đăng ký và quay lại',
    cancelJoinBack: 'Hủy yêu cầu tham gia và quay lại',
    registrationFail: 'Đăng ký đơn vị không thành công',
    registrationFailTitle: 'Yêu cầu đăng ký đơn vị của thầy/cô chưa được phê duyệt theo thông tin.',
    registrationFailDescription: 'Thầy/cô có thể chuyển sang không gian cá nhân để tiếp tục sử dụng NextSchool hoặc liên hệ đội ngũ chăm sóc khách hàng của NextSchool để được hỗ trợ.',
    registrationUnitSuccess: 'Đăng ký đơn vị thành công',
    registrationUnitSuccessTitle: 'Đơn vị của thầy/cô đã được phê duyệt và đăng ký thành công trên hệ thống NextSchool.',
    registrationUnitSuccessDescription: 'Thầy/cô có thể bắt đầu sử dụng đầy đủ các tính năng của NextSchool ngay bây giờ.',
    createPersonalSpace: 'Tạo không gian cá nhân',
    continueGoogleTitle: 'Email đã được sử dụng để đăng nhập bằng Google',
    continueGoogleDescription: 'Tài khoản của thầy/cô đã tồn tại. Vui lòng đăng nhập bằng Google để tiếp tục. Nếu cần dùng mật khẩu, thầy/cô có thể thêm mật khẩu sau khi đăng nhập.',
    continueGoogleDescriptionStudent: 'Tài khoản của bạn đã tồn tại. Vui lòng đăng nhập bằng Google để tiếp tục. Nếu cần dùng mật khẩu, bạn có thể thêm mật khẩu sau khi đăng nhập.',
    emailRestoreDescription: 'Hệ thống sẽ gửi mã xác nhận đến email của thầy cô. Vui lòng nhập email cần khôi phục mật khẩu.',
    emailRestoreDescriptionStudent: 'Hệ thống sẽ gửi mã xác nhận đến email của bạn. Vui lòng nhập email cần khôi phục mật khẩu.',
    getVerificationCode: 'Nhận mã xác nhận',
    emailRestorePlaceholder: 'Nhập email tài khoản cần khôi phục',
    emailRestoreVerifyCodeDescription: 'Nhập mã xác nhận để khôi phục mật khẩu.',
    emailRestoreVerifyCodePlaceholder: 'Nhập mã xác nhận đã gửi đến email của thầy/cô',
    forgotPasswordDescription: 'Vui lòng đặt lại mật khẩu.',
    updatePasswordSuccess: 'Cập nhật mật khẩu thành công',
    updatePasswordSuccessDescription: 'Hệ thống đã cập nhật mật khẩu của thầy cô thành công. Vui lòng đăng nhập lại để sử dụng.',
    updatePasswordSuccessDescriptionStudent: 'Hệ thống đã cập nhật mật khẩu của bạn thành công. Vui lòng đăng nhập lại để sử dụng.',
    setup_password: 'Thiết lập mật khẩu',
    setupPasswordDescription: 'Sau khi hoàn tất việc thiết lập mật khẩu, thầy/cô có thể sử dụng email này làm tài khoản đăng nhập hệ thống.',
    login_email: 'Email đăng nhập',
    change_password: 'Đổi mật khẩu',
    current_password: 'Mật khẩu hiện tại',
    changePasswordSuccess: 'Đổi mật khẩu thành công',
    changePasswordFailed: 'Đổi mật khẩu thất bại',
    personal_information: 'Thông tin cá nhân',
    update_personal_information: 'Cập nhật thông tin cá nhân',
    full_name: 'Họ và tên',
    phone: 'Số điện thoại',
    phonePlaceholder: 'Nhập số điện thoại',
    address: 'Địa chỉ',
    addressPlaceholder: 'Nhập địa chỉ chi tiết đơn vị',
    skip: 'Bỏ qua',
    update: 'Cập nhật',
    updateProfileSuccess: 'Cập nhật thông tin thành công',
    updateProfileFailed: 'Cập nhật thông tin thất bại',
    registrationSuccessTitle: 'Đăng ký tài khoản thành công',
    registrationDescription: 'Thầy/cô đã đăng ký tài khoản hệ thống thành công. Thầy cô có thể bắt đầu sử dụng hệ thống ngay bây giờ.',
    registrationDescriptionStudent: 'Bạn đã đăng ký tài khoản hệ thống thành công. Bạn có thể bắt đầu sử dụng hệ thống ngay bây giờ.',
    backLogin: 'Quay lại đăng nhập',
    noVerificationCode: 'Thầy/Cô chưa nhận được mã xác nhận?',
    noVerificationCodeStudent: 'Bạn chưa nhận được mã xác nhận?',
    resend: 'Gửi lại',
    after: 'sau',
    district: 'Xã/Phường',
    districtPlaceholder: 'Chọn xã/phường',
    province: 'Tỉnh/Thành phố',
    provincePlaceholder: 'Chọn tỉnh/thành phố',
    joinWorkspaceFail: 'Yêu cầu tham gia đơn vị bị từ chối',
    joinWorkspaceFailTitle: 'Yêu cầu tham gia đơn vị <strong>{name}</strong> của thầy/cô đã bị từ chối.',
    joinWorkspaceFailSubtitle: 'Thầy/cô có thể gửi lại yêu cầu hoặc chuyển sang không gian cá nhân để tiếp tục sử dụng NextSchool với trải nghiệm tốt nhất.',
    resendRequest: 'Gửi lại yêu cầu',
    backSpace: 'Quay lại lựa chọn sử dụng',
    // Student onboarding
    useNextSchoolTitleStudent: 'Chọn cách bạn muốn bắt đầu với NextSchool',
    useNextSchoolDescriptionStudent: 'NextSchool cho phép bạn tham gia các lớp học do giáo viên tạo',
    joinClass: 'Tham gia lớp học',
    joinClassDescription: 'Nhờ giáo viên gửi bạn đường link lớp học nhờ để tham gia ngay.',
    continueExplore: 'Tiếp tục khám phá',
    continueExploreDescription: 'Trải nghiệm hệ thống giáo viên hoặc trường để tham gia vào lớp sau.',
    startJoinClass: 'Bắt đầu tham gia lớp học',
    startJoinClassDescription: 'Nhập đường dẫn vào lớp học giáo viên đã gửi. Nếu chưa có, bạn có thể quay lại để tiếp tục sử dụng hệ thống.',
    classLink: 'Link lớp học',
    joinClassButton: 'Tham gia lớp',
    joinClassSuccess: 'Đã gửi yêu cầu tham gia lớp học thành công',
    joinClassSuccessSent: 'Yêu cầu của bạn đã được gửi đến giáo viên.',
    joinClassSuccessPendingApproval: 'Hãy chờ giáo viên duyệt để chính thức tham gia lớp nhé.',
    joinClassFail: 'Đã gửi yêu cầu tham gia lớp học thất bại',
    joinClassWaiting: {
      title: 'Chào mừng đến với NextSchool',
    },
    joinClassFailModal: {
      title: 'Yêu cầu tham gia lớp học bị từ chối',
      message: 'Yêu cầu tham gia lớp <strong>{name}</strong> của bạn đã bị từ chối.',
      suggestion: 'Bạn có thể gửi lại yêu cầu hoặc chuyển sang không gian cá nhân để tiếp tục sử dụng NextSchool với trải nghiệm tốt nhất.',
      retry: 'Gửi lại yêu cầu',
      backToSpace: 'Quay lại lựa chọn sử dụng',
    },
    joinClassPending: {
      title: 'Yêu cầu tham gia đang chờ xác nhận',
      message: 'Bạn đã gửi yêu cầu tham gia lớp học.',
      suggestion: 'Sau khi giáo viên chấp nhận, bạn sẽ được vào lớp ngay. Bạn có thể khám phá một số tính năng trong khi chờ giáo viên xác nhận hoặc hủy yêu cầu tham gia.',
      cancel: 'Hủy yêu cầu tham gia',
      cancelTitle: 'Hủy yêu cầu tham gia lớp học',
      cancelMessage: 'Sau khi hủy, bạn có thể tham gia một lớp học khác bằng đường dẫn mới.',
      cancelSuggestion: 'Bạn có chắc chắn muốn hủy yêu cầu không?',
      cancelButton: 'Hủy yêu cầu',
      cancelJoinClassSuccess: 'Yêu cầu tham gia lớp học đã được hủy',
      cancelJoinClassFail: 'Hủy yêu cầu tham gia lớp học thất bại',
    },

    validation: {
      required_name: 'Vui lòng nhập tên!',
      required_email: 'Email không được phép để trống.',
      invalid_email: 'Địa chỉ email không hợp lệ.',
      required_password: 'Mật khẩu không được phép để trống.',
      required_new_password: 'Mật khẩu mới không được phép để trống.',
      min_length_password: 'Mật khẩu phải có tối thiểu 8 ký tự.',
      max_length_password: 'Mật khẩu không được vượt quá 30 ký tự.',
      uppercase_password: 'Mật khẩu phải chứa ít nhất một chữ cái in hoa (A-Z).',
      number_password: 'Mật khẩu phải chứa ít nhất một chữ số (0-9).',
      special_password: 'Mật khẩu phải chứa ít nhất một ký tự đặc biệt.',
      required_confirm: 'Nhập lại mật khẩu không được phép để trống.',
      password_mismatch: 'Mật khẩu không khớp!',
      required_current_password: 'Mật khẩu hiện tại không được phép để trống.',
      agree_terms: 'Bạn phải đồng ý với điều khoản!',
      required_account: 'Tài khoản không được phép để trống.',
      email_not_found: 'Email không tồn tại trong hệ thống.',
      required_firstName: 'Thông tin không được phép để trống.',
      required_lastName: 'Thông tin không được phép để trống.',
      no_special_or_number: 'Thông tin không được phép chứa các ký tự đặc biệt và số.',
      email_already_exists: 'Email đã tồn tại.',
      required_otpCode: 'Mã OTP không được để trống. Vui lòng nhập mã để tiếp tục.',
      invalid_otpCode: 'Mã OTP không đúng. Vui lòng kiểm tra và nhập lại.',
      has_expired_otpCode: 'Mã OTP đã hết hạn. Vui lòng yêu cầu gửi lại mã mới.',
      required_school: 'Đơn vị trường không được phép để trống.',
      required_registered_school: 'Tên đơn vị đăng ký không được phép để trống.',
      registered_school_already_exists: 'Tên đơn vị đăng ký đã tồn tại.',
      required_school_phone: 'Số điện thoại liên hệ không được phép để trống.',
      invalid_school_phone: 'Số điện thoại không hợp lệ.',
      required_district: 'Xã/Phường không được phép để trống.',
      required_province: 'Tỉnh/Thành phố liên hệ không được phép để trống.',
    },
    loginStudent: {
      title: 'Đăng nhập học sinh',
      welcome: 'Chào mừng các học sinh',
      welcome1: 'Học thông minh - Dạy nhẹ nhàng',
      description: 'Vui lòng đăng nhập để tiếp tục',
    },
    loginTeacher: {
      title: 'Đăng nhập giáo viên',
      welcome: 'Chào mừng Quý thầy/cô',
      welcome1: 'Học thông minh - Dạy nhẹ nhàng',
      description: 'Vui lòng đăng nhập để tiếp tục',
    },
    loginParent: {
      title: 'Đăng nhập phụ huynh',
      welcome: 'Chào mừng các phụ huynh',
      description: 'Vui lòng đăng nhập để tiếp tục',
    },
    loginSuccessful: 'Đăng nhập thành công',
    loginFailed: 'Đăng nhập thất bại',
    confirm: 'Xác nhận',
  },
  transaction: {
    title: 'Quản lý giao dịch',
    searchPlaceholder: 'Tìm kiếm giao dịch...',
    statusFilter: 'Trạng thái',
    typeFilter: 'Loại',
    dateFilter: 'Ngày',
    upload: 'Đăng tải',
    uploaded: 'Đã đăng tải',
    purchased: 'Đơn mua',
    noDataUploaded: 'Chưa có dữ liệu đã đăng tải',
    noDataPurchased: 'Chưa có đơn mua',
    unsupportedType: 'Loại đăng tải chưa được hỗ trợ',
    unsupportedTypeDescription: 'Loại "{{type}}" chưa có component tương ứng',
    tab: {
      discoverByCategory: 'Khám phá theo danh mục',
      agent: 'Trợ lý',
      history: 'Lịch sử',
      settings: 'Cài đặt',
    },
    tabs: {
      sold: 'Đã bán',
      bought: 'Đã mua',
      commission: 'Hoa hồng',
    },
    uploadTypes: {
      educationalAssistant: 'Trợ lý giáo dục',
      lessonPlan: 'Kế hoạch giảng dạy',
      eLessonPlan: 'Kế hoạch bài dạy',
      worksheet: 'Bài tập',
      video: 'Video',
      image: 'Hình ảnh',
      slide: 'Slide',
      description: {
        educationalAssistant: 'Trợ lý AI giáo dục',
        lessonPlan: 'Kế hoạch giảng dạy',
        eLessonPlan: 'Kế hoạch bài dạy',
        worksheet: 'Phiếu bài tập học tập',
        video: 'Video học tập',
        image: 'Hình ảnh học tập',
        slide: 'Slide học tập',
      },
    },
    listResource: {
      title: 'Danh sách tài liệu',
      search: 'Tìm kiếm',
      classBlock: 'Khối lớp',
      subject: 'Môn học',
      status: 'Trạng thái',
      action: 'Hành động',
      noData: 'Không có dữ liệu',
      clear: 'Xóa',
    },
    form: {
      cancel: 'Hủy',
      upload: 'Đăng tải',
      uploadSuccess: 'Đăng tải thành công',
      uploadError: 'Đăng tải thất bại',
      nameRequired: 'Tên phiếu bài tập là bắt buộc',
      classRequired: 'Khối lớp là bắt buộc',
      subjectRequired: 'Môn học là bắt buộc',
      thumbnailRequired: 'Ảnh mẫu hiển thị là bắt buộc',
      validation: {
        name: 'Vui lòng nhập tên',
        class: 'Vui lòng chọn khối lớp',
        subject: 'Vui lòng chọn môn học',
        thumbnail: 'Vui lòng chọn ảnh mẫu hiển thị',
        file: 'Vui lòng chọn tệp tài liệu',
        fileRequired: 'Vui lòng chọn tệp tài liệu',
        errorMessage: 'Vui lòng kiểm tra lại thông tin form',
        description: 'Mô tả phải có ít nhất 10 ký tự',
        images: 'Vui lòng chọn tối đa 4 ảnh minh hoạ',
      },
    },
    uploadComponent: {
      worksheet: {
        title: 'Tải lên phiếu bài tập',
        configUpload: 'Thiết lập đăng tải phiếu bài tập',
        worksheetName: 'Tên phiếu bài tập',
        worksheetNamePlaceholder: 'Tên phiếu bài tập',
        fileUploaded: 'Tệp đã được tải lên thành công',
        deleteFile: 'Xóa tệp',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả chi tiết phiếu bài tập',
        detailedDescription: 'Mô tả chi tiết',
        maxFileSize: 'Kích thước tập tối đa: 30MB',
        justSupportedFormats: 'Định dạng hỗ trợ: .docx, .pdf',
      },
      slide: {
        title: 'Tải lên slide',
        configUpload: 'Thiết lập đăng tải slide',
        slideName: 'Tên slide',
        slideNamePlaceholder: 'Tên slide',
        fileUploaded: 'Tệp đã được tải lên thành công',
        deleteFile: 'Xóa tệp',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả chi tiết slide',
        detailedDescription: 'Mô tả chi tiết',
        maxFileSize: 'Kích thước tập tối đa: 30MB',
        justSupportedFormats: 'Định dạng hỗ trợ: .pptx, .ppt',
      },
      lessonPlan: {
        title: 'Tải lên kế hoạch giảng dạy',
        configUpload: 'Thiết lập đăng tải kế hoạch giảng dạy',
        lessonPlanName: 'Tên ',
        lessonPlanNamePlaceholder: 'Tên kế hoạch giảng dạy',
        fileUploaded: 'Tệp đã được tải lên thành công',
        deleteFile: 'Xóa tệp',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả chi tiết kế hoạch giảng dạy',
        detailedDescription: 'Mô tả chi tiết',
        maxFileSize: 'Kích thước tập tối đa: 30MB',
        justSupportedFormats: 'Định dạng hỗ trợ: .pptx, .ppt',
      },
      eLessonPlan: {
        title: 'Tải lên kế hoạch bài dạy điện tử',
        configUpload: 'Thiết lập đăng tải kế hoạch bài dạy điện tử',
        eLessonPlanName: 'Tên kế hoạch bài dạy điện tử',
        eLessonPlanNamePlaceholder: 'Tên kế hoạch bài dạy điện tử',
        fileUploaded: 'Tệp đã được tải lên thành công',
        deleteFile: 'Xóa tệp',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả chi tiết kế hoạch bài dạy điện tử',
        detailedDescription: 'Mô tả chi tiết',
        maxFileSize: 'Kích thước tập tối đa: 30MB',
        justSupportedFormats: 'Định dạng hỗ trợ: .pptx, .ppt',
      },
      video: {
        title: 'Tải lên video',
        configUpload: 'Thiết lập đăng tải video',
        videoName: 'Tên video',
        videoNamePlaceholder: 'Tên video',
        fileUploaded: 'Tệp đã được tải lên thành công',
        deleteFile: 'Xóa tệp',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả chi tiết video',
        maxFileSize: 'Kích thước tập tối đa: 30MB',
        chooseFile: 'Chọn video',
        videoSource: 'Nguồn video',
        videoSourcePlaceholder: 'Nhập nguồn video',
        detailedDescription: 'Mô tả chi tiết',
        justSupportedFormats: 'Định dạng hỗ trợ: .mp4, .mkv, .mov, .webm',
      },
      image: {
        title: 'Tải lên ảnh',
        configUpload: 'Thiết lập đăng tải ảnh',
        imageName: 'Tên ảnh',
        imageNamePlaceholder: 'Tên ảnh',
        fileUploaded: 'Tệp đã được tải lên thành công',
        deleteFile: 'Xóa tệp',
        description: 'Mô tả',
        descriptionPlaceholder: 'Nhập mô tả chi tiết ảnh',
        imageSource: 'Nguồn ảnh',
        imageSourcePlaceholder: 'Nhập nguồn ảnh',
        maxFileSize: 'Kích thước tập tối đa: 30MB',
        chooseFile: 'Chọn tệp',
        detailedDescription: 'Mô tả chi tiết',
        justSupportedFormats: 'Định dạng hỗ trợ: .jpg, .jpeg, .png, .gif, .bmp, .webp',
      },
      title: 'Thiết lập đăng tải',
      generalInfo: 'Thông tin chung',
      sampleImage: 'Ảnh mẫu hiển thị',
      uploadSampleImage: 'Tải ảnh mẫu hiển thị',
      illustrativeImages: 'Ảnh minh hoạ (tuỳ chọn)',
      exerciseName: 'Tên phiếu bài tập',
      exerciseNamePlaceholder: 'Tên phiếu bài tập',
      grade: 'Khối lớp',
      selectGrade: 'Chọn khối lớp',
      subject: 'Môn học',
      selectSubject: 'Chọn môn học',
      language: 'Ngôn ngữ',
      selectLanguage: 'Chọn ngôn ngữ',
      resourceSource: 'Nguồn tài liệu',
      uploadYourFile: 'Tải lên tệp của bạn',
      supportedFormats: 'Định dạng hỗ trợ:',
      maxFileSize: 'Kích thước tập tối đa: 30MB',
      chooseFile: 'Chọn tệp',
      description: 'Mô tả',
      detailedDescription: 'Mô tả chi tiết phiếu bài tập',
      descriptionPlaceholder: 'Nhập mô tả chi tiết phiếu bài tập',
      fileUploaded: 'Tệp đã được tải lên thành công',
      deleteFile: 'Xóa tệp',
      deleteThumbnail: 'Xóa ảnh mẫu',
      worksheetName: 'Tên phiếu bài tập',
      worksheetNamePlaceholder: 'Tên phiếu bài tập',
      deleteImage: 'Xóa ảnh minh hoạ',
      download: 'Tải xuống',
    },
    dialog: {
      delete: {
        title: 'Xóa',
        content: 'Bạn có chắc chắn muốn xóa tài liệu này không?',
        positiveText: 'Xóa',
        negativeText: 'Hủy',
        success: 'Xóa tài liệu thành công',
      },
    },
    stats: {
      purchases: {
        title: 'Số lượt mua',
        icon: 'ion:cube-outline',
      },
      revenue: {
        title: 'Doanh thu',
        icon: 'ion:wallet-outline',
      },
      cost: {
        title: 'Chi phí',
        icon: 'ion:card-outline',
      },
      profit: {
        title: 'Lợi nhuận',
        icon: 'ion:trending-up-outline',
      },
    },
    table: {
      title: 'Lợi nhuận',
      columns: {
        agent: 'Trợ lý',
        purchases: 'Lượt mua',
        revenue: 'Doanh thu',
        cost: 'Chi phí',
        profit: 'Lợi nhuận',
      },
    },
  },
  user: {
    userManagement: {
      title: 'Quản lý người dùng',
      changeButton: 'Thay đổi',
      recoveryEmail: 'Email khôi phục',
      addRecoveryEmail: 'Thêm email khôi phục',
      noInformation: 'Chưa có thông tin',
      workExperience: 'Kinh nghiệm làm việc',
      certificates: 'Chứng chỉ',
      awards: 'Giải thưởng',
      coAuthor: 'Đồng tác giả',
      reviews: 'Đánh giá',
      attachments: 'Tệp đính kèm',
      issuedBy: 'Cấp bởi',
      year: 'Năm',
      password: 'Mật khẩu',
      edit: {
        title: 'Sửa thông tin người dùng',
        name: 'Họ và tên',
        position: 'Chức vụ',
        workplace: 'Nơi làm việc',
        email: 'Email',
        phone: 'Điện thoại',
        password: 'Mật khẩu',
        confirmPassword: 'Xác nhận mật khẩu',
        recoveryEmail: 'Email khôi phục',
        addRecoveryEmail: 'Thêm email khôi phục',
        noInformation: 'Chưa có thông tin',
        workExperience: 'Kinh nghiệm làm việc',
        certificates: 'Chứng chỉ',
        awards: 'Giải thưởng',
        certificateName: 'Tên chứng chỉ/bằng cấp',
        issuedBy: 'Cấp bởi',
        yearIssued: 'Năm cấp',
        attachment: 'Hình ảnh/tệp đính kèm',
        certificate: 'Chứng chỉ/bằng cấp',
        save: 'Lưu',
        from: 'Từ',
        to: 'Đến',
        unit: 'Đơn vị',
        description: 'Mô tả',
        addWorkExperience: 'Thêm kinh nghiệm làm việc',
        addAwards: 'Thêm giải thưởng',
        addCertificate: 'Thêm chứng chỉ/bằng cấp',
        addWorkExperienceDescription: 'Thêm kinh nghiệm làm việc',
        addAwardsDescription: 'Thêm giải thưởng',
        addCertificateDescription: 'Thêm chứng chỉ/bằng cấp',
        upload: 'Tải lên',
        viewAttachment: 'Xem tệp đính kèm',
        success: 'Cập nhật thông tin người dùng thành công',
        error: 'Cập nhật thông tin người dùng thất bại',
        validation: {
          avatar: 'Vui lòng chọn hình ảnh!',
          name: 'Vui lòng nhập họ và tên!',
          position: 'Vui lòng nhập chức vụ!',
          workplace: 'Vui lòng nhập nơi làm việc!',
          email: 'Vui lòng nhập email!',
          phone: 'Vui lòng nhập số điện thoại!',
          certificateName: 'Vui lòng nhập tên chứng chỉ/bằng cấp!',
          issuedBy: 'Vui lòng nhập cấp bởi!',
          yearIssued: 'Vui lòng nhập năm cấp!',
          attachment: 'Vui lòng nhập hình ảnh/tệp đính kèm!',
          certificate: 'Vui lòng nhập chứng chỉ/bằng cấp!',
          from: 'Vui lòng nhập từ!',
          to: 'Vui lòng nhập đến!',
          unit: 'Vui lòng nhập đơn vị!',
          description: 'Vui lòng nhập mô tả!',
          addWorkExperience: 'Vui lòng nhập thêm kinh nghiệm làm việc!',
          addAwards: 'Vui lòng nhập thêm giải thưởng!',
          addCertificate: 'Vui lòng nhập thêm chứng chỉ/bằng cấp!',
          addWorkExperienceDescription: 'Vui lòng nhập mô tả kinh nghiệm làm việc!',
          addAwardsDescription: 'Vui lòng nhập mô tả giải thưởng!',
          addCertificateDescription: 'Vui lòng nhập mô tả chứng chỉ/bằng cấp!',
          invalidYear: 'Vui lòng nhập năm hợp lệ!',
          yearToLessThanFrom: 'Năm đến phải lớn hơn năm từ!',
        },
      },
    },
  },
  forum: {
    title: 'Diễn đàn cộng đồng next AI',
    tabs: {
      whatNew: 'Có gì mới',
      newPost: 'Bài viết mới',
      newPostOnProfile: 'Bài mới trên hồ sơ',
      newActivity: 'Hoạt động mới',
    },
  },

  monitor: {
    hint1: 'Số lượng cuộc trò chuyện với AI mỗi ngày, không bao gồm các thao tác prompt engineering hoặc debug.',
    hint2: 'Số người dùng duy nhất tham gia hỏi đáp với AI, không bao gồm prompt engineering hoặc debug.',
    hint3: 'Tổng số lượt tương tác với AI mỗi ngày.',
    hint4: 'Số lượt giao tiếp liên tục giữa người dùng và AI; dành cho các ứng dụng dựa trên hội thoại.',
    hint5: 'Đo lường hiệu suất của mô hình ngôn ngữ. Tính tốc độ xuất token của mô hình từ lúc bắt đầu đến khi hoàn tất phản hồi.',
    hint6: 'Phản ánh lượng token mà mô hình ngôn ngữ sử dụng mỗi ngày, hữu ích cho việc kiểm soát chi phí.',
    hint7: ' ',
  },
  globalList: {
    title: 'Cấu hình tham số',
    update: 'Cập nhật',
    create: 'Thêm mới',
    code: 'Mã',
    name: 'Tên',
    description: 'Mô tả',
    errorRequired: '{field} là bắt buộc',
    errorMaxLength: '{field} tối đa {max} ký tự',
    prompt_value: 'Giá trị prompt',
    validator: {
      codeInvalid: 'Mã không hợp lệ',
    },
  },

  globalListDetail: {
    title: 'Danh sách giá trị của tham số',
    update: 'Cập nhật',
    create: 'Thêm mới',
    code: 'Mã',
    name: 'Tên',
    value: 'Giá trị',
    order: 'Thứ tự',
    description: 'Mô tả',
    errorRequired: '{field} là bắt buộc',
    errorMaxLength: '{field} tối đa {max} ký tự',
    validator: {
      codeInvalid: 'Mã không hợp lệ',
    },
  },

  task: {
    title: 'Tác vụ',
    create: 'Tạo tác vụ',
    view: 'Thông tin tác vụ',
    edit: 'Sửa tác vụ',
    search: 'Tìm tác vụ',
    nameTask: 'Tên tác vụ',
    namePlaceholderTask: 'Ví dụ: Dịch tài liệu, Viết bài đăng Facebook,...',
    descriptionTask: 'Mô tả tác vụ',
    descriptionPlaceholderTask: 'Mô tả ngắn gọn về mục đích của tác vụ này',
    contentPromptTask: 'Nội dung prompt',
    contentPromptGuideTask: 'Sử dụng [biến] làm tham số để prompt linh hoạt hơn và có thể sử dụng với các đầu vào động',
    contentPromptPlaceholderTask: 'Ví dụ: "Dịch tài liệu từ [ngôn ngữ 1] sang [ngôn ngữ 2]. Đảm bảo bản dịch [ngôn ngữ 2] súc tích và có chiều sâu"',
    tag: 'Tag',
    nameTag: 'Tên tag',
    manageTag: 'Quản lý Tag',
    createTag: 'Tạo tag',
    editTag: 'Sửa tag',
    searchTag: 'Tìm tag',
    configureTag: 'Thiết lập Tag',
    assignAgent: 'Gán trợ lý',
    agentExecuted: 'Trợ lý thực hiện',
    titleDelete: 'Xóa tác vụ',
    titleErrorDelete: 'Xóa không thành công',
    contentDelete: 'Tác vụ sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
    contentErrorDelete: 'Trợ lý đang sử dụng tác vụ này đã được đăng tải lên cửa hàng. Vui lòng hủy đăng tải trợ lý trước khi thực hiện xóa tác vụ.',
    contentDeleteLeft: 'Tác vụ đang được gắn với',
    contentDeleteRight: 'Nếu tiếp tục, tác vụ sẽ bị xóa khỏi tất cả các trợ lý đang sử dụng. Bạn có chắc chắn muốn xóa không?',
    titleDeleteTag: 'Xác nhận xóa tag',
    contentDeleteTag: 'Tag sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
    contentDeleteTagLeft: 'đang được sử dụng bởi',
    contentDeleteTagCenter: 'Nếu tiếp tục, tag này sẽ bị xóa và ',
    contentDeleteTagBold: 'tự động gỡ bỏ ',
    contentDeleteTagRight: 'khỏi toàn bộ các tác vụ đó. Bạn có muốn tiếp tục?',
    configureParameters: 'Thiết lập tham số',
    nameParameter: 'Tên tham số',
    typeParameter: 'Kiểu dữ liệu',
    typeText: 'Chữ',
    typeDropdown: 'Danh sách cuộn',
    typeOptionList: 'Danh sách hiển thị toàn bộ',
    parameterOptionsList: 'Danh sách tham số lựa chọn',
    allowMultiple: 'Cho phép chọn nhiều',
    parameterExists: 'Tham số {parameter} đã tồn tại',
    action: 'Hành động',
    execute: 'Thực hiện',
    additionalRequest: 'Yêu cầu bổ sung',
    additionalRequestPlaceholder: 'Nhập yêu cầu bổ sung',
    parameterPlaceholder: 'Nhập liệu tham số',
    chooseParameters: 'Chọn tham số',
    parameterRequired: 'Vui lòng nhập tham số',
    addParameters: 'Thêm tham số',

  },

  validation: {
    required: 'Vui lòng nhập {name}!',
    greaterThanZero: 'Vui lòng nhập {name} lớn hơn 0!',
  },

  writer: {
    title: 'Sáng tạo nội dung cùng Nextschool AI',
    create: 'Tạo nội dung',
    edit: 'Sửa nội dung',
    search: 'Tìm nội dung',
    name: 'Tên nội dung',
    description: 'Hãy chia sẻ điều bạn muốn nói, và cùng AI tạo nên những câu chuyện truyền cảm hứng',
    placeholder: 'Mô tả chủ đề của bạn hoặc dán nội dung của bạn vào đây. AI của chúng tôi sẽ cấu trúc nó thành một bài thuyết trình hấp dẫn.',
    ideaInput: {
      title: 'Bạn muốn trình bày về điều gì?',
      creating: 'Đang tạo...',
      create: 'Tạo',
      language: 'Ngôn ngữ',
      articleType: 'Loại bài viết',
      articleTypePlaceholder: 'Chọn loại',
      languagePlaceholder: 'Chọn ngôn ngữ',
      authorName: 'Tên tác giả',
      authorNamePlaceholder: 'Nhập tên tác giả (tùy chọn)',
      workplace: 'Nơi làm việc',
      workplacePlaceholder: 'Nhập nơi làm việc (tùy chọn)',
      year: 'Năm xuất bản',
      yearPlaceholder: 'Nhập năm xuất bản (tùy chọn)',
      researchScope: 'Phạm vi nghiên cứu',
      researchScopePlaceholder: 'Nhập phạm vi nghiên cứu (tùy chọn)',
      placeholder: 'Mô tả chủ đề của bạn hoặc dán nội dung của bạn vào đây. AI của chúng tôi sẽ cấu trúc nó thành một bài thuyết trình hấp dẫn.',
      optimize: 'Tối ưu',
      optimizeTooltip: 'Tối ưu nội dung bằng AI',
      messages: {
        creating: 'Đang tạo tài liệu...',
        created: 'Đã tạo tài liệu, đang tạo nội dung...',
        error: 'Không thể tạo tài liệu',
        generalError: 'Có lỗi xảy ra khi tạo tài liệu',
        optimizing: 'Đang tối ưu văn bản...',
        optimized: 'Đã tối ưu văn bản thành công!',
        optimizeError: 'Không thể tối ưu văn bản',
      },
    },
    ideaList: {
      title: 'Ý tưởng đã tạo',
      ago: 'trước',
      emptyState: {
        title: 'Chưa có ý tưởng nào',
        description: 'Hãy tạo ý tưởng đầu tiên của bạn!',
      },
      messages: {
        creating: 'Đang tạo ý tưởng mới...',
        created: 'Tạo ý tưởng mới thành công!',
        error: 'Không thể tạo ý tưởng mới',
        generalError: 'Có lỗi xảy ra khi tạo ý tưởng mới',
      },
    },
    ideaCard: {
      startFromBlank: 'Bắt đầu từ một trang trắng',
      ago: 'trước',
      delete: 'Xóa',
      articleTypes: {
        report: 'Báo cáo',
        research: 'Bài nghiên cứu',
        article: 'Bài báo',
        paragraph: 'Đoạn văn',
        blog: 'Blog',
        creativeResearch: 'SKKN (Sáng kiến kinh nghiệm)',
      },
      languages: {
        vietnamese: 'Tiếng Việt',
        english: 'Tiếng Anh',
      },
    },
    aiAssistant: {
      title: 'Trợ lý sáng tạo nội dung',
      greeting: 'Xin chào! Tôi có thể giúp bạn sáng tạo nội dung',
      description: 'Hãy chia sẻ điều bạn muốn nói',
      placeholder: 'Nhập câu hỏi của bạn...',
    },
    deleteIdea: {
      title: 'Xóa ý tưởng',
      content: 'Bạn có chắc chắn muốn xóa ý tưởng này không?',
      delete: 'Xóa',
      cancel: 'Hủy',
    },
    detail: {
      streamingPlaceholder: 'Đang viết nội dung',
      noTitle: 'Không tiêu đề',
      creatingTitle: 'Đang tạo tiêu đề...',
      error: 'Đã xảy ra lỗi khi tạo nội dung. Vui lòng thử lại.',
      success: 'Đã tạo và lưu nội dung thành công!',
      deleteSuccess: 'Đã xóa ý tưởng',
      copySuccess: 'Đã copy nội dung',
      downloadSuccess: 'Đã tải xuống file DOCX',
      downloadError: 'Đã tải xuống dạng text thay thế',
      updateTitleSuccess: 'Đã cập nhật tiêu đề',
      placeholder: 'Viết điều gì đó...',
      askingAI: 'Đang hỏi AI...',
      creatingDiagram: 'Đang tạo sơ đồ...',
      noSelectedText: 'Không có text được chọn',
      creatingImage: 'Đang tạo hình ảnh...',
      creatingChart: 'Đang tạo biểu đồ...',
      creatingEditor: 'Đang khởi tạo editor...',
      preparing: 'Đang chuẩn bị...',
      creatingCustomSuggestion: 'Đang tạo gợi ý tùy chỉnh...',
      tableOfContents: {
        title: 'Mục lục',
        noHeadings: 'Chưa có tiêu đề nào',
        addHeadingsHint: 'Thêm tiêu đề để tạo mục lục',
      },
      replacingText: 'Đang thay thế đoạn văn...',
      applyingSuggestion: 'Đang áp dụng gợi ý...',
      predefinedSuggestion: 'Gợi ý có sẵn (click để thay thế)',
      generalSuggestions: 'Gợi ý chỉnh sửa',
      showSuggestions: 'Hiện gợi ý',
      imageSuccess: 'Đã tạo hình ảnh thành công!',
      imageError: 'Đã xảy ra lỗi khi tạo hình ảnh',
      noDocumentID: 'Không tìm thấy document ID',
      copyError: 'Không thể copy nội dung',
      words: 'từ',
      autoCompleteOn: 'Đã bật tự động hoàn thành',
      autoCompleteOff: 'Đã tắt tự động hoàn thành',
      stopStreaming: 'Dừng tạo nội dung',
      accept: 'Chấp nhận',
      reject: 'Từ chối',
      tryAgain: 'Thử lại',
      tab: 'Tab',
      suggestion: 'Gợi ý',
      suggestionDropdown: 'Dropdown gợi ý',
      suggestionDropdownHeader: 'Gợi ý cho phần này',
      suggestionDropdownClose: 'Đóng',
      customSuggestionInput: 'Nhập yêu cầu tùy chỉnh để AI viết lại đoạn văn này',
      customSuggestionInputPlaceholder: 'Ví dụ: Thêm ví dụ cụ thể, viết ngắn gọn hơn...',
      originalText: 'Văn bản gốc',
      preparingContent: 'Đang chuẩn bị nội dung...',
      pleaseWait: 'Vui lòng chờ trong giây lát',
      createTemplate: 'Tạo Template',
      createContent: 'Tạo Nội dung',
      noContentToSave: 'Không có nội dung để lưu',
      limitedAIInTemplateMode: 'Tính năng AI bị hạn chế trong chế độ tạo template',
      saveContentTemplate: 'Lưu đoạn mẫu',
      searchContentTemplate: 'Tìm kiếm đoạn mẫu',
      contentTemplateSaved: 'Đã lưu đoạn mẫu thành công',
      contentTemplateSaveError: 'Không thể lưu đoạn mẫu',
      contentTemplateSaveErrorOccurred: 'Đã xảy ra lỗi khi lưu đoạn mẫu',
      contentCopiedToClipboard: 'Đã sao chép nội dung vào clipboard',
      contentCopyError: 'Không thể sao chép nội dung',
      noContentFound: 'Không tìm thấy đoạn mẫu nào',
      contentTemplateTitle: 'Tiêu đề đoạn mẫu',
      contentTemplateTitlePlaceholder: 'Nhập tiêu đề cho đoạn mẫu...',
      contentTemplateGroup: 'Nhóm',
      contentTemplateGroupPlaceholder: 'Chọn nhóm...',
      contentTemplateSelectedContent: 'Nội dung được chọn:',
      contentTemplateSearchByTitle: 'Tìm kiếm theo tiêu đề...',
      contentTemplateSelectGroup: 'Chọn nhóm...',
      contentTemplateSearch: 'Tìm kiếm',
      contentTemplateClearFilter: 'Xóa bộ lọc',
      contentTemplateResults: 'Hiển thị {count} / {total} kết quả',
      contentTemplateCopy: 'Sao chép',
      contentTemplateApply: 'Áp dụng',
      contentTemplateNoGroups: 'Không thể tải danh sách nhóm',
      contentTemplateNoContents: 'Không thể tải danh sách nội dung',
      contentTemplateNoSelectedText: 'Vui lòng chọn đoạn văn bản để lưu',
      contentTemplateValidationTitle: 'Vui lòng nhập tiêu đề',
      contentTemplateValidationGroup: 'Vui lòng chọn nhóm',
      contentAppliedToSelection: 'Đã áp dụng nội dung vào đoạn văn được chọn',
      contentApplyError: 'Không thể áp dụng nội dung',
      noEditorInstance: 'Không tìm thấy editor',
      imageUrlModal: {
        title: 'Chèn hình ảnh từ URL',
        insert: 'Chèn hình ảnh',
        cancel: 'Hủy',
        imageUrl: 'URL hình ảnh',
        imageUrlRequired: 'URL hình ảnh *',
        imageUrlPlaceholder: 'https://example.com/image.jpg',
        altText: 'Mô tả hình ảnh (Alt text)',
        altTextPlaceholder: 'Nhập mô tả hình ảnh',
        imageTitle: 'Tiêu đề (Tùy chọn)',
        titlePlaceholder: 'Nhập tiêu đề hình ảnh',
        preview: 'Xem trước',
        error: {
          invalidUrl: 'URL hình ảnh không hợp lệ hoặc không thể tải được.',
          loadFailed: 'Không thể tải hình ảnh. Vui lòng kiểm tra URL.',
        },
        validation: {
          urlRequired: 'Vui lòng nhập URL hình ảnh hợp lệ',
          urlInvalid: 'Vui lòng nhập URL hợp lệ bắt đầu bằng http:// hoặc https://',
        },
      },
      colorPicker: {
        titleText: 'Chọn màu chữ',
        titleBackground: 'Chọn màu nền',
        textColor: 'Màu chữ',
        backgroundColor: 'Màu nền',
        themeColors: 'Màu chủ đề',
        standardColors: 'Màu tiêu chuẩn',
        moreColors: 'Màu khác...',
      },
      tableContextToolbar: {
        title: 'Thao tác bảng',
        rows: 'Hàng',
        columns: 'Cột',
        table: 'Bảng',
        addRowAbove: 'Thêm hàng phía trên',
        addRowBelow: 'Thêm hàng phía dưới',
        deleteRow: 'Xóa hàng',
        addColumnLeft: 'Thêm cột bên trái',
        addColumnRight: 'Thêm cột bên phải',
        deleteColumn: 'Xóa cột',
        deleteTable: 'Xóa bảng',
        close: 'Đóng toolbar',
        shortcuts: {
          addRowAbove: 'Ctrl+Shift+↑',
          addRowBelow: 'Ctrl+Shift+↓',
          deleteRow: 'Ctrl+Shift+Delete',
          addColumnLeft: 'Ctrl+Shift+←',
          addColumnRight: 'Ctrl+Shift+→',
          deleteColumn: 'Ctrl+Delete',
          deleteTable: 'Ctrl+Shift+Backspace',
        },
      },
      tooltips: {
        back: 'Quay lại',
        createTemplate: 'Tạo template',
        searchContent: 'Tìm kiếm đoạn mẫu',
        toggleAssistant: 'Bật/tắt trợ lý AI',
        download: 'Tải xuống nội dung',
        delete: 'Xóa nội dung',
      },
      menu: {
        downloadDocx: 'Tải xuống DOCX',
        saveToLesson: 'Lưu vào bài học',
      },
    },
    blankTemplate: {
      title: 'Tạo Template Trống',
      properties: 'Thuộc tính Template',
      propertiesDesc: 'Cấu hình thông tin cho template của bạn',
    },
    editTemplate: {
      title: 'Chỉnh sửa Template',
      properties: 'Thuộc tính Template',
      propertiesDesc: 'Cập nhật thông tin cho template của bạn',
      loadingTemplate: 'Đang tải template...',
      updateTemplate: 'Cập nhật Template',
    },
    blankContent: {
      title: 'Tạo Nội dung Trống',
      description: 'Tạo nội dung mới từ trang trắng',
      properties: 'Thuộc tính Nội dung',
      propertiesDesc: 'Cấu hình thông tin cho nội dung của bạn',
      placeholder: 'Bắt đầu viết nội dung của bạn...',
    },
    editContent: {
      title: 'Chỉnh sửa Nội dung',
      properties: 'Thuộc tính Nội dung',
      propertiesDesc: 'Cập nhật thông tin cho nội dung của bạn',
      loadingContent: 'Đang tải nội dung...',
      updateContent: 'Cập nhật Nội dung',
    },
    toolbar: {
      askAI: 'Hỏi AI',
      diagramAI: 'Sơ đồ AI',
      imageAI: 'Hình ảnh AI',
      saveContent: 'Lưu mẫu',
      searchContent: 'Tìm mẫu',
      insertTable: 'Chèn bảng',
      charts: 'Biểu đồ',
      explain: 'Giải thích',
      insight: 'Hiểu biết',
    },
    quickActions: {
      title: 'Tiện ích nhanh',
      addNew: 'Tạo mới',
      chooseTemplate: 'Chọn template',
      openLibrary: 'Thư viện',
      chooseTemplateDesc: 'Sử dụng mẫu có sẵn để bắt đầu nhanh',
      libraryDesc: 'Duyệt qua các tài liệu đã lưu',
      library: 'Thư viện',
      templates: 'Template bài viết',
      search: 'Tìm kiếm',
      all: 'Tất cả',
      addTemplate: 'Thêm template',
      business: 'Kinh doanh',
      tryChangeSearch: 'Thử thay đổi từ khóa tìm kiếu hoặc bộ lọc',
      noTemplate: 'Không tìm thấy template',
      articleTitle: 'Tiêu đề bài viết',
      articleTitlePlaceholder: 'Nhập tiêu đề bài viết',
      cancel: 'Hủy',
      create: 'Tạo',
      content: 'Kho nội dung',
      contentDesc: 'Tính năng sẽ được cập nhật sớm',
      createFromTemplate: 'Tạo từ template',
      outstandingTemplate: 'Template nổi bật',
      uploadTemplate: 'Tải lên template',
      uploadTemplateDesc: 'Nhấp để tải lên, hoặc kéo và thả tệp vào đây',
      uploadTemplateFormat: 'Định dạng hỗ trợ: .pdf | .doc | .docx',
      uploadTemplateConverting: 'Đang chuyển đổi file thành HTML...',
      uploadTemplateSuccess: 'File đã được xử lý thành công!',
      imageExtract: 'Trích văn bản từ hình ảnh',
      imageExtractDesc: 'Tính năng sẽ được cập nhật sớm',
      next: 'Tiếp theo',
      chooseDataSource: 'Chọn nguồn dữ liệu',
      uploadFile: 'Tải lên tệp',
      writerLibrary: 'Thư viện nội dung',
      contents: 'Nội dung',
      blank: 'Trang trắng',
      upload: 'Tải lên',
      // ContentLibrary specific keys
      templateName: 'Tên template',
      templateNamePlaceholder: 'Nhập tên template để tìm kiếm',
      field: 'Lĩnh vực',
      fieldPlaceholder: 'Chọn lĩnh vực',
      writerType: 'Loại bài viết',
      writerTypePlaceholder: 'Chọn loại',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      clearFilter: 'Xóa bộ lọc',
      templateList: 'Danh sách template',
      templateCount: 'kết quả',
      loadingTemplates: 'Đang tải danh sách template...',
      noTemplatesFound: 'Không tìm thấy template nào',
      tryChangeSearchOrFilter: 'Thử thay đổi từ khóa tìm kiếm hoặc bộ lọc',
      category: 'Danh mục',
      writerTypeLabel: 'Loại bài viết',
      languageLabel: 'Ngôn ngữ',
      // Additional keys for ContentLibrary
      createNewArticle: 'Tạo bài viết mới',
      contentFromFile: 'Nội dung từ file',
      useTemplate: 'Sử dụng Template',
      templatePreview: 'Xem trước Template',
      deleteTemplate: 'Xóa Template',
      deleteTemplateContent: 'Bạn có chắc chắn muốn xóa template này không?',
      deleteTemplateSuccess: 'Xóa template thành công',
      // Content-related keys
      contentName: 'Tên nội dung',
      contentNamePlaceholder: 'Nhập tên nội dung để tìm kiếm',
      group: 'Nhóm',
      groupPlaceholder: 'Chọn nhóm',
      addContent: 'Thêm nội dung',
      contentList: 'Danh sách nội dung',
      contentCount: 'kết quả',
      loadingContents: 'Đang tải danh sách nội dung...',
      noContentsFound: 'Không tìm thấy nội dung nào',
      deleteContent: 'Xóa Nội dung',
      deleteContentContent: 'Bạn có chắc chắn muốn xóa nội dung này không?',
      deleteContentSuccess: 'Xóa nội dung thành công',
      messages: {
        creating: 'Đang tạo bài viết...',
        created: 'Tạo bài viết thành công',
        error: 'Tạo bài viết thất bại',
        generalError: 'Có lỗi xảy ra khi tạo bài viết',
        processingFile: 'Đang xử lý file...',
        extractionError: 'Không thể trích xuất nội dung từ file',
        fileProcessedSuccess: 'Xử lý file thành công',
        fileProcessingError: 'Lỗi khi xử lý file',
      },
      validation: {
        titleRequired: 'Vui lòng nhập tiêu đề bài viết',
        fieldRequired: 'Vui lòng chọn lĩnh vực',
        languageRequired: 'Vui lòng chọn ngôn ngữ',
        articleTypeRequired: 'Vui lòng chọn loại bài viết',
        contentRequired: 'Vui lòng tải lên file và chờ xử lý hoàn tất',
        unsupportedFileType: 'Chỉ hỗ trợ file PDF và DOC/DOCX',
        // Content validation
        groupRequired: 'Vui lòng chọn nhóm',
        groupNameRequired: 'Vui lòng nhập tên nhóm',
      },
      selectedTemplate: 'Template được chọn',
      selectTemplate: 'Chọn Template',
    },
    uploadContent: {
      title: 'Tải lên template',
      back: 'Quay lại',
      uploadNewFile: 'Tải file khác',
      fileUpload: 'Tải lên tệp',
      imageExtract: 'Trích văn bản từ hình ảnh',
      chooseDataSource: 'Chọn nguồn dữ liệu',
      uploadDescription: 'Nhấp để tải lên, hoặc kéo và thả tệp vào đây',
      supportedFormats: 'Định dạng hỗ trợ: DOC, DOCX, PDF (tối đa 10MB)',
      extractTextAuto: 'Trích xuất văn bản tự động',
      editBeforeSave: 'Chỉnh sửa trước khi lưu',
      processingFile: 'Đang xử lý file...',
      pleaseWait: 'Vui lòng đợi trong giây lát',
      comingSoon: 'Tính năng sẽ được cập nhật sớm',
      fileInfo: {
        processedSuccessfully: 'Đã xử lý thành công',
      },
      form: {
        articleTitle: 'Tiêu đề bài viết',
        articleTitlePlaceholder: 'Nhập tiêu đề bài viết',
        field: 'Lĩnh vực',
        fieldPlaceholder: 'Chọn lĩnh vực',
        language: 'Ngôn ngữ',
        languagePlaceholder: 'Chọn ngôn ngữ',
        articleType: 'Loại bài viết',
        articleTypePlaceholder: 'Chọn loại bài viết',
        contentLabel: 'Nội dung đã chuyển đổi (có thể chỉnh sửa):',
        contentPlaceholder: 'Nhập nội dung bài viết...',
        // Content form specific fields
        contentTitle: 'Tiêu đề nội dung',
        contentTitlePlaceholder: 'Nhập tiêu đề nội dung',
        group: 'Nhóm',
        groupPlaceholder: 'Chọn nhóm',
        groupName: 'Tên nhóm',
        groupNamePlaceholder: 'Nhập tên nhóm mới',
      },
      validation: {
        titleRequired: 'Vui lòng nhập tiêu đề bài viết',
        fieldRequired: 'Vui lòng chọn lĩnh vực',
        languageRequired: 'Vui lòng chọn ngôn ngữ',
        articleTypeRequired: 'Vui lòng chọn loại bài viết',
      },
      messages: {
        processingFile: 'Đang xử lý file...',
        fileProcessedSuccess: 'Xử lý file thành công',
        fileProcessedError: 'Lỗi khi xử lý file: {error}',
        pdfNoTextError: 'File PDF này không chứa text (có thể là file scan ảnh). Vui lòng upload file PDF có thể copy được text.',
        onlyPdfDocSupported: 'Chỉ hỗ trợ file DOC/DOCX/PDF',
        creatingTemplate: 'Đang tạo template...',
        templateCreatedSuccess: 'Tạo template thành công',
        templateCreatedError: 'Tạo template thất bại',
        updatingTemplate: 'Đang cập nhật template...',
        templateUpdatedSuccess: 'Cập nhật template thành công',
        templateUpdatedError: 'Cập nhật template thất bại',
        checkContentBeforeSave: 'Vui lòng kiểm tra lại nội dung trước khi lưu',
        errorOccurred: 'Có lỗi xảy ra khi tạo template',
        // Content messages
        creatingContent: 'Đang tạo nội dung...',
        contentCreatedSuccess: 'Tạo nội dung thành công',
        contentCreatedError: 'Tạo nội dung thất bại',
        updatingContent: 'Đang cập nhật nội dung...',
        contentUpdatedSuccess: 'Cập nhật nội dung thành công',
        contentUpdatedError: 'Cập nhật nội dung thất bại',
        loadContentError: 'Không thể tải nội dung',
        groupCreatedSuccess: 'Tạo nhóm thành công',
        groupCreatedError: 'Tạo nhóm thất bại',
      },
      saveTemplate: 'Lưu template',
      createGroup: 'Tạo nhóm mới',
    },
  },

  classroom: {
    title: 'Lớp học',
    create: 'Tạo lớp học',
    add: 'Thêm lớp học',
    view: 'Xem lớp học',
    edit: 'Chỉnh sửa lớp học',
    edit2: 'Sửa lớp học',
    search: 'Tìm kiếm lớp học',
    educationalAssistants: 'Trợ lý giáo dục',
    titleDelete: 'Xóa lớp học',
    contentDelete: 'Hệ thống sẽ thực hiện xoá lớp vĩnh viễn toàn bộ kết quả học tập của học sinh. Hành động này không thể hoàn tác. Bạn có chắc chắn muốn xoá không?',
    deleteConfirmCheckbox: 'Tôi hiểu dữ liệu kết quả học tập của học sinh sẽ mất vĩnh viễn',
    name: 'Tên lớp học',
    namePlaceholder: 'Nhập tên lớp học',
    classBlock: 'Khối lớp',
    classBlockPlaceholder: 'Chọn khối lớp',
    description: 'Mô tả',
    descriptionPlaceholder: 'Nhập mô tả lớp học',
    welcome: 'Chào mừng đến với Classroom',
    welcomeClassroom: 'Xin chào đến với {name}',
    welcomeTeacherBanner: 'Xin chào thầy/cô! Sao không kết nối với các ứng dụng của mình nhỉ?',
    welcomeStudentBanner: 'Xin chào các em! Sao không kết nối với các ứng dụng của mình nhỉ?',
    welcomeDescriptionTeacherBanner: 'Một khi đã kết nối, thầy/cô có thể dạy, chia sẻ và quản lý tiện lợi hơn bao giờ hết.',
    welcomeDescriptionStudentBanner: 'Một khi đã kết nối, các em có thể học, chia sẻ và quản lý tiện lợi hơn bao giờ hết.',
    connectNow: 'Kết nối ngay',
    setting: 'Cài đặt lớp học',
    configureGrade: 'Thiết lập thang điểm',
    titleConfigureGrade: 'Thay đổi thang điểm sẽ ảnh hưởng toàn hệ thống',
    contentConfigureGrade: 'Thang điểm mới sẽ áp dụng cho tất cả lớp học trong hệ thống.\n'
			+ 'Các bài tập, bài kiểm tra đã chấm điểm sẽ được tính lại theo thang điểm mới.\n'
			+ 'Việc thay đổi có thể làm thay đổi kết quả hiện tại của học sinh.\n'
			+ 'Bạn có chắc chắn muốn tiếp tục không?',
    saveToLesson: 'Lưu vào bài học',
    saveContentToLesson: 'Lưu nội dung vào bài học',
    saveCreatedContentToLesson: 'Lưu nội dung đã tạo vào bài học',
    addLessonAssistant: 'Thêm trợ lý hỗ trợ bài học',
    addCreatedAssistantSubject: 'Thêm trợ lý hỗ trợ đã tạo vào môn học',
    saveToLessonDesc: 'Lưu nội dung đã tạo vào bài học',
    saveImageToLesson: 'Lưu hình ảnh vào bài học',
    saveImageToLessonDesc: 'Lưu hình ảnh đã tạo vào bài học',
    saveToNewClass: 'Thêm vào lớp học mới',
    saveToNewLesson: 'Thêm vào bài học mới',
    createAndSave: 'Thêm lớp học và lưu',
    classroomIdMissing: 'Thiếu classroomId',
    planPlaceholder: 'Hãy nhập nội dung mà thầy/cô muốn trình bày',
    planPlaceholderStudent: 'Hãy nhập nội dung mà bạn muốn trình bày',
    saveContentToNewClass: 'Lưu nội dung vào lớp học mới',
    classroomTeachBoard: 'Trợ Lý 360°',
    createLesson: 'Thêm bài học',
    connectApps: 'Kết nối ứng dụng',
    connectAppsDescription: 'Kết nối với ứng dụng để bài học thêm sinh động',
    imageToText: 'Hình ảnh sang văn bản',
    pdfToText: 'PDF sang văn bản',
    deleteHistory: 'Xóa lịch sử tài liệu',
    contentDeleteHistory: 'Bạn có chắc chắn muốn xóa lịch sử tài liệu này không?',
    dictate: 'Ra lệnh',
    uploadDocument: 'Tải tài liệu tham khảo',
    selectReportType: 'Chọn loại báo cáo',
    selectReportTypePlaceholder: 'Chọn loại báo cáo',
    addOtherFile: 'Thêm tệp khác',
    filesExceedLimit: 'Các tệp sau vượt quá giới hạn 30MB: {files}',
    selectClassBlock: 'Chọn khối lớp',
    selectSubject: 'Chọn môn học',
    classLevel: {
      grade_1: 'Lớp 1',
      grade_2: 'Lớp 2',
      grade_3: 'Lớp 3',
      grade_4: 'Lớp 4',
      grade_5: 'Lớp 5',
      grade_6: 'Lớp 6',
      grade_7: 'Lớp 7',
      grade_8: 'Lớp 8',
      grade_9: 'Lớp 9',
      grade_10: 'Lớp 10',
      grade_11: 'Lớp 11',
      grade_12: 'Lớp 12',
    },
    addAgentToNewClassroom: 'Thêm trợ lý vào lớp học mới',
    descriptionClassroom: 'Mô tả lớp học',
    emptyHint: 'Bắt đầu với lớp học đầu tiên',
    toolManagement: {
      title: 'Danh sách công cụ',
      addTool: 'Thêm công cụ',
      editTool: 'Chỉnh sửa công cụ',
      addConfig: 'Thêm cấu hình',
      subject: 'Môn học',
      grade: 'Khối lớp',
      inUse: 'Sử dụng',
      notInUse: 'Ngừng sử dụng',
      setAsDefault: 'Đặt làm mặc định',
      applyFrom: 'Áp dụng từ',
      template: 'Template',
      name: 'Tên công cụ',
      namePlaceholder: 'Nhập tên công cụ',
      nameRequired: 'Vui lòng nhập tên công cụ',
      nameMaxLength: 'Tên công cụ không được vượt quá 255 ký tự',
      description: 'Mô tả',
      descriptionPlaceholder: 'Nhập mô tả công cụ',
      descriptionMaxLength: 'Mô tả không được vượt quá 1000 ký tự',
      configName: 'Tên cấu hình',
      configNamePlaceholder: 'Nhập tên cấu hình',
      configNameRequired: 'Vui lòng nhập tên cấu hình',
      configNameMaxLength: 'Tên cấu hình không được vượt quá 255 ký tự',
      type: 'Loại',
      typePlaceholder: 'Chọn loại',
      typeRequired: 'Vui lòng chọn loại',
      gradePlaceholder: 'Chọn khối lớp',
      gradeRequired: 'Vui lòng chọn khối lớp',
      subjectPlaceholder: 'Chọn môn học',
      subjectRequired: 'Vui lòng chọn môn học',
      selectToolFirst: 'Vui lòng chọn công cụ trước',
      createToolSuccess: 'Tạo công cụ thành công',
      createToolFailed: 'Tạo công cụ thất bại',
      createToolError: 'Đã có lỗi xảy ra khi tạo công cụ',
      updateToolSuccess: 'Cập nhật công cụ thành công',
      updateToolFailed: 'Cập nhật công cụ thất bại',
      updateToolError: 'Đã có lỗi xảy ra khi cập nhật công cụ',
      deleteToolTitle: 'Xác nhận xóa',
      deleteToolConfirm: 'Bạn có chắc chắn muốn xóa công cụ "{name}"?',
      deleteToolSuccess: 'Xóa công cụ thành công',
      deleteToolFailed: 'Xóa công cụ thất bại',
      deleteToolError: 'Đã có lỗi xảy ra khi xóa công cụ',
      createConfigSuccess: 'Tạo cấu hình thành công',
      createConfigFailed: 'Tạo cấu hình thất bại',
      createConfigError: 'Đã có lỗi xảy ra khi tạo cấu hình',
      editConfig: 'Chỉnh sửa cấu hình',
      updateConfigSuccess: 'Cập nhật cấu hình thành công',
      updateConfigFailed: 'Cập nhật cấu hình thất bại',
      updateConfigError: 'Đã có lỗi xảy ra khi cập nhật cấu hình',
      deleteConfigTitle: 'Xác nhận xóa',
      deleteConfigConfirm: 'Bạn có chắc chắn muốn xóa cấu hình "{name}"?',
      deleteConfigSuccess: 'Xóa cấu hình thành công',
      deleteConfigFailed: 'Xóa cấu hình thất bại',
      deleteConfigError: 'Đã có lỗi xảy ra khi xóa cấu hình',
      status: 'Trạng thái',
      editing: 'Đang chỉnh sửa',
      published: 'Đã xuất bản',
      saveAndChangeStatus: 'Lưu và chuyển trạng thái',
      upload: 'Tải lên',
      configNotFound: 'Không tìm thấy cấu hình',
      loadConfigError: 'Có lỗi xảy ra khi tải nội dung cấu hình',
      noContentToSave: 'Không có nội dung để lưu',
      saveSuccess: 'Lưu thành công',
      saveError: 'Có lỗi xảy ra khi lưu',
      uploadFeature: 'Tính năng tải lên đang được phát triển',
      uploadTemplate: 'Tải lên template',
      uploadFile: 'Tải lên tệp',
      selectFileFirst: 'Vui lòng chọn file trước',
      fileNotFound: 'Không tìm thấy file',
      invalidFileType: 'Định dạng file không hợp lệ. Chỉ chấp nhận file .docx',
      convertError: 'Có lỗi xảy ra khi chuyển đổi file',
      editorNotReady: 'Editor chưa sẵn sàng',
      uploadSuccess: 'Tải lên và chuyển đổi thành công',
      supportedFormat: 'Định dạng hỗ trợ:',
      maxFileSize: 'Kích thước tệp tối đa:',
      selectFile: 'Chọn tệp',
      next: 'Tiếp theo',
    },
    reportTypes: {
      weeklyMonthlySemester: 'Báo cáo tuần / tháng / học kỳ',
      professional: 'Báo cáo chuyên môn',
      annualSummary: 'Báo cáo tổng kết năm học',
      educationQuality: 'Báo cáo chất lượng giáo dục',
      accreditation: 'Báo cáo kiểm định',
      teacherStudentWork: 'Báo cáo công tác giáo viên – học sinh',
      educationDepartment: 'Báo cáo với Phòng GD, Sở GD',
      incidentEmergency: 'Báo cáo sự cố, đột xuất',
    },

    articleType: {
      TEACHING_PLAN: 'Kế hoạch giảng dạy',
      TEI: 'Sáng kiến kinh nghiệm',
      REPORT: 'Báo cáo',
      ELECTRONIC_LESSON_PLAN: 'Kế hoạch bài học',
      RESEARCH: 'Bài nghiên cứu',
    },

    addNewLesson: 'Thêm mới bài học',
    gradeChangeDialog: {
      title: 'Thay đổi thang điểm sẽ ảnh hưởng toàn hệ thống',
      description: 'Thang điểm mới sẽ áp dụng cho tất cả các lớp học trong hệ thống.',
      impact1: 'Các bài tập, bài kiểm tra đã chấm điểm sẽ được tính lại theo thang điểm mới.',
      impact2: 'Việc thay đổi có thể làm thay đổi kết quả hiện tại của học sinh.',
      question: 'Bạn có chắc chắn muốn tiếp tục không?',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
    },
    confirm: 'Xác nhận thay đổi',
    averageScore: 'Điểm trung bình:',
    member: {
      search: ' Tìm kiếm thành viên',
      add: 'Thêm thành viên',
      addStudent: 'Thêm học sinh',
      share: 'Chia sẻ lớp học',
      shareHint: 'Link tạm thời (chưa có API). Sẽ thay bằng link share thật khi backend sẵn sàng.',
      joinRequestsLabel: 'Yêu cầu tham gia',
      joinRequestsEmpty: 'Chưa có yêu cầu tham gia',
      title: 'Thành viên lớp học',
      name: 'Tên thành viên',
      nameStudent: 'Tên học sinh',
      email: 'Email',
      action: 'Thao tác',
      chooseMember: 'Chọn thành viên để thêm vào lớp học',
      titleDelete: 'Xóa thành viên khỏi lớp học',
      contentDelete: 'Hệ thống sẽ xoá thành viên này khỏi lớp học.<br/> Tất cả dữ liệu liên quan bao gồm bài tập, bài kiểm tra và điểm số của thành viên cũng sẽ bị xoá vĩnh viễn và không thể khôi phục.<br/> Bạn có chắc chắn muốn tiếp tục không?',
      chooseGroup: 'Chọn theo nhóm',
      addSuccess: 'Đã thêm thành công {count} thành viên',
      addFailed: 'Thêm thành viên thất bại',
      shareSub: 'Chia sẻ lớp học đến học sinh và phụ huynh',
      shareTo: 'Chia sẻ tới',
      ungrouped: 'Chưa phân nhóm',
      shareLinkLabel: 'Liên kết chia sẻ',
      joinRequests: {
        title: 'Yêu cầu tham gia lớp học',
        subtitle: 'Yêu cầu tham gia lớp học của học sinh đang chờ thầy/cô phê duyệt',
        classPlaceholder: 'Chọn lớp',
        columns: {
          fullname: 'Họ và tên',
          phone: 'Số điện thoại',
          approval: 'Phê duyệt',
        },
        status: {
          approved: 'Đã phê duyệt',
          rejected: 'Đã từ chối',
        },
        message: {
          approveAllSuccess: 'Đã duyệt tất cả yêu cầu thành công',
          approveSuccess: 'Đã duyệt yêu cầu thành công',
          rejectSuccess: 'Đã từ chối yêu cầu thành công',
          approveAllFailed: 'Duyệt tất cả yêu cầu thất bại',
          approveFailed: 'Duyệt yêu cầu thất bại',
          rejectFailed: 'Từ chối yêu cầu thất bại',
          updateError: 'Đã có lỗi xảy ra',
        },
      },
      emptyHint: 'Thêm thành viên cho lớp học để bắt đầu theo dõi tiến độ của học sinh',
      copied: 'Đã sao chép',
      copyFailed: 'Sao chép thất bại',
    },
    subject: {
      title: 'Không gian học tập',
      create: 'Thêm mới không gian học tập',
      createv2: 'Thêm mới',
      creatorSubmit: 'Tạo',
      search: 'Tìm kiếm...',
      edit: 'Sửa không gian học tập',
      titleDelete: 'Xóa không gian học tập',
      contentDelete: 'Không gian học tập sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      name: 'Tên không gian học tập',
      namePlaceholder: 'Nhập tên không gian học tập',
      avatar: 'Ảnh đại diện',
      subject: 'Môn học',
      subjectPlaceholder: 'Chọn môn học',
      note: 'Tạo tự động mỗi môn học là 1 không gian',
      createTeachingPlan: 'Tạo kế hoạch giảng dạy',
      info: 'Thông tin',
      delete: 'Xóa',
      noTeachingPlan: 'Không có kế hoạch giảng dạy nào',
      searchPlan: 'Tìm kiếm kế hoạch giảng dạy',
      uploadTeachingPlan: 'Tải lên kế hoạch giảng dạy',
      uploadTeachingPlanDescription: 'Tải lên kế hoạch giảng dạy đã lưu trong thiết bị của thầy cô.',
      uploadTeachingPlanDescription2: 'Tải lên kế hoạch giảng dạy của thầy cô',
      supportedFormats: 'Định dạng được hỗ trợ:',
      bestSupportForPdf: 'Hỗ trợ tốt nhất đối với tệp có định dạng .pdf',
      maxSize: 'Kích thước tập tối đa: 30MB',
      next: 'Tiếp theo',
      selectDataSource: 'Chọn nguồn dữ liệu',
      complete: 'Thực hiện và hoàn thành',
      back: 'Quay lại',
      teachingPlanCreated: 'Kế hoạch giảng dạy đã được tạo',
      teachingPlanCreatedDescription: 'Chúng tôi đã tự động đặt tên cho kế hoạch giảng dạy theo tên tệp bạn tải lên. Bạn có thể sửa đổi nó bất kỳ lúc nào.',
      // Subject names
      mathematics: 'Toán',
      vietnamese: 'Tiếng Việt',
      english: 'Tiếng Anh',
      physics: 'Vật lý',
      chemistry: 'Hóa học',
      biology: 'Sinh học',
      history: 'Lịch sử',
      geography: 'Địa lý',
      civic_education: 'Giáo dục công dân',
      technology: 'Công nghệ',
      informatics: 'Tin học',
      physical_education: 'Thể dục',
      music: 'Âm nhạc',
      art: 'Mỹ thuật',
      literature: 'Ngữ văn',
      natural_science: 'Khoa học tự nhiên',
      social_science: 'Khoa học xã hội',
      teachingPlanCreatedDesc: 'Kế hoạch giảng dạy đã được tạo thành công và sẵn sàng sử dụng.',
      teachingPlanFiles: 'Tệp kế hoạch giảng dạy',
      uploadTeachingPlanFiles: 'Tải lên tệp kế hoạch giảng dạy',
      uploadTeachingPlanDesc: 'Tải lên kế hoạch bài giảng của thầy cô',
      teachingPlanName: 'Tên',
      teachingPlanNamePlaceholder: 'Nhập tên kế hoạch giảng dạy',
      copyTeachingPlan: 'Sao chép kế hoạch giảng dạy',
      copyTeachingPlanDescription: 'Chọn kế hoạch giảng dạy từ lớp học khác để sử dụng.',
      selectAll: 'Chọn tất cả',
      selected: 'Đã chọn',
      total: 'Tổng',
      cancel: 'Hủy',
      add: 'Thêm',
      overview: 'Tổng quan',
      teachingPlan: 'Kế hoạch giảng dạy',
      lessonPlan: 'Kế hoạch bài dạy',
      createLessonPlan: 'Tạo kế hoạch bài dạy',
      noLessonPlan: 'Không có kế hoạch bài dạy nào',
      uploadLessonPlan: 'Tải lên kế hoạch bài dạy',
      uploadLessonPlanDescription: 'Tải lên kế hoạch bài dạy đã lưu trong thiết bị của thầy cô.',
      // uploadTeachingPlanDescription: 'Tải lên kế hoạch giảng dạy đã lưu trong thiết bị của bạn.',
      lessonPlanCreated: 'Kế hoạch bài dạy đã được tạo',
      lessonPlanCreatedDescription: 'Tải lên kế hoạch bài dạy của thầy cô',
      lessonPlanName: 'Tên',
      enterLessonPlanName: 'Nhập tên kế hoạch bài dạy',
      copyLessonPlan: 'Sao chép kế hoạch bài dạy',
      copyLessonPlanDescription: 'Chọn một kế hoạch bài dạy từ lớp học khác để sử dụng.',
      selectTool: 'Chọn từ công cụ',
      lesson: 'Bài học',
      practice: 'Bài luyện tập',
      flashcard: 'Thẻ ôn tập',
      document: 'Tài liệu',
      lessonPlanSize: 'Kích thước',
      lessonPlanUploadDate: 'Ngày tải lên',
      lessonPlanAuthor: 'Tác giả',
      titleDeleteLessonPlan: 'Xoá kế hoạch bài dạy',
      contentDeleteLessonPlan: 'Hệ thống sẽ thực hiện xoá kế hoạch bài dạy này và không thể hoàn tác. Bạn có chắc chắn muốn xoá không?',
      teachingPlanSize: 'Kích thước',
      teachingPlanUploadDate: 'Ngày tải lên',
      teachingPlanAuthor: 'Tác giả',
      titleDeleteTeachingPlan: 'Xoá kế hoạch giảng dạy',
      contentDeleteTeachingPlan: 'Hệ thống sẽ thực hiện xoá kế hoạch giảng dạy này và không thể hoàn tác. Bạn có chắc chắn muốn xoá không?',
      close: 'Đóng',
      lessonPlanFiles: 'Tệp kế hoạch bài dạy',
      subjectDescription: 'Tổng hợp kiến thức và mục tiêu học cho môn {subject}',
      assignAgentTitle: 'Thêm trợ lý hỗ trợ',
      infoLessonPlan: 'Thông tin kế hoạch bài dạy',
      infoTeachingPlan: 'Thông tin kế hoạch giảng dạy',
      download: 'Tải xuống',
      noTeachingPlanDesc: 'Thêm kế hoạch giảng dạy để bắt đầu xây dựng lộ trình dạy học và theo dõi kết quả',
      noLessonPlanDesc: 'Thêm kế hoạch bài dạy để bắt đầu xây dựng lộ trình dạy học và theo dõi kết quả',
      emptyHint: 'Bắt đầu với không gian học tập đầu tiên',
    },

    exercise: {
      title: 'Bài tập',
      not_completed: 'Chưa hoàn thành',
      no_exercise: 'Chưa có bài tập nào',
      create_exercise: 'Tạo bài tập đầu tiên',
      // Assignment modal keys
      assignConfirmTitle: 'Xác nhận giao bài tập',
      assignConfirmMessage: 'Bài tập sẽ được giao tới các thành viên lớp học.',
      assignConfirmDescription: 'Bạn có chắc chắn muốn giao bài tập này?',
      assignButton: 'Giao bài ngay',
      recallConfirmTitle: 'Thu hồi bài tập',
      recallConfirmMessage: 'Bài tập sẽ không còn hiển thị cho các thành viên lớp học và chỉ bạn mới có thể xem và sử dụng. Kết quả làm bài của các thành viên đã hoàn thành <strong>sẽ bị hủy bỏ</strong>. Bạn có chắc chắn muốn thu hồi bài tập này?',
      draftConfirmTitle: 'Bài tập chưa được giao',
      draftConfirmMessage: 'Bạn cần giao bài tập để theo dõi tiến độ và kết quả làm bài của học sinh.',
      draftConfirmDescription: 'Học sinh sẽ không nhìn thấy bài tập này cho đến khi bạn giao.',
      expireTime: 'Hạn hoàn thành',
      noExpireTime: 'Không giới hạn',
      // Exam grading modal keys
      aiGradingTitle: 'Tự động chấm bài bằng AI',
      aiGradingDescription: 'AI sẽ tự động chấm bài kiểm tra dựa trên đáp án mà bạn đã thiết lập trước đó. Các câu hỏi đã được chấm thủ công trước đó sẽ không bị thay đổi. Bạn có muốn tiếp tục chấm bài bằng AI không?',
      completeGradingTitle: 'Hoàn thành chấm bài',
      completeGradingDescription: 'Sau khi hoàn thành, hệ thống sẽ tự động tính điểm dựa trên các câu trả lời đúng mà bạn đã chấm. Bạn có muốn tiếp tục?',
      remainingQuestionsTitle: 'Còn {count} câu chưa được chấm',
      remainingQuestionsDescription: 'Bạn vẫn còn {count} câu hỏi chưa được chấm. Bạn có muốn để AI tự động chấm các câu còn lại và hoàn thành chấm bài hay tiếp tục chấm thủ công?',
      gradeButton: 'Chấm bài',
      completeButton: 'Hoàn thành',
      continueManualGrading: 'Tiếp tục chấm',
      useAiAndComplete: 'Dùng AI và hoàn thành',
      aiGradingStarted: 'Đã bắt đầu chấm bài bằng AI',
      gradingCompleted: 'Đã hoàn thành chấm bài',
      aiGradingAndCompleted: 'Đã sử dụng AI để chấm bài còn lại và hoàn thành',
      // Student exercise result keys
      aiGradingButton: 'AI chấm bài',
      correctAnswersCount: 'Số câu đúng: {percentage}%',
      resultQuestionNumber: 'Câu hỏi {number}',
      resultCorrect: 'Đúng',
      resultIncorrect: 'Sai',
      keywordLabel: 'Từ khóa:',
      sampleAnswerLabel: 'Câu trả lời mẫu:',
      studentAnswerLabel: 'Câu trả lời của học sinh:',
      scoreDisplay: '{current}/{max}',
      accuracyPercentage: 'Chính xác: {percentage}%',
      regradeLabel: 'Chấm điểm lại',
      editAnswerLabel: 'Nhận xét từ giáo viên',
      editAnswerPlaceholder: 'Nhập nội dung nhận xét tại đây...',
      quickGradingLabel: 'Chấm điểm nhanh',
      resultCompleteButton: 'Hoàn thành',
      updateResultTitle: 'Cập nhật kết quả làm bài',
      updateResultContent: 'Hệ thống sẽ lưu thay đổi điểm số của học sinh và đồng bộ vào tất cả các bài tập liên quan. Bạn có chắc chắn muốn lưu lại không?',
      questions: 'Câu hỏi',
      students_submitted: 'học sinh đã nộp',
      correct: 'Chính xác',
      deadline: 'Hạn hoàn thành',
      question: 'Nhập câu hỏi',
      answer: 'Nhập câu trả lời',
      add: 'Thêm câu hỏi',
      delete: 'Xóa',
      complete: 'Hoàn thành',
      placeholder: 'Nhập giá trị',
      incorrect: 'Sai',
      essayPlaceholder: 'Nhập đáp án câu tự luận',
      enterYourAnswer: 'Nhập câu trả lời của bạn...',
      blankPlaceholder: 'trống',
      orderPlaceholder: 'Câu thứ {n}',
      type: {
        multipleChoice: 'Câu hỏi trắc nghiệm',
        trueFalse: 'Đúng/Sai',
        essay: 'Tự luận',
        ordering: 'Sắp xếp',
        fillBlank: 'Điền vào chỗ trống',
      },
      addQuestion: 'Thêm câu hỏi',
      added: 'Đã thêm câu hỏi',
      deleted: 'Đã xóa câu hỏi',
      completed: 'Đã hoàn thành bài tập',
      enterQuestion: 'Vui lòng nhập câu hỏi',
      correctAnswer: 'Câu trả lời đúng',
      orderList: 'Danh sách cần sắp xếp:',
      orderCorrect: 'Thứ tự đúng:',
      questionNumber: 'Câu hỏi {n}',
      questionSample1: 'Xác suất thống kê là gì?',
      questionSample2: 'Câu hỏi điền vào chỗ ____ Câu trả lời điền tại ô dưới',
      questionSample3: 'Câu hỏi đúng/sai',
      questionSample4: 'Câu hỏi tự luận',
      questionSample5: 'Câu hỏi sắp xếp',
      answerSample1: 'Demo câu trả lời trắc nghiệm sai',
      answerSample2: 'Demo câu trả lời trắc nghiệm sai',
      answerSample3: 'Demo câu trả lời trắc nghiệm đúng',
      answerSample4: 'Demo câu trả lời trắc nghiệm sai',
      titleDelete: 'Xóa bài tập',
      contentDelete: 'Bài tập sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      single: 'Từng câu',
      all: 'Tất cả câu',
      result: 'Kết quả',
      progress: 'Tiến độ',
      next: 'Câu tiếp',
      back: 'Quay lại',
      remaining: 'Còn lại',
      totalQuestions: 'Tổng số câu',
      score: 'Điểm số',
      correctAnswers: 'Đáp án đúng',
      incorrectAnswers: 'Đáp án sai',
      retry: 'Làm lại',
      close: 'Thoát',
      questionType: {
        multipleChoice: 'Chọn đáp án đúng',
        trueFalse: 'Đúng/Sai',
        fillBlank: 'Điền vào chỗ trống',
        shortAnswer: 'Câu hỏi ngắn',
        openEnded: 'Câu hỏi tự luận',
        ordering: 'Sắp xếp theo thứ tự',
      },
      resultMessage: 'Bạn đã hoàn thành xuất sắc {correct} trên tổng số {total} câu hỏi',
      shareConfirmation: 'Xác nhận giao bài tập',
      shareConfirmationDescription: 'Bài tập sẽ được giao cho học sinh trong lớp học để thực hiện.',
      unshareConfirmation: 'Xác nhận hủy chia sẻ',
      unshareConfirmationDescription: 'Bài tập sẽ không còn được giao cho học sinh và chỉ bạn mới có thể xem.',
      share: 'Giao bài tập',
      unshare: 'Hủy giao bài tập',
      cancel: 'Hủy',
      probability: 'Xác suất thống kê',
      createdDate: 'Ngày tạo',
      completedDate: 'Ngày hoàn thành',
      waitingForCompletion: 'Đang chờ hoàn thành',
      notSubmitted: 'Chưa nộp',
      completionPercentage: 'Tỷ lệ hoàn thành',
      searchStudent: 'Tìm kiếm học sinh...',
      incomplete: 'Chưa hoàn thành',
      preview: 'Xem trước',
      resultsError: 'Không thể hiển thị kết quả',
      keyword: 'Từ khóa',
      aiComment: 'Nhận xét từ AI Và Giáo viên',
      detailedComment: 'Nhận xét chi tiết',
      structure: 'Cấu trúng',
      content: 'Nội dung',
      language: 'Ngôn ngữ',
      improvementSuggestions: 'Gợi ý cải thiện',
      students: 'học sinh',
      deadlineNear: 'Hạn hoàn thành gần kề',
      correctAnswerLabel: 'Đáp án đúng',
      incorrectAnswerLabel: 'Đáp án sai',
      submitConfirmDesc: 'Vẫn còn thời gian làm bài. Bạn có muốn xem lại bài trước khi nộp không?',
      submitConfirmTitle: 'Xác nhận nộp bài',
      assignExerciseConfirm: 'Bài tập sẽ được giao tới tất cả thành viên lớp học.',
      assignExerciseConfirm2: 'Bạn có chắc chắn muốn giao bài tập này?',
      recallExerciseConfirm1: 'Bài tập sẽ không còn hiển thị cho các thành viên lớp học và học sinh sẽ không thể xem sử dụng.',
      recallExerciseConfirm2: 'Bạn có chắc muốn thu hồi bài tập này?',
      score_breakdown: 'Điểm số',
      completion_progress: 'Tiến độ hoàn thành',
      shareConfirm: 'Xác nhận giao bài tập',
      shareConfirmDescription: 'Bài tập sẽ được giao tới các thành viên lớp học.',
      shareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn giao bài tập này?',
      unShareConfirm: 'Thu hồi bài tập',
      unShareConfirmDescription: 'Bài tập sẽ không còn hiển thị cho các thành viên lớp học và chỉ bạn mới có thể xem và sử dụng. Kết quả làm bài của các thành viên đã hoàn thành <strong>sẽ bị hủy bỏ</strong>',
      unShareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn thu hồi bài tập này',
      improvements: 'Cần cải thiện',
      strengths: 'Điểm mạnh',
      noData: 'Chưa có dữ liệu',
      completedSummary: 'Đã hoàn thành',
      resultSummary: 'Kết quả tổng hợp',
      generalEvaluation: 'Đánh giá bài làm',
      assign: 'Giao bài',
      recall: 'Thu hồi',
      assignSuccess: 'Giao bài tập thành công',
      assignError: 'Có lỗi xảy ra khi giao bài tập',
      recallSuccess: 'Đã hủy giao bài tập',
      recallError: 'Có lỗi xảy ra khi hủy giao bài tập',
      statusAssigned: 'Đã giao',
      statusDraft: 'Chưa giao',
      statusCompleted: 'Hoàn thành',
      statusExpired: 'Hết hạn',
      exerciseInfo: 'Nhập thông tin bài tập',
      addNote: 'Thêm nhận xét',
      evaluation: {
        strengths: {
          multipleChoice: 'Nhận diện và chọn đáp án chính xác',
          trueFalse: 'Phân biệt đúng sai rõ ràng',
          fillBlank: 'Nắm vững thuật ngữ và khái niệm',
          shortAnswer: 'Trình bày ý tưởng ngắn gọn',
          essay: 'Phân tích và giải thích chi tiết',
          ordering: 'Hiểu thứ tự logic',
          keyword: 'Nắm bắt từ khóa quan trọng',
          default: 'Thực hiện tốt loại câu hỏi này',
          generalGood: 'Hiểu rõ kiến thức cơ bản',
          applyFormula: 'Áp dụng công thức chính xác',
          completed: 'Hoàn thành bài kiểm tra',
        },
        improvements: {
          multipleChoice: 'Cần đọc kỹ đề bài và phân tích kỹ hơn',
          trueFalse: 'Cần hiểu rõ khái niệm cơ bản',
          fillBlank: 'Cần học thuộc thuật ngữ chính xác',
          shortAnswer: 'Cần luyện tập cách diễn đạt',
          essay: 'Cần phát triển kỹ năng phân tích',
          ordering: 'Cần hiểu logic trình tự',
          keyword: 'Cần nắm bắt từ khóa quan trọng',
          default: 'Cần cải thiện kỹ năng này',
          reviewBasic: 'Cần ôn tập lại kiến thức cơ bản',
          practiceMore: 'Luyện tập thêm các dạng bài tập',
          continueImprove: 'Tiếp tục phát triển kỹ năng',
        },
      },
    },
    exam: {
      emptyHint: 'Giao các bài kiểm tra để bắt đầu theo dõi kết quả làm bài của học sinh',
      emptyAction: 'Lên lịch kiểm tra',
      title: 'Bài kiểm tra',
      titleTeacher: 'Đề kiểm tra',
      titleStudent: 'Bài kiểm tra',
      searchPlaceholder: 'Tìm kiếm',
      empty: 'Không có bài kiểm tra nào',
      emptySearch: 'Không tìm thấy bài kiểm tra nào',
      loadError: 'Không thể tải danh sách bài kiểm tra',
      durationLabel: 'Thời gian làm bài',
      examDateLabel: 'Ngày kiểm tra',
      startTimeLabel: 'Giờ kiểm tra',
      totalScoreLabel: 'Tổng điểm',
      durationMinutes: '{minutes} phút',
      duration: 'Thời gian làm bài',
      minutes: 'phút',
      startExam: 'Bắt đầu kiểm tra',
      viewResult: 'Xem kết quả',
      listButton: 'Danh sách',
      submittedCount: '{submitted} / {total} học sinh đã nộp',
      testDuration: 'Thời gian làm bài',
      testDate: 'Ngày kiểm tra',
      testTime: 'Giờ kiểm tra',
      defaultDuration: '15 phút',
      detailTitle: 'Chi tiết bài kiểm tra',
      backToClass: 'Quay lại lớp học',
      countdownMessage: 'Bạn có thể bắt đầu làm bài sau:',
      endedTitle: 'Bài kiểm tra đã kết thúc',
      endedDescription: 'Thời gian làm bài đã hết theo quy định của giáo viên.',
      contactTeacherMessage: 'Nếu bạn cần thêm thời gian để hoàn thành, vui lòng liên hệ giáo viên để được hỗ trợ.',
      status: {
        pending: 'Chưa thực hiện',
        completed: 'Đã hoàn thành',
        overdue: 'Quá hạn',
        unknown: 'Không xác định',
      },
      teacherStatus: {
        graded: 'Đã chấm bài',
        notGraded: 'Chưa chấm bài',
      },
      completionTitle: 'Chúc mừng bạn đã hoàn thành bài kiểm tra',
      completionDescription: 'Bài kiểm tra của bạn đã được nộp. Bạn sẽ nhận được kết quả sau khi giáo viên chấm điểm',
      completionButton: 'Quay lại lớp học',
      completed: 'Đã hoàn thành',
      notCompleted: 'Chưa hoàn thành',
      notSubmitted: 'Chưa nộp',
      submitted: 'Đã nộp',
      notGraded: 'Chưa chấm bài',
      graded: 'Đã chấm bài',
      student: 'Học sinh',
      expired: 'Hết hạn',
      notStarted: 'Chưa tới giờ',
      students: 'Học sinh',
      questions: 'Câu hỏi',
      deadline: 'Hạn hoàn thành',
      noDeadline: 'Không giới hạn',
      progress: 'Tiến độ',
      incomplete: 'Chưa hoàn thành',
      completionPercentage: 'Tỷ lệ hoàn thành',
      searchStudent: 'Tìm kiếm học sinh...',
      completedDate: 'Ngày hoàn thành',
      createdDate: 'Ngày tạo',
      waitingForCompletion: 'Đang chờ hoàn thành',
      preview: 'Xem trước',
      chapter: 'Chương',

      // Grading related translations
      resultQuestionNumber: 'Câu hỏi {number}',
      resultCorrect: 'Đúng',
      resultIncorrect: 'Sai',
      scoreDisplay: '{current}/{max}',
      accuracyPercentage: 'Độ chính xác {percentage}%',
      regradeLabel: 'Chấm lại',
      editAnswerLabel: 'Nhận xét từ giáo viên',
      editAnswerPlaceholder: 'Thêm nhận xét...',
      quickGradingLabel: 'Thao tác nhanh',
      resultCompleteButton: 'Hoàn thành chấm bài',
      aiGradingButton: 'Chấm điểm AI',
      gradingCompleted: 'Chấm bài thành công',
      resultsError: 'Không thể tải kết quả kiểm tra',

      // AI feedback related
      aiComment: 'Nhận xét AI',
      detailedComment: 'Nhận xét chi tiết',
      content: 'Nội dung',
      structure: 'Cấu trúc',
      language: 'Ngôn ngữ',
      improvementSuggestions: 'Đề xuất cải thiện',
      score: 'Điểm',

      // Question types
      keywordLabel: 'Từ khóa',
      sampleAnswerLabel: 'Đáp án mẫu',
      studentAnswerLabel: 'Câu trả lời',
      results: 'Kết quả',
      waitingForExamEnd: 'Đang chờ kết thúc bài thi',
      inProgress: 'Đang diễn ra',
      remainingToViewResult: 'Còn lại {time} để có thể xem kết quả',
      cannotViewResultUntilEnd: 'Chưa thể xem kết quả. Vui lòng đợi kết thúc thời gian làm bài.',
      viewResults: 'Xem kết quả',
      score_breakdown: 'Điểm số',
      completion_progress: 'Tiến độ hoàn thành',
      uncompleted: 'Chưa hoàn thành',
      noResults: 'Không có kết quả',
      correct: 'Chính xác',
      exam: 'Kiểm tra',
    },
    lessonWorkspace: {
      documents: 'Tài liệu',
      slides: 'Trình chiếu',
      notes: 'Ghi chú',
      exercises: 'Bài tập',
      flashcards: 'Thẻ ôn tập',
      whiteboard: 'Bảng trắng',
      exit: 'Thoát',
      documentsDescription: 'Xem và quản lý tài liệu bài học',
      slidesDescription: 'Trình chiếu slides cho học sinh',
      notesDescription: 'Ghi chú trong lúc giảng dạy',
      exercisesDescription: 'Quản lý và giao bài tập',
      flashcardsDescription: 'Sử dụng thẻ ôn tập',
      whiteboardDescription: 'Bảng trắng tương tác',
      noDocuments: 'Chưa có tài liệu nào',
      comingSoon: 'Chức năng đang phát triển',
      notesPlaceholder: 'Nhập ghi chú của bạn...',
    },

    // Subject Selection
    subjectSelection: {
      title: 'Chào thầy/cô, hãy chọn môn học để bắt đầu tiết dạy hôm nay!',
      lessons: 'bài học',
      clickToView: 'Nhấn để xem bài học',
      noSubjects: 'Không có môn học nào',
    },

    // Lesson List
    lessonList: {
      title: 'Bài học môn {subject}',
      startLesson: 'Bắt đầu bài học',
      present: 'Trình chiếu',
    },
    result: {
      title: 'Kết quả học tập',
      question: 'Câu hỏi',
      correct: 'Đúng',
      incorrect: 'Sai',
      completed: 'Đã hoàn thành',
      remaining: 'Còn lại',
      totalQuestions: 'Tổng số câu',
      retake: 'Làm lại',
      explain: 'Giải thích câu hỏi',
      complete: 'Bạn đã hoàn thành xuất sắc {correctAnswers} trên tổng số {totalQuestions} câu hỏi',
      averageScore: 'Điểm trung bình',
      strengths: 'Điểm mạnh',
      needsImprovement: 'Cần cải thiện',
      events: 'Nhận diện biến cố đơn và hợp',
      classicalFormula: 'Áp dụng công thức xác suất cổ điển',
      frequency: 'Phân tích bằng tần suất',
      conditional: 'Xác suất có điều kiện',
      additionRule: 'Tính xác suất bằng quy tắc cộng',
      frequencyChart: 'Đọc hiểu biểu đồ tần suất',
      all: 'Tất cả',
      subjectAll: 'Môn học: Tất cả',
      typeAll: 'Xem theo: Bài kiểm tra và bài tập',
      type: 'Loại',
      studentAssessment: 'Đánh giá học sinh',
      emptyAddStudentHint: 'Thêm thành viên cho lớp học để bắt đầu theo dõi tiến độ của học sinh',
    },
    questionCard: {
      motivationalMessage: 'Đừng lo, bạn vẫn đang học mà!',
      showHint: 'Bạn không biết?',
      viewAnswer: 'Xem đáp án',
      checkAnswer: 'Kiểm tra',
    },
    lesson: {
      title: 'Bài học',
      create: 'Tạo bài học',
      createv2: 'Thêm mới bài học',
      createNewlesson: 'Lưu vào bài học mới',
      edit: 'Sửa bài học',
      search: 'Tìm kiếm',
      createContent: 'Thêm nội dung',
      agentSupport: 'Trợ lý lớp học',
      createAgentSupport: 'Thêm trợ lý giáo dục',
      createFirstAgentSupport: 'Thêm mới trợ lý đầu tiên',
      titleDelete: 'Xóa bài học',
      contentDelete: 'Bài học sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      name: 'Tên bài học',
      namePlaceholder: 'Nhập tên bài học',
      description: 'Mô tả bài học',
      descriptionPlaceholder: 'Nhập mô tả bài học',
      titleDeleteAgentSupport: 'Xóa trợ lý giáo dục',
      contentDeleteAgentSupport: 'Trợ lý giáo dục sẽ bị xóa. Bạn có chắc chắn muốn xóa không?',
      shareConfirmation: 'Xác nhận chia sẻ',
      shareConfirmationDescription: 'Toàn bộ bài học sẽ được công khai để các thành viên lớp học có thể xem và sử dụng.',
      unshareConfirmation: 'Xác nhận hủy chia sẻ',
      unshareConfirmationDescription: 'Toàn bộ bài học sẽ không còn hiển thị cho các thành viên lớp học và chỉ bạn mới có thể xem và sử dụng.',
      shareConfirm: 'Xác nhận chia sẻ',
      shareConfirmDescription: 'Toàn bộ bài học sẽ được công khai để các thành viên lớp học có thể xem và sử dụng.',
      shareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn chia sẻ bài học này?',
      unShareConfirm: 'Hủy chia sẻ bài học',
      unShareConfirmDescription: 'Toàn bộ bài học sẽ không còn hiển thị cho các thành viên lớp học và chỉ bạn mới có thể xem và sử dụng.',
      unShareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn hủy chia sẻ bài học này?',
      sharedConfirm: 'Bài học đã được chia sẻ',
      sharedConfirmDescription: 'Tất cả tài liệu và nội dung học tập trong bài học này đã được chia sẻ.',
      sharedConfirmDescriptionBottom: 'Không có thêm nội dung mới để chia sẻ.',
      unSharedConfirm: 'Bài học đã được ngừng chia sẻ',
      unSharedConfirmDescription: 'Tất cả tài liệu và nội dung học tập trong bài học này đã được ngừng chia sẻ.',
      unSharedConfirmDescriptionBottom: 'Không có thêm nội dung nào cần ngừng chia sẻ nữa.',
      share: 'Chia sẻ',
      unshare: 'Hủy chia sẻ',
      cancel: 'Hủy',
      onlyMe: 'Chỉ mình tôi',
      shared: 'Đã chia sẻ',
      assigned: 'Đã giao',
      stopShare: 'Ngừng chia sẻ',
      public: 'Công khai',
      agree: 'Đồng ý',
      revoke: 'Thu hồi',
      emptyHint: 'Tạo bài học đầu tiên để bắt đầu',
      emptyHintExcercise: 'Tạo bài học đầu tiên để bắt đầu các bài tập',
      noContent: 'Chưa có nội dung',
      noContentDescription: 'Thêm mới nội dung đầu tiên cho bài học',
      bulkShareSuccess: 'Chia sẻ nội dung bài học thành công',
      bulkShareError: 'Có lỗi xảy ra khi chia sẻ nội dung bài học',
      bulkUnshareSuccess: 'Ngừng chia sẻ nội dung bài học thành công',
      bulkUnshareError: 'Có lỗi xảy ra khi ngừng chia sẻ nội dung bài học',
    },
    practice: {
      title: 'Bài luyện tập',
      create: 'Tạo bài luyện tập',
      search: 'Tìm kiếm bài luyện tập',
      createContent: 'Thêm nội dung luyện tập',
      titleDelete: 'Xóa bài luyện tập',
      contentDelete: 'Bài luyện tập sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      name: 'Tiêu đề bài luyện tập',
      namePlaceholder: 'Nhập tiêu đề bài luyện tập',
      description: 'Mô tả',
      descriptionPlaceholder: 'Mô tả',
      progress: 'Tiến độ',
      next: 'Tiếp tục',
      questionType: {
        multipleChoice: 'Chọn đáp án đúng',
        trueFalse: 'Đúng/Sai',
        fillBlank: 'Điền vào chỗ trống',
        shortAnswer: 'Câu hỏi ngắn',
        openEnded: 'Câu hỏi tự luận',
        ordering: 'Sắp xếp theo thứ tự',
      },
      shareConfirm: 'Xác nhận chia sẻ',
      shareConfirmDescription: 'Bài luyện tập sẽ được công khai để các thành viên lớp học có thể xem và sử dụng.',
      shareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn chia sẻ thẻ bài luyện tập này?',
      unShareConfirm: 'Hủy chia sẻ bài luyện tập',
      unShareConfirmDescription: 'Bài luyện tập sẽ không còn hiển thị cho các thành viên lớp học và chỉ bạn mới có thể xem và sử dụng.',
      unShareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn hủy chia sẻ bài luyện tập này?',
      practiceInfo: 'Nhập thông tin bài luyện tập',
      shareSuccess: 'Chia sẻ bài luyện tập thành công',
      shareError: 'Có lỗi xảy ra khi chia sẻ bài luyện tập',
      unShareSuccess: 'Hủy chia sẻ bài luyện tập thành công',
      unShareError: 'Có lỗi xảy ra khi hủy chia sẻ bài luyện tập',
    },
    flashcard: {
      title: 'Thẻ ôn tập',
      practiceTitle: 'Luyện tập thẻ ôn tập',
      clickToFlip: 'Nhấp để lật thẻ',
      nextCard: 'Thẻ tiếp theo',
      shuffle: 'Xáo trộn',
      allCards: 'Tất cả thẻ',
      bookmarkedCards: 'Thẻ đã đánh dấu',
      flipCard: 'Lật thẻ',
      aiAssistantTitle: 'Trợ lý AI',
      aiAssistantPlaceholder: 'Hỏi AI về nội dung thẻ ôn tập...',
      congrats: 'Chúc mừng!',
      completedAll: 'Bạn đã hoàn thành tất cả thẻ ôn tập',
      yourProgress: 'Tiến độ của bạn',
      completed: 'Đã hoàn thành',
      remaining: 'Còn lại',
      retry: 'Luyện tập lại',
      titleDelete: 'Xóa thẻ ôn tập',
      contentDelete: 'Thẻ ôn tập sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      questionType: {
        multipleChoice: 'Chọn đáp án đúng',
        trueFalse: 'Đúng/Sai',
        fillBlank: 'Điền vào chỗ trống',
        shortAnswer: 'Câu hỏi ngắn',
        openEnded: 'Câu hỏi tự luận',
        ordering: 'Sắp xếp theo thứ tự',
        flashcard: 'Thẻ câu hỏi',
      },
      answerSample: 'Đáp án tham khảo',
      correct: 'Chính xác',
      incorrect: 'Sai',
      pleaseTryAgain: 'Hãy thử lại',
      correctAnswerIs: 'Đáp án đúng là',
      close: 'Đóng',
      check: 'Kiểm tra',
      shareConfirm: 'Xác nhận chia sẻ',
      shareConfirmDescription: 'Thẻ ôn tập sẽ được công khai để các thành viên lớp học có thể xem và sử dụng.',
      shareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn chia sẻ thẻ ôn tập này?',
      unShareConfirm: 'Hủy chia sẻ thẻ ôn tập',
      unShareConfirmDescription: 'Thẻ ôn tập sẽ không còn hiển thị cho các thành viên lớp học và chỉ bạn mới có thể xem và sử dụng.',
      unShareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn hủy chia sẻ thẻ ôn tập này?',
      shareSuccess: 'Chia sẻ thẻ ôn tập thành công',
      shareError: 'Có lỗi xảy ra khi chia sẻ thẻ ôn tập',
      unShareSuccess: 'Hủy chia sẻ thẻ ôn tập thành công',
      unShareError: 'Có lỗi xảy ra khi hủy chia sẻ thẻ ôn tập',
    },
    document: {
      title: 'Tài liệu',
      titleDelete: 'Xóa tài liệu',
      contentDelete: 'Tài liệu sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      uploadTitle: 'Tải lên tài liệu học tập',
      uploadDescription: 'Tải lên tài liệu cho bài học của thầy cô',
      shareConfirm: 'Xác nhận chia sẻ',
      shareConfirmDescription: 'Tài liệu sẽ được công khai để các thành viên lớp học có thể xem và sử dụng.',
      shareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn chia sẻ tài liệu này?',
      unShareConfirm: 'Hủy chia sẻ tài liệu',
      unShareConfirmDescription: 'Tài liệu sẽ không còn hiển thị cho các thành viên lớp học và chỉ bạn mới có thể xem và sử dụng.',
      unShareConfirmDescriptionBottom: 'Bạn có chắc chắn muốn hủy chia sẻ tài liệu này?',
      shareSuccess: 'Chia sẻ tài liệu thành công',
      shareError: 'Có lỗi xảy ra khi chia sẻ tài liệu',
      unShareSuccess: 'Hủy chia sẻ tài liệu thành công',
      unShareError: 'Có lỗi xảy ra khi hủy chia sẻ tài liệu',
      uploadSuccess: 'Tải lên file thành công',
      uploadError: 'Tải lên file thất bại',
      createSuccess: 'Tạo tài liệu của bài học thành công',
      createError: 'Tạo tài liệu của bài học thất bại',
    },
    content: {
      smartGeneration: 'Thiết kế bài tập hấp dẫn với tính năng tạo câu hỏi bằng AI',
      smartGenerationPractice: 'Thiết kế bài luyện tập hấp dẫn với tính năng tạo câu hỏi bằng AI',
      smartGenerationFlashcard: 'Thiết kế flashcard hấp dẫn với tính năng tạo flashcard tự động bằng AI',
      uploadDocument: 'Tải lên tài liệu',
      descriptionDocument: 'Tải lên tệp tài liệu, ghi chú để chia sẻ cho học sinh.',
      createPractice: 'Tạo bài tập luyện',
      descriptionPractice: 'Tạo bài quizz từ nội dung thầy cô đã giảng dạy giúp học sinh học tập hiệu quả.',
      createFlashcard: 'Tạo thẻ ôn tập',
      descriptionFlashcard: 'Tạo bộ thẻ ghi nhớ nhanh từ nội dung bài giảng để giúp học sinh ôn tập dễ dàng. ',
      createExercise: 'Tạo bài tập',
      descriptionExercise: 'Tạo nhanh đề kiểm tra dựa trên nội dung giảng dạy của thầy cô.',
      uploadNewDocument: 'Tạo mới tài liệu',
      descriptionNewDocument: 'Tải lên tệp tài liệu mới.',
      selectKnowledge: 'Chọn từ Bộ kiến thức',
      descriptionSelectKnowledge: 'Chọn tài liệu từ kho Kiến thức đã tải lên.',
      selectLesson: 'Chọn từ tài liệu đã tải lên',
      descriptionSelectLesson: 'Tái sử dụng nội dung từ bài học đã có.',
      selectTool: 'Chọn từ công cụ',
      descriptionSelectTool: 'Sử dụng slide và ý tưởng đã tạo ',
      dataSource: 'Chọn tệp dữ liệu',
      executeFinish: 'Kiểm tra và hoàn thành',
      addKnowledge: 'Thêm vào kho kiến thức',
      finish: 'Hoàn thành',
      contentCreated: 'Tài liệu đã được tạo',
      documentCreated: 'Tài liệu học tập đã được tạo',
      documentCreatedSubject: 'Tài liệu học tập môn {subject} đã được tạo',
      contentCreatedDes: 'Chúng tôi đã tự động đặt tên  cho tài liệu theo tên tệp bạn tải lên. Bạn có thể sửa đổi nó bất kỳ lúc nào.',
      documentName: 'Tên tệp tài liệu',
      createSelectKnowledge: 'Thêm nội dung từ bộ kiến thức',
      descriptionCreateSelectKnowledge: 'Thêm nội dung đã được tải lên tại Kiến thức',
      createSelectLesson: 'Thêm nội dung từ bài học',
      createSelectTool: 'Thêm tài liệu từ nội dung đã tải lên',
      descriptionCreateSelectTool: 'Thêm nội dung đã được tải lên tại các bài học',
      descriptionCreateSelectLesson: 'Thêm nội dung đã được tải lên tại các bài học',
      createBlankPage: 'Bắt đầu từ một trang trắng',
      descriptionBlankPage: 'Tạo thẻ ôn tập từ ý tưởng của bạn.',
      createFromLesson: 'Tạo từ Bài học',
      descriptionFromLesson: 'Tạo bộ thẻ ghi nhớ nhanh từ nội dung bài giảng giúp học sinh ôn tập dễ dàng.',
      next: 'Tiếp theo',
      documentSource: 'Nguồn tài liệu',
      model: 'Chọn mô hình',
      practiceInfo: 'Thông tin bài tập luyện',
      exerciseInfo: 'Thông tin bài tập',
      flashcardInfo: 'Thông tin thẻ ôn tập',
      flashcardInfoInput: 'Nhập thông tin tạo thẻ',
      name: 'Tên',
      exerciseName: 'Tên bài tập',
      flashcardName: 'Tên thẻ ôn tập',
      practiceName: 'Tên bài luyện tập',
      description: 'Mô tả',
      question: 'Câu hỏi',
      questionAnswer: 'Câu hỏi & câu trả lời',
      multipleChoiceNumber: 'Câu hỏi trắc nghiệm',
      trueFalseNumber: 'Câu hỏi đúng/sai',
      openEndedNumber: 'Câu hỏi tự luận',
      blankNumber: 'Điền vào chỗ trống',
      shortAnswerNumber: 'Câu trả lời ngắn',
      orderingNumber: 'Sắp xếp theo thứ tự',
      difficulty: 'Độ khó',
      difficultyPlaceholder: 'Chọn độ khó',
      rememberLevel: 'Nhận biết',
      applyLevel: 'Vận dụng',
      analyzeLevel: 'Vận dụng cao',
      additionalRequirement: 'Yêu cầu',
      placeholderRequirement: 'Nhập yêu cầu tạo câu hỏi mong muốn cho các tài liệu được chọn.',
      dueDate: 'Hạn hoàn thành',
      cardType: 'Loại thẻ',
      keywordCard: 'Thẻ từ khóa - giải thích',
      multipleChoiceAnswerCard: 'Thẻ câu trả lời trắc nghiệm',
      blankCard: 'Thẻ điền vào chỗ trống',
      documentList: 'Danh sách tài liệu',
      chooseLearningSpace: 'Chọn không gian học tập',
      chooseLesson: 'Chọn bài học',
      chooseClassroom: 'Chọn lớp',
      keyword: 'Từ khóa',
      addImage: 'Thêm hình ảnh',
      addImageAI: 'Tạo ảnh tự động',
      definition: 'Đinh nghĩa',
      preview: 'Xem trước',
      addBlank: 'Thêm ô trống',
      addAnswer: 'Thêm câu trả lời',
      addCard: 'Thêm thẻ',
      answerOption: 'Lựa chọn trả lời',
      questionConfiguration: 'Cấu hình câu hỏi',
      additionalSettings: 'Cài đặt bổ sung',
      addOption: 'Thêm lựa chọn',
      ideasCreated: 'Ý tưởng đã tạo',
      slideCreated: 'Bài thuyết trình đã tạo',
      saveQuestionBank: 'Lưu vào ngân hàng câu hỏi',
      fillBankPlaceholder: 'Điền vào [Chỗ trống]',
      uploadImage: 'Tải ảnh lên',
      messages: {
        createExerciseSuccess: 'Thêm mới bài tập thành công',
        createExerciseError: 'Thêm mới bài tập thất bại',
        updateExerciseSuccess: 'Cập nhật bài tập thành công',
        updateExerciseError: 'Cập nhật bài tập thất bại',
        createFlashcardSuccess: 'Thêm mới thẻ ôn tập thành công',
        createFlashcardError: 'Thêm mới thẻ ôn tập thất bại',
        updateFlashcardSuccess: 'Cập nhật thẻ ôn tập thành công',
        updateFlashcardError: 'Cập nhật thẻ ôn tập thất bại',
        createPracticeSuccess: 'Thêm mới bài luyện tập thành công',
        createPracticeError: 'Thêm mới bài luyện tập thất bại',
        updatePracticeSuccess: 'Cập nhật bài luyện tập thành công',
        updatePracticeError: 'Cập nhật bài luyện tập thất bại',
      },
    },
    question: {
      create: 'Tạo câu hỏi',
      creating: 'Đang tạo câu hỏi',
      answer: 'Câu trả lời',
      chooseQuestionTypePlaceholder: 'Chọn loại câu hỏi',
      questionPlaceholder: 'Nhập câu hỏi',
      addWithAI: 'Tạo câu hỏi với AI',
      addCardWithAI: 'Tạo thẻ bằng AI',
      limitNumber: 'Tổng câu hỏi phải lớn hơn 0 và nhỏ hơn hoặc bằng 20',
      checkNumber: 'Tổng số câu hỏi phải bằng tổng số câu hỏi theo từng cấp độ',
      correctOrder: 'Thứ tự đúng',
      incorrect: 'Bạn đã trả lời sai',
      correctAnswer: 'Đáp án đúng',
      answerOrdering: 'Đáp án theo thứ tự',
      enterAnswerOrdering: 'Nhập đáp án theo thứ tự',
      enterAnswerOrderingNumber: 'Nhập đáp án theo thứ tự {n}',
      question: 'Câu hỏi',
      addOptionAnswer: 'Thêm đáp án',
      questionCreatedSuccessfully: 'Tạo câu hỏi thành công',
      questionCreatedFailed: 'Tạo câu hỏi thất bại',
      questionCardCreatedSuccessfully: 'Tạo thẻ thành công',
      questionCardCreatedFailed: 'Tạo thẻ thất bại',
    },

    examPaper: {
      title: 'Kho đề kiểm tra',
      createExamPaper: 'Tạo đề kiểm tra',
      editExamPaper: 'Sửa đề kiểm tra',
      duplicateExamPaper: 'Nhân bản đề kiểm tra',
      questionLibrary: 'Ngân hàng câu hỏi',
      exam: 'Lịch kiểm tra',
      searchExam: 'Tìm kiếm lịch kiểm tra',
      createExam: 'Lên lịch kiểm tra',
      editExam: 'Sửa lịch kiểm tra',
      examDate: 'Ngày kiểm tra',
      examDatePlaceholder: 'Chọn ngày kiểm tra',
      class: 'Lớp',
      classPlaceholder: 'Chọn lớp',
      nameExam: 'Đề kiểm tra',
      nameExamPlaceholder: 'Chọn đề kiểm tra',
      duration: 'Thời gian làm bài',
      durationPlaceholder: 'Chọn thời gian làm bài',
      status: 'Trạng thái',
      showAnswer: 'Hiển thị đáp án',
      hideAnswer: 'Ẩn đáp án',
      searchQuestion: 'Tìm kiếm',
      questionTypePlaceholder: 'Loại câu hỏi',
      nameExamPaper: 'Tên đề kiểm tra',
      nameExamPaperPlaceholder: 'Tên đề kiểm tra',
      subjectPlaceholder: 'Chọn môn học',
      questionDisplayMode: 'Hiển thị câu trong đề',
      questionDisplayModePlaceholder: 'Chọn cách hiển thị câu trong đề',
      splitExamParts: 'Tách đề kiểm tra thành 2 phần Trắc nghiệm và Tự luận',
      splitExamPartsCheck: 'Tách thành Trắc nghiệm và Tự luận',
      titleExamPaperDelete: 'Xóa đề kiểm tra',
      contentExamPaperDelete: 'Đề kiểm tra sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      titleQuestionDelete: 'Xóa câu hỏi',
      contentQuestionDelete: 'Câu hỏi sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      configureScore: 'Thiết lập điểm',
      autoAIGeneration: 'Tạo tự động bằng AI',
      descriptionAutoAIGeneration: 'Thiết kế bài kiểm tra hấp dẫn với tính năng tạo câu hỏi bằng AI',
      subDescriptionAutoAIGeneration: 'Thiết kế bài kiểm tra hấp dẫn với tính năng tạo câu hỏi bằng AI',
      chooseQuestionBank: 'Chọn từ ngân hàng câu hỏi',
      descriptionChooseQuestionBank: 'Tạo đề kiểm tra từ ngân hàng câu hỏi.',
      examPaperInfo: 'Thông tin đề kiểm tra',
      enterExamPaperInfo: 'Nhập thông tin đề kiểm tra',
      uploadedInClasses: 'Đã tải lên tại các lớp học',
      uploadDocument: 'Tải lên tài liệu',
      questionCountByLevel: 'Nhập số lượng câu hỏi theo từng cấp độ',
      remembering: 'Câu hỏi nhận biết',
      understanding: 'Câu hỏi thông hiểu',
      applying: 'Câu hỏi vận dụng',
      highOrderApplying: 'Câu hỏi vận dụng cao',
      setting: 'Thiết lập đề kiểm tra',
      score: 'Điểm',
      multipleChoiceSection: 'Trắc nghiệm',
      essaySection: 'Tự luận',
      enterAverageScore: 'Nhập điểm trung bình',
      configureScoreMultiple: 'Thiết lập điểm trắc nghiệm',
      configureScoreEssay: 'Thiết lập điểm tự luận',
      totalScoreMultiple: 'Tổng điểm trắc nghiệm',
      totalScoreEssay: 'Tổng điểm tự luận',
      totalScorePlaceholder: 'Nhập tổng điểm',
      averageScore: 'Điểm trung bình mỗi câu',
      numberQuestion: 'Số câu hỏi',
      titleConfigureScoreDelete: 'Hủy thiết lập điểm',
      contentConfigureScoreDelete: 'Hệ thống sẽ thực hiện xóa các thiết lập điểm trung bình đã được tạo trước đó. Bạn có chắc chắn muốn xóa không?',
      titleExamDelete: 'Xóa lịch kiểm tra',
      contentExamDelete: 'Lịch kiểm tra sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      formatQuestion1: 'Câu hỏi số',
      formatQuestion2: 'Câu hỏi',
      formatQuestion3: 'Câu',
      formatQuestion4: 'Q',
      question: 'Câu hỏi',
      questions: 'Câu hỏi',
      orderingItem: 'Câu sắp xếp',
      statusAssigned: 'Chưa thực hiện',
      statusInProgress: 'Đang thực hiện',
      statusExpired: ' Xem kết quả bài làm ',
      titleConfigureScore: 'Đề kiểm tra chưa có câu hỏi',
      contentConfigureScore: 'Bạn chưa thêm câu hỏi nào cho đề kiểm tra này. Vui lòng thêm câu hỏi trước khi thiết lập điểm.',
      noDataBank: 'Bắt đầu thêm câu hỏi để tạo bài kiểm tra',
      primarySchool: 'Tiểu học',
      lowerSecondarySchool: 'Trung học cơ sở',
      highSchool: 'Trung học phổ thông',
      advancedCustomization: 'Tùy chỉnh nâng cao',
      cancelAdvancedCustomization: 'Hủy tùy chỉnh nâng cao',
      examMatrixSetup: 'Thiết lập ma trận đề',
      setupByMatrix: 'Thiết lập theo ma trận',
      totalQuestions: 'Tổng số câu hỏi',
      emptyHint: 'Giao các bài kiểm tra để bắt đầu theo dõi kết quả làm bài của học sinh',
      emptyCreateHint: 'Bắt đầu với đề kiểm tra đầu tiên',
      selectCategoryHint: 'Chọn một danh mục để xem câu hỏi',
      emptyQuestionBankHint: 'Chưa có câu hỏi trong ngân hàng câu hỏi',
      viewAll: 'Xem tất cả',
      teacherCreated: 'Giáo viên tạo',
      selectFromClass: 'Hoặc chọn tài liệu từ lớp',
      examDetail: 'Chi tiết đề kiểm tra',
      examName: 'Tên đề kiểm tra',
      totalScore: 'Tổng điểm',
      questionDistribution: 'Phân bổ câu hỏi',
      multipleChoice: 'Trắc nghiệm',
      trueFalse: 'Đúng/Sai',
      fillInTheBlank: 'Điền khuyết',
      shortAnswer: 'Câu hỏi ngắn',
      openEnded: 'Tự luận',
      ordering: 'Sắp xếp',
      createdBy: 'Người tạo',
      createdDate: 'Ngày tạo',
      questionsDetail: 'Chi tiết câu hỏi',
      orderItem: 'Câu sắp xếp',
      statusDraft: 'Nháp',
      statusAssignedDetail: 'Đã giao',
      statusInProgressDetail: 'Đang thực hiện',
      statusCompleted: 'Hoàn thành',
      statusExpiredDetail: 'Hết hạn',
      configure: 'Cấu hình',
      addFirstQuestion: 'Thêm mới câu hỏi đầu tiên cho đề kiểm tra',
      addQuestion: 'Thêm câu hỏi',
      editQuestion: 'Sửa câu hỏi',
      objectives: 'Mục tiêu bài kiểm tra',
      noQuestions: 'Chưa có câu hỏi nào',
      clickAddQuestion: 'Nhấn "Tạo câu hỏi với AI" để thêm câu hỏi',
      complete: 'Hoàn thành',
      confirm: 'Đồng ý',
    },
    noSubject: 'Chưa có môn học nào',
    noSubjectDescription: 'Hiện tại chưa có môn học nào trong lớp học này. Vui lòng liên hệ giáo viên để được hỗ trợ.',
    welcomeTeacher: 'Xin chào thầy/cô!!',
    welcomeStudent: 'Chào {name}',
    welcomeDescriptionTeacher: 'Hãy tạo nên một tiết học thật hấp dẫn',
    welcomeDescriptionStudent: 'Cùng khám phá bài học mới nhé!',
    messagePlaceholderTeacher: 'Thầy/cô cần giúp gì hôm nay...',
    messagePlaceholderStudent: 'Bạn cần giúp gì hôm nay',
    // Dynamic headers for different tools
    headerTitles: {
      NORMAL_CHAT: 'AI đồng hành cùng thầy cô trong từng bước soạn kế hoạch giảng dạy',
      SLIDE: 'Cùng AI tạo nên những slide khiến học sinh say mê',
      IMAGE: 'Minh họa sinh động cho tiết học thêm hấp dẫn cùng AI',
      TEACHING_EXPERIENCE_INITIATIVE: 'Tiết kiệm thời gian viết sáng kiến với AI hỗ trợ',
      LESSON_PLAN: 'Cùng AI hỗ trợ soạn bài dạy theo chuẩn chương trình mới',
      TEACHING_PLAN: 'AI đồng hành cùng thầy cô trong từng bước soạn kế hoạch giảng dạy',
      WRITE: 'Viết dễ hơn, nhanh hơn, hiệu quả hơn cùng AI',
      MIND_MAP: 'Giúp học sinh dễ hiểu hơn với sơ đồ hóa kiến thức từ AI',
      CHAT_PDF: 'Hiểu nhanh nội dung tài liệu PDF qua hội thoại với AI',
      IMAGE_TO_TEXT: 'Trích xuất nội dung chữ từ ảnh chụp cùng AI nhận diện chữ viết',
      PDF_TO_TEXT: 'AI giúp bạn trích nội dung từ PDF để chỉnh sửa dễ dàng',
    },
    headerTitlesStudent: {
      SLIDE: 'AI giúp bạn biến nội dung thành slide đẹp và dễ hiểu hơn',
      IMAGE: 'Nhập ý tưởng và để AI tạo hình minh hoạ cực nhanh',
      MIND_MAP: 'Chuyển kiến thức thành sơ đồ trực quan để học tập hiệu quả',
    },
    normalChat: 'Chat bình thường',
    send: 'Gửi',
    startChat: 'Bắt đầu cuộc trò chuyện',
    startChatDescription: 'Hãy gửi tin nhắn đầu tiên để bắt đầu',
    chatHistory: 'Lịch sử trò chuyện',
    newChat: 'Đoạn chat mới',
    noChatHistory: 'Chưa có lịch sử trò chuyện',
    confirmDeleteChat: 'Bạn có chắc chắn muốn xóa đoạn chat này?',
    confirmDeleteConversation: 'Bạn có chắc chắn muốn xóa cuộc trò chuyện này?',
    loadingHistory: 'Đang tải lịch sử...',
    conversation: 'Cuộc trò chuyện',
    deleteConversation: 'Xóa cuộc trò chuyện',
    back: 'Quay lại',
    quickStart: 'Bắt đầu nhanh với',
    smartSuggestions: 'Gợi ý thông minh',
    loadingConversation: 'Đang tải cuộc trò chuyện...',
    errorLoadingConversation: 'Không thể tải cuộc trò chuyện',
    errorSendingMessage: 'Có lỗi xảy ra khi gửi tin nhắn',
    more: 'Thêm',
    // dictate: 'Ra lệnh',
    voiceMode: 'Chế độ giọng nói',
    createSlide: 'Tạo slide',
    createImage: 'Tạo ảnh',
    teachingExperienceInitiative: 'Viết sáng kiến kinh nghiệm',
    shortTeachingExperienceInitiative: 'Viết SKKN',
    lessonPlan: 'Soạn kế hoạch bài dạy',
    shortLessonPlan: 'Soạn KHBD',
    teachingPlan: 'Soạn kế hoạch giảng dạy',
    shortTeachingPlan: 'Soạn KHGD',
    teachingPlanForm: {
      title: 'Soạn kế hoạch bài dạy',
      grade: 'Khối lớp',
      gradePlaceholder: 'Chọn khối lớp',
      subject: 'Môn học',
      subjectPlaceholder: 'Chọn môn học',
      bookSeries: 'Bộ sách',
      bookSeriesPlaceholder: 'Chọn bộ sách',
      lesson: 'Bài học',
      lessonPlaceholder: 'Chọn bài học cần soạn',
      periods: 'Số tiết dạy',
      periodsPlaceholder: 'Chọn số tiết',
      studentLevel: 'Trình độ học sinh',
      studentLevelPlaceholder: 'Chọn trình độ học sinh',
      uploadTitle: 'Tải lên kế hoạch giảng dạy đã phê duyệt để soạn chính xác hơn',
      supportedFormats: 'Định dạng hỗ trợ:',
      maxFileSize: 'Kích thước tệp tối đa: 50MB',
      chooseFile: 'Chọn tệp',
      uploadedFiles: 'Tệp đã tải lên',
      startCreating: 'Bắt đầu soạn kế hoạch',
      creating: 'Đang tạo...',
      noFilesUploaded: 'Chưa có tệp nào được tải lên',
      fileUploaded: 'Đã tải lên {count} tệp',
      fileRemoved: 'Đã xóa tệp',
      unsupportedFormat: '{name}: Định dạng không hỗ trợ. Chỉ chấp nhận .pdf, .docx',
      fileTooLarge: '{name}: Kích thước vượt quá 50MB',
      creatingPlan: 'Đang tạo kế hoạch giảng dạy...',
      createSuccess: 'Đã tạo kế hoạch giảng dạy thành công',
      createError: 'Có lỗi xảy ra khi tạo kế hoạch',
      gradeOptions: {
        grade1: 'Lớp 1',
        grade2: 'Lớp 2',
        grade3: 'Lớp 3',
        grade4: 'Lớp 4',
        grade5: 'Lớp 5',
        grade6: 'Lớp 6',
        grade7: 'Lớp 7',
        grade8: 'Lớp 8',
        grade9: 'Lớp 9',
        grade10: 'Lớp 10',
        grade11: 'Lớp 11',
        grade12: 'Lớp 12',
      },
      subjectOptions: {
        math: 'Toán',
        literature: 'Ngữ văn',
        english: 'Tiếng Anh',
        physics: 'Vật lý',
        chemistry: 'Hóa học',
        biology: 'Sinh học',
        history: 'Lịch sử',
        geography: 'Địa lý',
        informatics: 'Tin học',
      },
      bookSeriesOptions: {
        kntt: 'Kết nối tri thức',
        cd: 'Cánh diều',
        ctst: 'Chân trời sáng tạo',
      },
      periodsOptions: {
        period1: '1 tiết',
        period2: '2 tiết',
        period3: '3 tiết',
        period4: '4 tiết',
        period5: '5 tiết',
      },
      studentLevelOptions: {
        excellent: 'Giỏi',
        good: 'Khá',
        average: 'Trung bình',
        weak: 'Yếu',
      },
      lessonContent: {
        title: 'Nội dung tiết học',
        periodInLesson: 'Tiết trong bài học',
        periodInCurriculum: 'Tiết theo chương trình',
        periodInCurriculumPlaceholder: 'Nhập số tiết',
        lessonStartFrom: 'Bài học bắt đầu từ',
        lessonEndAt: 'Bài học kết thúc tại',
        selectLesson: 'Chọn bài học',
        selectActivity: 'Lựa chọn hoạt động trong tiết học',
        warmUpSection: 'Phần khởi động',
        warmUp: 'Khởi động',
        reviewOld: 'Ôn bài cũ',
        practiceSection: 'Phần luyện tập/thực hành',
        practice: 'Luyện tập',
        apply: 'Vận dụng',
        none: 'Không thực hiện',
        conclusionSection: 'Phần kết thúc',
        consolidate: 'Củng cố bài',
        summary: 'HĐ tổng kết',
        selectTemplate: 'Lựa chọn cấu trúc tiến trình dạy học của kế hoạch',
        viewDetail: 'Xem chi tiết',
        startDrafting: 'Bắt đầu soạn bài',
        fillAllInfo: 'Vui lòng điền đầy đủ thông tin cho tất cả các tiết học',
        selectTemplateWarning: 'Vui lòng chọn cấu trúc tiến trình dạy học',
        loadLessonsError: 'Có lỗi xảy ra khi tải danh sách bài học',
        loadTemplatesError: 'Có lỗi xảy ra khi tải danh sách template',
      },
    },
    write: 'Viết lách',
    writeArticle: 'Viết bài',
    mindMap: 'Sơ đồ tư duy',
    shortMindMap: 'Sơ đồ',
    chatPdf: 'Hỏi đáp PDF',
    imageToWord: 'Chuyển hình ảnh sang văn bản',
    shortImageToText: 'Chuyển ảnh',
    pdfToWord: 'Chuyển PDF scan sang văn bản',
    shortPdfToText: 'Chuyển PDF',
    lessonAi: 'Bài học AI',
    prepareLessonTitle: 'Cùng chuẩn bị nội dung bài học cho học sinh nào!',
    lessonSupport: 'Hỗ trợ soạn bài',
    addTeacherMaterial: 'Thêm tài liệu của thầy/cô',
    createPractice: 'Soạn bài tập luyện',
    createFlashcard: 'Làm thẻ ôn tập nhanh',
    assignHomework: 'Giao bài tập cho học sinh',
    questionBank: 'Ngân hàng câu hỏi',
    createExamPaper: 'Ra đề kiểm tra',
    educationalAssistant: 'Trợ lý giáo dục',
    addCompanionAssistant: 'Thêm trợ lý đồng hành cùng thầy/cô',
    addAssistant: 'Thêm trợ lý',
    listAssistant: 'Danh sách trợ lý',
    editDisplay: 'Sửa hiển thị',
    customizeView: 'Tùy chọn hiển thị',
    apply: 'Áp dụng',
    supportTools: 'Công cụ hỗ trợ',
    toolSelected: 'Đã chọn',
    allTools: 'Tất cả công cụ',
    displayMode: 'Cách hiển thị',
    horizontalCard: 'Dạng thẻ ngang',
    verticalCard: 'Dạng thẻ dọc',
    iconOnly: 'Chỉ hiển thị icon',
    recentlyCreated: 'Đã tạo gần đây',
    filteredByTool: 'Được lọc theo công cụ',
    choose: 'Chọn',
    tools: 'Công cụ',
    messages: 'Tin nhắn ',
    suggestedMessages: 'Tin nhắn gợi ý',
    addSuggestedMessage: 'Thêm tin nhắn gợi ý',
    editSuggestedMessage: 'Sửa tin nhắn gợi ý',
    deleteSuggestedMessage: 'Xóa tin nhắn gợi ý',
    noSuggestedMessages: 'Chưa có tin nhắn gợi ý nào',
    enterSuggestedMessage: 'Nhập tin nhắn gợi ý',
    enterNewSuggestedMessage: 'Nhập tin nhắn gợi ý mới',
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    createAssistant: 'Thêm mới trợ lý giáo dục',
    enterCreationRequest: 'Nhập yêu cầu tạo trợ lý',
    enterCreationRequestPlaceholder: 'Ví dụ: Hãy tạo một trợ lý giáo dục hỗ trợ giảng dạy môn Toán (Hình học) cho học sinh lớp 8',
    enterCreationRequestPlaceholderStudent: 'Ví dụ: Hãy tạo một trợ lý học tập giúp học sinh lớp 8 ôn luyện và hiểu rõ môn Toán (Hình học).',
    createAgent: 'Tạo thủ công',
    viewAll: 'Xem tất cả',
    addSpace: 'Thêm vào không gian',
    addSubject: 'Thêm vào môn học',
    chooseAgent: 'Chọn trợ lý để tiếp tục',
    addAgentSuccess: 'Thêm trợ lý thành công',
    addAgentSuccessDescription: 'AI đã tạo thành công một trợ lý giáo dục cho thầy/cô. ',
    addAgentSuccessDescriptionBottom: 'Thầy/cô có thể thêm vào các không gian lớp học để học sinh có thể tương tác trực tiếp.',
    createEducationalAssistant: 'Tạo mới trợ lý giáo dục',
    assistantName: 'Tên trợ lý giáo dục',
    imageDetails: {
      title: 'Mô tả hình ảnh',
      content: 'Nội dung',
      imageInfo: 'Thông tin hình ảnh',
      type: 'Loại',
      resolution: 'Độ phân giải',
      aspectRatio: 'Tỷ lệ khung hình',
      model: 'Mô hình',
      createdTime: 'Thời gian tạo',
      sourceId: 'ID nguồn',
      totalImages: 'Số lượng ảnh',
      download: 'Tải xuống',
      share: 'Chia sẻ link',
      shareCommunity: 'Chia sẻ lên cộng đồng',
      shareCommunitySuccess: 'Chia sẻ thành công',
      shareCommunityFail: 'Chia sẻ thất bại',
      shareCommunityDescriptionSuccess: 'Ảnh của thầy/cô đã được gửi để kiểm duyệt. Khi được duyệt, ảnh sẽ hiển thị trong ',
      shareCommunityDescriptionSuccessStrong: 'Khám phá thư viện hình ảnh.',
      image_style: 'Phong cách',
      image_name: 'Tên hình ảnh',
      author: 'Tác giả',
      unapprove: 'Hủy duyệt',
      approve: 'Duyệt đăng tải',
      publish: 'Đăng tải',
      unpublish: 'Hủy đăng tải',
      update: 'Cập nhật',
      copyPrompt: 'Sử dụng mô tả',
      like: 'Lượt thích',
      generateTemplate: 'Tạo ảnh từ mẫu',
    },
    viewStudentList: 'Xem danh sách học sinh trong lớp',
    fetchAssignments: 'Lấy danh sách bài tập của môn học',
    createQuickQuiz: 'Tạo bài kiểm tra nhanh',
    showAllTeachingClasses: 'Hiển thị tất cả các lớp mà tôi đang dạy',
    teacherNoClassroom: 'Thầy/cô chưa tham gia lớp học nào',
    youNoClassroom: 'Bạn chưa tham gia lớp học nào',
    pleaseContactAdmin: 'Vui lòng liên hệ quản trị viên để được thêm vào lớp.',
    classListDescription: 'Danh sách các lớp học thầy/cô đã tạo <br/>Thầy/cô có thể chỉnh sửa thông tin lớp ngay tại đây.',
    numberMember: 'Số thành viên',
    chooseDataFile: 'Chọn tệp dữ liệu',
    reviewFinish: 'Kiểm tra và hoàn thành',
    uploadKnowledge: 'Tải lên kiến thức',
    fileUpload: 'Tải lên tệp',
    imageText: 'Hình ảnh văn bản',
    pdfScan: 'PDF scan văn bản',
    fileUploaded: 'Tệp đã tải lên',
    imageConversionSuccessful: 'Chuyển đổi hình ảnh thành công',
    pdfConversionSuccessful: 'Chuyển đổi tệp PDF thành công',
    knowledgeSuccessful: 'Kiến thức đã được thêm thành công',
    configureLink: 'Thiết lập liên kết chia sẻ',
    initializeLink: 'Khởi tạo liên kết',
    shareLinkTitle: 'Chia sẻ trợ lý',
    shareLinkDescription: 'Thiết lập thực hiện chia sẻ trợ lý cho phụ huynh học sinh',
    sharedLink: 'Liên kết chia sẻ',
    sharedLinkSubtitle: 'Thiết lập liên kết để người dùng khác truy cập trợ lý của bạn',
    expiresOn: 'Hết hạn ngày {date}',
    nameTask: 'Tên nhiệm vụ',
    descriptionTask: 'Mô tả nhiệm vụ',
    descriptionPlaceholderTask: 'Nhập mô tả ngắn gọn cho nhiệm vụ',
    configurationAssistant: 'Thiết lập trợ lý',
    chatInterface: 'Giao diện trò chuyện',
    chatInterfaceSubtitle: 'Điều chỉnh giao diện trò chuyện để tương tác với trợ lý dễ dàng và sinh động hơn',
    chatAppearanceTitle: 'Thiết lập giao diện',
    chatAppearanceSubtitle: 'Tùy chỉnh giao diện khi thực hiện trò chuyện với trợ lý',
    task: {
      titleDelete: 'Xóa nhiệm vụ',
      titleErrorDelete: 'Xóa không thành công',
      contentDelete: 'Nhiệm vụ sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
      contentErrorDelete: 'Trợ lý đang sử dụng tác vụ này đã được đăng tải lên cửa hàng. Vui lòng hủy đăng tải trợ lý trước khi thực hiện xóa nhiệm vụ.',
      contentDeleteLeft: 'Nhiệm vụ đang được gắn với',
      contentDeleteRight: 'Nếu tiếp tục, nhiệm vụ sẽ bị xóa khỏi tất cả các trợ lý đang sử dụng. Bạn có chắc chắn muốn xóa không?',
      createSuccess: 'Thêm mới nhiệm vụ thành công',
      createFailed: 'Thêm mới nhiệm vụ thất bại',
      nameAlreadyExists: 'Tên nhiệm vụ đã tồn tại',
      updateSuccess: 'Cập nhật nhiệm vụ thành công',
      updateFailed: 'Cập nhật nhiệm vụ thất bại',
      deleteSuccess: 'Xóa nhiệm vụ thành công',
      deleteFailed: 'Xóa nhiệm vụ thất bại',
    },
    imageLibraryTitle: 'Khám phá bộ sưu tập của NextSchool',
    imageLibrarySubTitle: 'Khám phá thư viện hình ảnh',
    deleteAssistantSuccess: 'Xóa trợ lý thành công',
    deleteAssistantFailed: 'Xóa trợ lý thất bại',
    updateAssistantSuccess: 'Cập nhật giao diện thành công',
    updateAssistantFailed: 'Cập nhật giao diện thất bại',
    moreTool: 'Xem thêm',
  },
  classroomTransaction: {
    uploadTypes: {
      document: 'Tài liệu',
      exercise: 'Bài tập',
      exam: 'Bài kiểm tra',
      flashcard: 'Thẻ ôn tập',
      practice: 'Bài luyện tập',
    },
  },
  school: {
    title: 'Theo dõi và quản lý hoạt động các trường học cùng Nextschool AI',
    create: 'Tạo trường học',
    search: 'Tìm kiếm trường học',
    edit: 'Chỉnh sửa trường học',
    titleDelete: 'Xóa trường học',
    desc: 'Theo dõi số lượng agent, người dùng, mức độ sử dụng và dữ liệu tri thức từ tất cả các trường trực thuộc.',
    applied: {
      title: 'Đơn vị đã ứng dụng AI',
      rank1: 'Trường THCS ABCN',
      rank2: 'Trường tiểu học Thành Công',
      rank3: 'Trường tiểu học Hạnh Phúc',
      rank4: 'Trường mầm non An Nhiên',
    },
    user: {
      title: 'Người dùng',
      infoTitle: 'Thông tin người dùng',
      infoDesc: 'Theo dõi số lượng người dùng, người dùng hoạt động, người dùng hoạt động tháng này, người dùng hoạt động tháng trước.',
      total: 'Tổng số',
      activeThisMonth: 'Hoạt động tháng này',
      usageRateTitle: 'Tỷ lệ sử dụng trợ lý AI',
      usageRateDesc: 'Theo dõi tỷ lệ sử dụng AI của người dùng',
      usageRateGrowth: 'Tỷ lệ sử dụng AI',
      usageRateGrowthDesc: 'Tỷ lệ sử dụng AI',
      totalUser: 'Tổng số người dùng',
      teacher: 'Giáo viên',
      student: 'Học sinh',
      other: 'Khác',

    },
    userGroupBar: {
      title: 'Tỷ lệ người dùng',
      teacher: 'Giáo viên',
      student: 'Học sinh',
      other: 'Khác',
      ratio: 'Tỷ lệ',
      ratioDesc: 'Tỷ lệ người dùng trợ lý AI theo nhóm',
    },
    stats: {
      growth: 'tăng',
      unitMonthAgo: 'so với tháng trước',
    },
    classStats: {
      classCount: 'Tổng số lớp học',
      contentCount: 'Số lượng nội dung học tập',
    },
    usageFrequency: {
      title: 'Tần suất sử dụng lại',
      frequencyDesc: 'Theo dõi tần suất sử dụng lại',
      number: 'Số người',
    },
    trendsChart: {
      title: 'Xu hướng ứng dụng AI',
      trendsDesc: 'Xu hướng ứng dụng AI',
      number: 'Số phiếu',
    },
    appliedList: {
      title: 'Đơn vị đã ứng dụng AI',
      rank1: 'Trường THCS ABCN',
      rank2: 'Trường tiểu học Thành Công',
      rank3: 'Trường tiểu học Hạnh Phúc',
      rank4: 'Trường mầm non An Nhiên',
    },
    activeRate: {
      title: 'Tỷ lệ hoạt động',
      active: 'Hoạt động',
      inactive: 'Không hoạt động',
      rateDesc: 'Tỷ lệ trợ lý AI hoạt động',
      activeLabel: 'Tỷ lệ hoạt động',
    },
    class: {
      title: 'Lớp học',
      performanceTitle: 'Hiệu suất học tập',
      performanceDesc: 'Theo dõi hiệu suất học tập của lớp học',
      lessonCount: 'Số lượng bài học',
      assignmentCount: 'Số lượng bài tập',
      reviewTitle: 'Đánh giá',
      usageRateTitle: 'Tỷ lệ sử dụng trợ lý AI',
      reviewSchool1: 'Trường THCS ABCN',
      reviewCount1: '100',
      reviewSchool2: 'Trường tiểu học Thành Công',
      reviewCount2: '100',
      reviewSchool3: 'Trường tiểu học Hạnh Phúc',
      reviewCount3: '100',
      usageRateDesc: 'Theo dõi tỷ lệ sử dụng AI của lớp học',
      reviewDesc: 'Theo dõi đánh giá của lớp học',
    },
    interaction: {
      interactionTitle: 'Tương tác với trợ lý AI',
      interactionDesc: 'Theo dõi tương tác với trợ lý AI',
      usageTimeTitle: 'Thời gian sử dụng',
      usageTimeDesc: 'Theo dõi thời gian sử dụng',
      detailAnalysisTitle: 'Phân tích tương tác chi tiết',
      detailAnalysisDesc: 'Theo dõi tương tác chi tiết',
      usageRateTitle: 'Tỷ lệ sử dụng trợ lý AI',
      usageRateDesc: 'Theo dõi tỷ lệ sử dụng AI',
      interactionDurationTitle: 'Thời lượng tương tác',
      interactionDurationDesc: 'Theo dõi thời lượng tương tác',
      student: 'Học sinh',
      teacher: 'Giáo viên',
      memoryCard: 'Thẻ ghi nhớ',
      exercise: 'Bài luyện tập',
      knowledge: 'Bộ kiến thức',
      agent: 'Trợ lý AI',
      school: 'Trường học',
    },
    userReturnRateChart: {
      title: 'Tỷ lệ quay lại của người dùng',
      desc: 'Theo dõi tỷ lệ quay lại của người dùng',
    },
    review: {
      title: 'Đánh giá',
    },
    overview: {
      title: 'Tổng quan',
    },
    userTab: {
      title: 'Người dùng',
    },
    classTab: {
      title: 'Lớp học',
    },
    interactionTab: {
      title: 'Tương tác',
    },
  },

  agentPdf: {
    title: 'Trò chuyện với PDF',
    description: 'Sử dụng AI của Nextschool để giúp bạn đọc hiểu tốt hơn',
    chat: 'Trò chuyện',
    explain: 'Giải thích',
    insight: 'Hiểu biết',
    translate: 'Dịch',
    translateTo: 'Dịch văn bản này sang',
    selectLanguage: 'Chọn ngôn ngữ đầu ra',
    copy: 'Sao chép',
    rendering: 'Đang render PDF...',
    pages: 'trang',
    noFile: 'Không thể tải tệp',
    recentFiles: 'Tệp gần đây',
    noRecentFiles: 'Không có tệp gần đây',
    page: 'Trang',
    noFiles: 'Chưa có File',
    noRecentFilesDescription: 'Tải lên tệp PDF để bắt đầu',
    viewDetail: 'Xem chi tiết',
    language: {
      vi: 'Tiếng Việt',
      en: 'Tiếng Anh',
      lo: 'Tiếng Lào',
      kh: 'Tiếng Campuchia',
      cn: 'Tiếng Trung Quốc',
      mm: 'Tiếng Myanmar',
    },
    actions: {
      explain: 'Giải thích nội dung này',
      insight: 'Phân tích và tóm tắt nội dung này',
      translate: 'Dịch nội dung này',
      help: 'Hãy giúp tôi hiểu nội dung này',
    },
    tools: {
      title: 'Công cụ PDF',
      description: 'Khám phá các công cụ mạnh mẽ để nâng cao trải nghiệm đọc và phân tích PDF của bạn',
      summary: {
        title: 'Tóm tắt tài liệu',
        description: 'Nhận diện thông tin chính một cách thông minh, tạo ngắn gọn tóm tắt nhanh chóng để giúp bạn nắm bắt bản chất của tài liệu.',
      },
      qa: {
        title: 'Hỏi và Đáp Thông Minh',
        description: 'Trả lời các câu hỏi dựa trên nội dung của tài liệu, cung cấp câu trả lời chuyên nghiệp để nâng cao hiểu biết về tài liệu.',
      },
      comparison: {
        title: 'So Sánh Nội Dung',
        description: 'Hỗ trợ nội dung tham khảo để dễ dàng chuyển hướng đến văn bản gốc, tạo điều kiện cho việc so sánh chính xác và nâng cao hiệu suất đọc.',
      },
      translation: {
        title: 'Dịch Tài Liệu',
        description: 'Dịch một tệp PDF và so sánh nó cạnh nhau với tệp gốc bên trái và tệp dịch bên phải.',
      },
    },
    aiAssistant: {
      title: 'Trò chuyện với PDF',
      greeting: 'Xin chào! Tôi có thể giúp bạn sáng tạo nội dung',
      description: 'Hãy chia sẻ điều bạn muốn nói',
      placeholder: 'Nhập câu hỏi của bạn...',
    },
    toolbar: {
      askAI: 'Hỏi AI',
      explain: 'Giải thích',
      analyze: 'Phân tích',
      translate: 'Dịch',
      copy: 'Sao chép',
    },
  },
  aiKids: {
    clouds: {

      aiBasic: 'AI cơ bản',
      aiTutor: 'Gia Sư AI',
      findSecret: 'Đi tìm bí mật cỏ 4 lá',
      aiFriend: 'AI và bạn',
      aiWorld: 'Thế giới AI',
    },
    level: 'Chọn cấp độ',
    back: 'Quay lại',
    chooseCharacter: 'Chọn nhân vật',
    backToForm: 'Quay lại',
    backToCharacter: 'Quay lại',
    backToLevel: 'Quay lại',
    backToCloud: 'Quay lại',
    aiSecret: 'Mật mã AI',
    enterInfo: 'Nhập thông tin của bạn',
    fullName: 'Họ và tên',
    birthDate: 'Ngày sinh',
    teacher: 'Giáo viên',
    className: 'Lớp học',
    submit: 'Lưu lại',
    backToMain: 'Quay lại',
    backToMainDesc: 'Quay lại trang chủ',
    findSecret: 'Bí mật cỏ 4 lá',

  },
  elearning: {
    description: 'Tuyển chọn các khóa học hiệu quả nhất trong thời đại AI',
    aiApplication: 'AI Ứng dụng',
    aiKids: 'AI cho trẻ em',
    stemRobotic: 'STEM & Robotic',
    stemKids: 'Tài chính cho trẻ em',
    exploreCourses: 'Khám phá AI ELearning',
    universityName: 'UNI ACADEMY',
    searchPlaceholder: 'Tìm kiếm',
    categoryAiApplication: 'AI ứng dụng',
    categoryAiKids: 'AI cho trẻ',
    categoryStemRobotic: 'STEM & Robotic',
    categoryFinanceKids: 'Tài chính cho trẻ',
  },
  aiApp: {
    universal: 'Phổ cập',
    specialized: 'Chuyên ngành',
    teacher: 'Giáo viên',
    parent: 'Phụ huynh',
    student: 'Học sinh',
    lecturer: 'Giảng viên',
    aiBasic: 'AI Nền tảng',
    allCourses: 'Toàn bộ khóa học',
    lessons: 'bài học',
    minutes: 'phút',
    aiApplication: 'AI ứng dụng',
    aiInPractice: 'AI thực chiến',
    exploreNewCourse: 'Khám phá khóa học mới',
    exploreNowPlus: '+ Khám phá ngay',
    noFreeCourses: 'Không tìm thấy khóa học miễn phí nào.',
    noCourses: 'Không tìm thấy khóa học nào.',
    viewDetail: 'Xem chi tiết',
    exploreCourse: 'Khám phá khóa học',
    exploreNow: 'Khám phá ngay',
    at: 'học tại',
    price: 'Giá',
  },

  ocr: {
    title: 'Tài liệu đã tạo',
    extract: 'Trích xuất',
    extractResult: 'Kết quả trích xuất',
    preparingContent: 'Đang chuẩn bị nội dung...',
    uploadTitle: 'Tải đã tệp lên',
    downloadOriginal: 'Tải file gốc',
    aiWriter: 'Trình viết AI',
    titleDelete: 'Xóa tài liệu',
    contentDelete: 'Tài liệu sẽ bị xóa vĩnh viễn và không thể hoàn tác. Bạn có chắc chắn muốn xóa không?',
    imageToWord: {
      title: 'Hình ảnh sang văn bản',
      description: 'Chuyển đổi ảnh, bản quét hoặc ảnh chụp màn hình thành văn bản có thể chỉnh sửa.',
    },
    pdfToWord: {
      title: 'PDF sang văn bản',
      description: 'Chuyển đổi tệp PDF sang tài liệu DOC và DOCX.',
    },
    exportSuccessful: 'Trích xuất thành công',
    exportFailed: 'Trích xuất thất bại',
  },
  educationalResource: {
    free: 'Miễn phí',
    preview: 'Xem trước',
    addToClassroom: 'Thêm vào lớp học',
    usage: 'sử dụng',
    description: 'Mô tả',
    resourceInfo: 'Thông tin tài liệu',
    documentType: 'Loại tài liệu',
    subject: 'Môn học',
    gradeLevel: 'Khối lớp',
    author: 'Tác giả',
    workExperience: 'Kinh nghiệm làm việc',
    awards: 'Giải thưởng',
    certificates: 'Chứng chỉ & Bằng cấp',
    coAuthors: 'Đồng tác giả',
    viewDocument: 'Xem tài liệu',
    reviews: 'Đánh giá',
    writeReview: 'Viết đánh giá',
    filterByRating: 'Lọc theo đánh giá:',
    reviewsCount: 'đánh giá',
    developing: 'Tính năng đang phát triển',
    download: 'Tải xuống',
  },
  modals: {
    insufficientCredit: {
      title: 'Oops! Credit đã cạn',
      subtitle: 'Bạn cần bổ sung credit để tiếp tục dùng các tính năng',
      features: {
        createExam: 'Tạo đề thi & slide và bài tập',
        aiAssistant: 'Trợ lý thông minh GPT, Claude, DeepSeek',
        analyzeContent: 'Phân tích, gợi ý & viết nội dung',
        generateImage: 'Tạo hình ảnh bằng AI sáng tạo, trực quan',
        mindMap: 'Vẽ sơ đồ tư duy thông minh',
        learningTools: 'Công cụ hỗ trợ học tập không giới hạn',
      },
      button: 'Nâng cấp gói',
    },
    upgradeToPro: {
      title: 'Nâng cấp để mở khóa đầy đủ tính năng AI',
      subtitle: 'Trải nghiệm học tập mượt mà, không giới hạn với các gói nâng cao',
      features: {
        abundantCredits: 'Credit dồi dào mỗi tháng – đủ để tạo đề thi, bài tập và nội dung không giới hạn',
        aiModels: 'Truy cập các mô hình AI mạnh mẽ: GPT-4.1, Claude 3.5, DeepSeek, Gemini 2.5...',
        imageGeneration: 'Tạo hình ảnh bằng AI sáng tạo, trực quan',
        learningTools: 'Công cụ hỗ trợ học tập không giới hạn',
      },
      button: 'Nâng cấp ngay',
    },
    sessionExpired: {
      title: 'Phiên đăng nhập đã hết hạn',
      subtitle: 'Vui lòng đăng nhập lại để tiếp tục sử dụng',
      button: 'Đăng nhập lại',
      badge: 'Phiên làm việc',
      securityTitle: 'Bảo mật tài khoản',
      securityDescription: 'Để đảm bảo an toàn, hệ thống đã tự động đăng xuất sau thời gian không hoạt động.',
      helpText: 'Bạn sẽ được chuyển về trang đăng nhập',
    },
  },
  creditDisplay: {
    free: 'Miễn phí',
    basic: 'Cơ bản',
    advanced: 'Nâng cao',
    basicDescription: 'GPT 4-mini & 3, Claude...',
    advancedDescription: 'Gemini 2.5 Pro, Llama 3.1...',
    upgrade: 'Nâng cấp',
  },
  whiteboard: {
    title: 'Bảng vẽ',
    saveSuccess: 'Lưu bảng vẽ thành công',
    exportInfo: 'Tính năng xuất đang được phát triển',
    untitled: 'Bảng vẽ chưa đặt tên',
    description: 'Tạo và chia sẻ ý tưởng của bạn một cách trực quan',
    toolbar: {
      shapeProperties: 'Thuộc tính hình dạng',
      font: 'Phông chữ',
      size: 'Kích thước',
      align: 'Căn chỉnh',
      color: 'Màu sắc',
      dashStyle: 'Kiểu đường nét',
      fillStyle: 'Kiểu tô màu',
      arrowheadStart: 'Đầu mũi tên bắt đầu',
      arrowheadEnd: 'Đầu mũi tên kết thúc',
      arrowKind: 'Loại mũi tên',
      start: 'Bắt đầu',
      end: 'Kết thúc',
      // Size options
      small: 'Nhỏ',
      medium: 'Trung bình',
      large: 'Lớn',
      // Color options
      black: 'Đen',
      grey: 'Xám',
      lightViolet: 'Tím nhạt',
      violet: 'Tím',
      blue: 'Xanh dương',
      lightBlue: 'Xanh dương nhạt',
      green: 'Xanh lá',
      lightGreen: 'Xanh lá nhạt',
      yellow: 'Vàng',
      orange: 'Cam',
      red: 'Đỏ',
      lightRed: 'Đỏ nhạt',
      // Dash style options
      solid: 'Liền nét',
      dashed: 'Nét đứt',
      dotted: 'Nét chấm',
      // Fill style options
      none: 'Không',
      noFill: 'Không tô màu',
      pattern: 'Họa tiết',
      // Font style options
      draw: 'Vẽ tay',
      sans: 'Sans',
      serif: 'Serif',
      mono: 'Mono',
      // Alignment options
      left: 'Trái',
      center: 'Giữa',
      right: 'Phải',
      top: 'Trên',
      middle: 'Giữa',
      bottom: 'Dưới',
      // Arrow options
      arc: 'Cung',
      elbow: 'Góc',
      arrow: 'Mũi tên',
      triangle: 'Tam giác',
      square: 'Vuông',
      dot: 'Chấm',
      diamond: 'Kim cương',
      inverted: 'Ngược',
      bar: 'Thanh',
    },
  },
  creditBonus: {
    table: {
      workspace: 'Workspace',
      name: 'Tên gói bonus',
      level: 'Level',
      baseCredit: 'Credit cơ bản',
      advanceCredit: 'Credit nâng cao',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      status: 'Trạng thái',
    },

    status: {
      active: 'Đang hoạt động',
      pending: 'Đang chờ',
      ended: 'Đã kết thúc',
    },

    filter: {
      title: 'Bộ lọc',
      workspace: 'Workspace',
      level: 'Level',
      status: 'Trạng thái',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      apply: 'Áp dụng',
    },

    action: {
      addPackage: 'Thêm gói',
    },

    confirm: {
      deleteTitle: 'Xóa gói',
      deleteContent: 'Xác nhận xóa gói. Bạn có chắc chắn?',
    },

    error: {
      deleteActive: 'Không được phép xóa gói đang hoạt động',
      deleteEnded: 'Không được phép xóa gói đã kết thúc',
      deleteFailed: 'Xóa gói không thành công',
    },

    form: {
      title: {
        create: 'Thêm gói',
        edit: 'Cập nhật gói',
      },
      label: {
        level: 'Level',
        name: 'Tên gói',
        baseCredit: 'Credit cơ bản',
        advanceCredit: 'Credit nâng cao',
        workspace: 'Workspace',
        startDate: 'Ngày bắt đầu',
        endDate: 'Ngày kết thúc',
        startEndDateLevel2: '(gói Level 2 không được trùng giai đoạn)',
      },
      placeholder: {
        selectLevel: 'Chọn level',
        selectWorkspace: 'Chọn workspace',
        inputName: 'Nhập tên gói',
        selectStatus: 'Chọn trạng thái',
        startDate: 'Chọn ngày bắt đầu',
        endDate: 'Chọn ngày kết thúc',
      },
    },

    message: {
      createSuccess: 'Thêm mới gói bonus thành công',
      createFail: 'Thêm mới gói bonus thất bại',
      editSuccess: 'Cập nhật gói bonus thành công',
      editFail: 'Cập nhật gói bonus thất bại',
      deleteSuccess: 'Xóa gói bonus thành công',
      deleteFail: 'Xóa gói bonus thất bại',
    },
    validation: {
      endDateAfterStartDate: 'Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu',
      endDateAfterCurrentDate: 'Ngày kết thúc phải lớn hơn bằng ngày hiện tại',
      startDateBeforeEndDate: 'Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc',
      startDateAfterCurrentDate: 'Ngày bắt đầu phải lớn hơn bằng ngày hiện tại',
    },

  },
  planAndStorage: {
    title: 'Gói và lưu trữ',
    free: 'Miễn phí',
    historyTransaction: 'Lịch sử giao dịch',
    upgrade: 'Nâng cấp',
    month: 'tháng',
    storage: 'Bộ nhớ',
    uploadedDocs: 'Kiến thức và tài liệu đã tải lên',
    empty: 'Trống',
    documents: 'Tài liệu bài học',
    images: 'Hình ảnh',
    assistant: 'Kiến thức trợ lý',
  },

  lessonPlanGenerator: {
    page: {
      title: 'Kế hoạch bài dạy',
    },
    assistant: {
      title: 'Trợ lý soạn kế hoạch bài dạy',
      placeholder: 'Nhập yêu cầu thầy cô muốn tạo',
      greeting: 'Xin chào! Tôi có thể giúp bạn soạn kế hoạch bài dạy.',
      description: 'Hãy cho tôi biết bạn muốn tạo gì trong kế hoạch bài dạy.',
    },
    creatingPlan: {
      step1: 'Đang phân tích yêu cầu và thông tin đầu vào...',
      step2: 'Đang xác định số tiết học và cấu trúc bài dạy...',
      step3: 'Đang xây dựng cây kế hoạch với các nhiệm vụ chính...',
      step4: 'Đang tạo cấu trúc chi tiết cho từng tiết học...',
      step5: 'Đang hoàn thiện kế hoạch bài dạy...',
      streamingDone: 'Đã hoàn thành tạo kế hoạch bài dạy. Thầy cô có thể tiếp tục soạn các phần tiếp theo tại quy trình bên dưới.',
      banner: 'Đang tạo kế hoạch chi tiết',
      editorLoading: 'Đang tạo kế hoạch bài dạy...',
      pageLoading: 'Đang tải kế hoạch bài dạy...',
    },
    tasks: {
      regenerate: 'Tạo lại',
      stop: 'Dừng',
      continue: 'Tiếp tục soạn',
      pending: 'Đang chờ',
      workflowTitle: 'Quy trình tạo',
    },
    messages: {
      planNotFound: 'Không tìm thấy dữ liệu kế hoạch bài dạy',
      downloadNotReady: 'Chức năng xuất file đang được phát triển',
      infoNotReady: 'Hiển thị thông tin chi tiết',
      useAgentPanel: 'Dùng panel bên phải để tạo hoặc phân tích nội dung đã chọn.',
      chatReply: 'Tôi đã nhận được tin nhắn của bạn. Để tạo nội dung, vui lòng sử dụng nút "Tiếp tục soạn" bên dưới.',
      mcpWriting: 'Đang thực hiện: {name}',
      demoContent: 'Thu thập nội dung chi tiết liên quan',
      researchContent: 'Đã thu thập thông tin và truy xuất các tài liệu liên quan thành công. Tiếp theo tôi sẽ tạo kế hoạch bài dạy.',
    },
    mcp: {
      searchTitle: 'Tìm kiếm',
      writeTitle: 'Viết',
    },
  },
  // Add to vi-VN.ts
  payment: {
    title: 'Thanh toán',
    plan: {
      basic: 'Cơ bản',
      advanced: 'Nâng cao',
    },
    cycle: {
      monthly: 'Hàng tháng',
      yearly: 'Hàng năm',
    },
    discount: 'Giảm giá',
    discountCode: 'Mã giảm giá',
    enterDiscount: 'Nhập mã giảm giá...',
    apply: 'Áp dụng',
    cancel: 'Hủy',
    chooseMethod: 'Chọn phương thức thanh toán',
    method: {
      bank: 'Chuyển khoản ngân hàng',
      card: 'Thẻ tín dụng/ghi nợ',
      wallet: 'Ví điện tử',
    },
    agreePrefix: 'Tôi đồng ý với',
    terms: 'điều khoản và điều kiện',
    agreeSuffix: 'của dịch vụ',
    pay: 'Thanh toán',
    backHome: 'Về trang chủ',
    success: {
      title: 'Thanh toán thành công!',
      subtitle: 'Cảm ơn bạn đã nâng cấp tài khoản. Dưới đây là thông tin giao dịch của bạn:',
      txId: 'Mã giao dịch',
      amount: 'Số tiền',
      method: 'Phương thức',
      time: 'Thời gian',
      account: 'Tài khoản',
      basicCredit: 'Credit cơ bản',
      advancedCredit: 'Credit nâng cao',
    },
    failure: {
      title: 'Thanh toán không thành công',
      reason: 'Lý do',
      defaultReason: 'Giao dịch bị từ chối',
      retry: 'Thử lại',
    },
  },
}
